import { jsx as re, jsxs as we } from "react/jsx-runtime";
import * as _ from "react";
import Ce, { forwardRef as qt, createElement as Me, isValidElement as Qt, cloneElement as Ks, Children as Zn, Fragment as Bn, createContext as Un, useContext as Ws, useCallback as Vr, useState as Js, useRef as Wr, useEffect as Et, useMemo as Fr, useId as Xs } from "react";
function qn(r, e) {
  for (var t = 0; t < e.length; t++) {
    const s = e[t];
    if (typeof s != "string" && !Array.isArray(s)) {
      for (const n in s)
        if (n !== "default" && !(n in r)) {
          const i = Object.getOwnPropertyDescriptor(s, n);
          i && Object.defineProperty(r, n, i.get ? i : {
            enumerable: !0,
            get: () => s[n]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(r, Symbol.toStringTag, { value: "Module" }));
}
var St = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Jr(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var Gs = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(r) {
  (function() {
    var e = {}.hasOwnProperty;
    function t() {
      for (var s = [], n = 0; n < arguments.length; n++) {
        var i = arguments[n];
        if (i) {
          var a = typeof i;
          if (a === "string" || a === "number")
            s.push(i);
          else if (Array.isArray(i)) {
            if (i.length) {
              var o = t.apply(null, i);
              o && s.push(o);
            }
          } else if (a === "object") {
            if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]")) {
              s.push(i.toString());
              continue;
            }
            for (var l in i)
              e.call(i, l) && i[l] && s.push(l);
          }
        }
      }
      return s.join(" ");
    }
    r.exports ? (t.default = t, r.exports = t) : window.classNames = t;
  })();
})(Gs);
var Hn = Gs.exports;
const de = /* @__PURE__ */ Jr(Hn), zn = "_icon_c4v1u_1", Kn = "_svg_c4v1u_10", Wn = "_colored_c4v1u_13", Jn = "_rotate90_c4v1u_18", Xn = "_rotate180_c4v1u_22", Gn = "_rotate270_c4v1u_26", Sr = {
  icon: zn,
  svg: Kn,
  colored: Wn,
  rotate90: Jn,
  rotate180: Xn,
  rotate270: Gn
}, Yn = (r) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.94871 8.68377C9.8126 8.27543 9.43046 8 9.00003 8C8.5696 8 8.18746 8.27543 8.05134 8.68377L6.05134 14.6838C5.8767 15.2077 6.15986 15.774 6.6838 15.9487C7.20774 16.1233 7.77406 15.8402 7.94871 15.3162L8.05412 15H9.94593L10.0513 15.3162C10.226 15.8402 10.7923 16.1233 11.3163 15.9487C11.8402 15.774 12.1234 15.2077 11.9487 14.6838L9.94871 8.68377ZM9.00003 12.1623L9.27927 13H8.72079L9.00003 12.1623Z" }), /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 8C13.4477 8 13 8.44772 13 9V15C13 15.5523 13.4477 16 14 16C14.5523 16 15 15.5523 15 15V14L16.2 15.6C16.5314 16.0418 17.1582 16.1314 17.6 15.8C18.0418 15.4686 18.1314 14.8418 17.8 14.4L16.5701 12.7601C17.4154 12.3591 18 11.4978 18 10.5C18 9.11929 16.8807 8 15.5 8H14ZM15 10V11H15.5C15.7761 11 16 10.7761 16 10.5C16 10.2239 15.7761 10 15.5 10H15Z" }), /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 8C2 4.68629 4.68629 2 8 2H16C19.3137 2 22 4.68629 22 8V16C22 19.3137 19.3137 22 16 22H8C4.68629 22 2 19.3137 2 16V8ZM8 4H16C18.2091 4 20 5.79086 20 8V16C20 18.2091 18.2091 20 16 20H8C5.79086 20 4 18.2091 4 16V8C4 5.79086 5.79086 4 8 4Z" })), Qn = (r) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ _.createElement("path", { d: "M18.6768 6.59968C19.0674 6.20916 19.0674 5.576 18.6768 5.18547C18.2863 4.79495 17.6531 4.79495 17.2626 5.18547L11.9697 10.4784L6.67683 5.18547C6.28631 4.79495 5.65314 4.79495 5.26262 5.18547C4.8721 5.576 4.8721 6.20916 5.26262 6.59968L10.5555 11.8926L5.26262 17.1855C4.8721 17.576 4.8721 18.2092 5.26262 18.5997C5.65314 18.9902 6.28631 18.9902 6.67683 18.5997L11.9697 13.3068L17.2626 18.5997C17.6531 18.9902 18.2863 18.9902 18.6768 18.5997C19.0674 18.2092 19.0674 17.576 18.6768 17.1855L13.3839 11.8926L18.6768 6.59968Z" })), ei = (r) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ _.createElement("path", { d: "M12 8C11.4477 8 11 7.55237 11 7.00008C11 6.4478 11.4477 6 12 6L17 6.00008C17.5523 6.00008 18 6.4478 18 7.00008V12C18 12.5523 17.5523 13 17 13C16.4477 13 16 12.5523 16 12V8.00008L12 8Z" }), /* @__PURE__ */ _.createElement("path", { d: "M8 12C8 11.4477 7.55229 11 7 11C6.44772 11 6 11.4477 6 12L6 17.0001C6 17.5524 6.44772 18.0001 7 18.0001L12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16L8 16.0001V12Z" })), ti = (r) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8ZM10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z" }), /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 0C11.2044 0 10.4413 0.316071 9.87868 0.87868C9.31607 1.44129 9 2.20435 9 3V3.1675C8.99921 3.29374 8.96167 3.41704 8.89195 3.52232C8.84498 3.59323 8.78479 3.6539 8.71507 3.70122C8.64693 3.71549 8.58027 3.73687 8.51624 3.76514C8.39742 3.81758 8.26561 3.83322 8.13782 3.81005C8.01142 3.78713 7.89468 3.72728 7.80231 3.6381L7.7475 3.58329C7.46888 3.30436 7.13802 3.08308 6.77382 2.93211C6.40963 2.78113 6.01925 2.70343 5.625 2.70343C5.23075 2.70343 4.84037 2.78113 4.47618 2.93211C4.11216 3.08301 3.78143 3.30415 3.50289 3.58289C3.22415 3.86143 3.00301 4.19216 2.85211 4.55618C2.70113 4.92037 2.62343 5.31075 2.62343 5.705C2.62343 6.09925 2.70113 6.48963 2.85211 6.85382C3.00308 7.21802 3.22436 7.54888 3.50329 7.8275L3.5581 7.88231C3.64728 7.97468 3.70713 8.09142 3.73005 8.21782C3.75322 8.34561 3.73758 8.47742 3.68514 8.59624C3.67663 8.61551 3.66874 8.63505 3.66146 8.65482C3.61644 8.77723 3.53564 8.88326 3.42955 8.95914C3.32591 9.03327 3.20283 9.07526 3.07564 9.08H3C2.20435 9.08 1.44129 9.39607 0.87868 9.95868C0.316071 10.5213 0 11.2844 0 12.08C0 12.8756 0.316071 13.6387 0.87868 14.2013C1.44129 14.7639 2.20435 15.08 3 15.08H3.1675C3.29374 15.0808 3.41704 15.1183 3.52232 15.1881C3.62801 15.258 3.71087 15.3574 3.76081 15.474L3.76514 15.4838C3.81758 15.6026 3.83322 15.7344 3.81005 15.8622C3.78713 15.9886 3.72728 16.1053 3.63811 16.1977L3.58329 16.2525C3.30436 16.5311 3.08308 16.862 2.93211 17.2262C2.78113 17.5904 2.70343 17.9808 2.70343 18.375C2.70343 18.7692 2.78113 19.1596 2.93211 19.5238C3.08308 19.888 3.30436 20.2189 3.58329 20.4975C3.86174 20.7761 4.19233 20.9971 4.55618 21.1479C4.92037 21.2989 5.31075 21.3766 5.705 21.3766C6.09925 21.3766 6.48963 21.2989 6.85382 21.1479C7.21784 20.997 7.54896 20.7755 7.8275 20.4967L7.8823 20.4419C7.97467 20.3527 8.09142 20.2929 8.21782 20.27C8.34561 20.2468 8.47742 20.2624 8.59624 20.3149C8.61551 20.3234 8.63505 20.3313 8.65482 20.3385C8.77723 20.3836 8.88326 20.4644 8.95914 20.5704C9.03327 20.6741 9.07526 20.7972 9.08 20.9244V21C9.08 21.7957 9.39607 22.5587 9.95868 23.1213C10.5213 23.6839 11.2843 24 12.08 24C12.8757 24 13.6387 23.6839 14.2013 23.1213C14.7639 22.5587 15.08 21.7957 15.08 21V20.8325C15.0808 20.7063 15.1183 20.583 15.1881 20.4777C15.258 20.372 15.3574 20.2891 15.474 20.2392L15.4838 20.2349C15.6026 20.1824 15.7344 20.1668 15.8622 20.19C15.9886 20.2129 16.1053 20.2727 16.1977 20.3619L16.2529 20.4171C16.5314 20.6959 16.8622 20.917 17.2262 21.0679C17.5904 21.2189 17.9808 21.2966 18.375 21.2966C18.7692 21.2966 19.1596 21.2189 19.5238 21.0679C19.8878 20.917 20.2186 20.6959 20.4971 20.4171C20.7759 20.1386 20.997 19.8078 21.1479 19.4438C21.2989 19.0796 21.3766 18.6892 21.3766 18.295C21.3766 17.9008 21.2989 17.5104 21.1479 17.1462C20.997 16.7822 20.7755 16.451 20.4967 16.1725L20.4419 16.1177C20.3527 16.0253 20.2929 15.9086 20.27 15.7822C20.2468 15.6544 20.2625 15.5226 20.3149 15.4038L20.3191 15.3939C20.3691 15.2774 20.452 15.178 20.5577 15.1081C20.663 15.0383 20.7863 15.0008 20.9125 15H21C21.7957 15 22.5587 14.6839 23.1213 14.1213C23.6839 13.5587 24 12.7957 24 12C24 11.2043 23.6839 10.4413 23.1213 9.87868C22.5587 9.31607 21.7957 9 21 9H20.8325C20.7063 8.99921 20.583 8.96167 20.4777 8.89195C20.4068 8.84498 20.3461 8.78479 20.2988 8.71507C20.2845 8.64692 20.2631 8.58027 20.2349 8.51624C20.1824 8.39742 20.1668 8.26561 20.19 8.13782C20.2129 8.01142 20.2727 7.89468 20.3619 7.80231L20.4171 7.7471C20.6959 7.46857 20.917 7.13784 21.0679 6.77382C21.2189 6.40963 21.2966 6.01925 21.2966 5.625C21.2966 5.23075 21.2189 4.84037 21.0679 4.47618C20.9171 4.11233 20.6961 3.78174 20.4175 3.50329C20.1389 3.22436 19.808 3.00308 19.4438 2.85211C19.0796 2.70113 18.6892 2.62343 18.295 2.62343C17.9008 2.62343 17.5104 2.70113 17.1462 2.85211C16.782 3.00308 16.4511 3.22436 16.1725 3.50329L16.1177 3.55811C16.0253 3.64728 15.9086 3.70713 15.7822 3.73005C15.6544 3.75322 15.5226 3.73752 15.4038 3.68508L15.3939 3.68086C15.2774 3.63092 15.178 3.54801 15.1081 3.44232C15.0383 3.33704 15.0008 3.21374 15 3.0875V3C15 2.20435 14.6839 1.44129 14.1213 0.87868C13.5587 0.316071 12.7956 0 12 0ZM11.2929 2.29289C11.4804 2.10536 11.7348 2 12 2C12.2652 2 12.5196 2.10536 12.7071 2.29289C12.8946 2.48043 13 2.73478 13 3V3.09L13 3.09399C13.0021 3.6108 13.1552 4.11572 13.4406 4.54661C13.7249 4.97601 14.1282 5.3132 14.6011 5.51701C15.0843 5.72908 15.6198 5.79211 16.139 5.69796C16.66 5.60349 17.1408 5.35516 17.5193 4.98491L17.5875 4.91671C17.6804 4.82374 17.7907 4.74998 17.9121 4.69965C18.0335 4.64933 18.1636 4.62343 18.295 4.62343C18.4264 4.62343 18.5565 4.64933 18.6779 4.69965C18.7993 4.74998 18.9096 4.82374 19.0025 4.91671L19.0033 4.9175C19.0963 5.01037 19.17 5.12066 19.2203 5.24206C19.2707 5.36346 19.2966 5.49359 19.2966 5.625C19.2966 5.75641 19.2707 5.88654 19.2203 6.00794C19.17 6.12934 19.0959 6.24002 19.0029 6.3329L18.9428 6.39285L18.9351 6.40073C18.5649 6.77925 18.3165 7.26 18.222 7.781C18.14 8.23332 18.1773 8.69798 18.3284 9.12961C18.3403 9.22042 18.3646 9.30938 18.4009 9.39393C18.6045 9.86896 18.9425 10.2741 19.3734 10.5594C19.8043 10.8448 20.3092 10.9979 20.826 11L20.83 11H21C21.2652 11 21.5196 11.1054 21.7071 11.2929C21.8946 11.4804 22 11.7348 22 12C22 12.2652 21.8946 12.5196 21.7071 12.7071C21.5196 12.8946 21.2652 13 21 13L20.91 13L20.906 13C20.3892 13.0021 19.8843 13.1552 19.4534 13.4406C19.024 13.725 18.6867 14.1283 18.4829 14.6012C18.2709 15.0843 18.2079 15.6198 18.302 16.139C18.3965 16.66 18.6448 17.1408 19.0151 17.5193L19.0833 17.5875C19.1763 17.6804 19.25 17.7907 19.3003 17.9121C19.3507 18.0335 19.3766 18.1636 19.3766 18.295C19.3766 18.4264 19.3507 18.5565 19.3003 18.6779C19.25 18.7993 19.1763 18.9096 19.0833 19.0025L19.0825 19.0033C18.9896 19.0963 18.8793 19.17 18.7579 19.2203C18.6365 19.2707 18.5064 19.2966 18.375 19.2966C18.2436 19.2966 18.1135 19.2707 17.9921 19.2203C17.8707 19.17 17.76 19.0959 17.6671 19.0029L17.6071 18.9429L17.5993 18.9351C17.2207 18.5649 16.74 18.3165 16.219 18.222C15.6998 18.1279 15.1643 18.1909 14.6812 18.4029C14.2083 18.6067 13.805 18.944 13.5206 19.3734C13.2352 19.8043 13.0821 20.3092 13.08 20.826L13.08 20.83V21C13.08 21.2652 12.9746 21.5196 12.7871 21.7071C12.5996 21.8946 12.3452 22 12.08 22C11.8148 22 11.5604 21.8946 11.3729 21.7071C11.1854 21.5196 11.08 21.2652 11.08 21V20.91L11.0797 20.8866C11.0673 20.355 10.8952 19.8395 10.5859 19.407C10.2827 18.983 9.86132 18.6581 9.37477 18.4725C8.89796 18.2689 8.37163 18.2095 7.861 18.302C7.34 18.3965 6.85921 18.6448 6.48069 19.0151L6.4125 19.0833C6.31963 19.1763 6.20934 19.25 6.08794 19.3003C5.96654 19.3507 5.83641 19.3766 5.705 19.3766C5.57359 19.3766 5.44346 19.3507 5.32206 19.3003C5.20066 19.25 5.09037 19.1763 4.9975 19.0833L4.99671 19.0825C4.90374 18.9896 4.82998 18.8793 4.77965 18.7579C4.72933 18.6365 4.70343 18.5064 4.70343 18.375C4.70343 18.2436 4.72933 18.1135 4.77965 17.9921C4.82998 17.8707 4.90413 17.76 4.9971 17.6671L5.05715 17.6072L5.06486 17.5993C5.43512 17.2207 5.68349 16.74 5.77796 16.219C5.87211 15.6998 5.80908 15.1643 5.59701 14.6811C5.3932 14.2082 5.05601 13.8049 4.62661 13.5206C4.19572 13.2352 3.6908 13.0821 3.17399 13.08H3C2.73478 13.08 2.48043 12.9746 2.29289 12.7871C2.10536 12.5996 2 12.3452 2 12.08C2 11.8148 2.10536 11.5604 2.29289 11.3729C2.48043 11.1854 2.73478 11.08 3 11.08H3.09L3.11338 11.0797C3.64498 11.0673 4.16054 10.8952 4.59305 10.5859C5.01698 10.2827 5.34189 9.86133 5.52745 9.37478C5.73113 8.89797 5.79055 8.37163 5.69796 7.861C5.60349 7.34 5.35516 6.85921 4.98491 6.48069L4.91671 6.4125C4.82374 6.31963 4.74998 6.20934 4.69965 6.08794C4.64933 5.96654 4.62343 5.83642 4.62343 5.705C4.62343 5.57358 4.64933 5.44346 4.69965 5.32206C4.74998 5.20066 4.82374 5.09037 4.91671 4.9975L4.9175 4.99671C5.01037 4.90374 5.12066 4.82998 5.24206 4.77965C5.36346 4.72933 5.49358 4.70343 5.625 4.70343C5.75642 4.70343 5.88654 4.72933 6.00794 4.77965C6.12934 4.82998 6.24002 4.90413 6.33289 4.99711L6.39285 5.05715L6.40073 5.06486C6.77925 5.43512 7.26 5.68349 7.781 5.77796C8.23333 5.85998 8.69798 5.82272 9.12961 5.67157C9.22042 5.65969 9.30938 5.63538 9.39393 5.59914C9.86895 5.39555 10.2741 5.0575 10.5594 4.62661C10.8448 4.19572 10.9979 3.6908 11 3.17399V3C11 2.73478 11.1054 2.48043 11.2929 2.29289Z" })), ri = (r) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ _.createElement("path", { d: "M9 10C9 9.44771 8.55228 9 8 9C7.44772 9 7 9.44771 7 10C7 11.3261 7.52678 12.5979 8.46447 13.5355C9.40215 14.4732 10.6739 15 12 15C13.3261 15 14.5979 14.4732 15.5355 13.5355C16.4732 12.5979 17 11.3261 17 10C17 9.44771 16.5523 9 16 9C15.4477 9 15 9.44771 15 10C15 10.7956 14.6839 11.5587 14.1213 12.1213C13.5587 12.6839 12.7956 13 12 13C11.2044 13 10.4413 12.6839 9.87868 12.1213C9.31607 11.5587 9 10.7956 9 10Z" }), /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.2 1.4C5.38885 1.14819 5.68524 1 6 1H18C18.3148 1 18.6111 1.14819 18.8 1.4L21.7939 5.39188C21.9232 5.56038 22 5.77122 22 6V20C22 20.7957 21.6839 21.5587 21.1213 22.1213C20.5587 22.6839 19.7957 23 19 23H5C4.20435 23 3.44129 22.6839 2.87868 22.1213C2.31607 21.5587 2 20.7957 2 20V6C2 5.77123 2.07682 5.56041 2.20606 5.39192L5.2 1.4ZM17.5 3L19 5H5L6.5 3H17.5ZM4 20V7H20V20C20 20.2652 19.8946 20.5196 19.7071 20.7071C19.5196 20.8946 19.2652 21 19 21H5C4.73478 21 4.48043 20.8946 4.29289 20.7071C4.10536 20.5196 4 20.2652 4 20Z" })), si = (r) => /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: 24, height: 24, ...r }, /* @__PURE__ */ _.createElement("style", null, `
@keyframes a0_t { 0% { transform: translate(12px,12px) rotate(0deg) translate(-6px,-6px); } 25% { transform: translate(12px,12px) rotate(180deg) translate(-6px,-6px); } 50% { transform: translate(12px,12px) rotate(360deg) translate(-6px,-6px); } 100% { transform: translate(12px,12px) rotate(720deg) translate(-6px,-6px); } }
@keyframes a1_t { 0% { transform: translate(6px,2px); } 50% { transform: translate(6px,0px); } 100% { transform: translate(6px,2px); } }
@keyframes a2_t { 0% { transform: translate(2px,6px); } 50% { transform: translate(0px,6px); } 100% { transform: translate(2px,6px); } }
@keyframes a3_t { 0% { transform: translate(6px,10px); } 50% { transform: translate(6px,12px); } 100% { transform: translate(6px,10px); } }
@keyframes a4_t { 0% { transform: translate(10px,6px); } 50% { transform: translate(12px,6px); } 100% { transform: translate(10px,6px); } }
`), /* @__PURE__ */ _.createElement("g", { transform: "translate(12,12) translate(-6,-6)", style: {
  animation: "3s linear infinite both a0_t"
} }, /* @__PURE__ */ _.createElement("ellipse", { rx: 2, ry: 2, transform: "translate(6,2)", style: {
  animation: "3s linear infinite both a1_t"
} }), /* @__PURE__ */ _.createElement("ellipse", { rx: 2, ry: 2, transform: "translate(2,6)", style: {
  animation: "3s linear infinite both a2_t"
} }), /* @__PURE__ */ _.createElement("ellipse", { rx: 2, ry: 2, transform: "translate(6,10)", style: {
  animation: "3s linear infinite both a3_t"
} }), /* @__PURE__ */ _.createElement("ellipse", { rx: 2, ry: 2, transform: "translate(10,6)", style: {
  animation: "3s linear infinite both a4_t"
} }))), ni = (r) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ _.createElement("path", { d: "M17.3883 0.864973C15.8152 0.851302 14.2995 1.45607 13.1679 2.54902L13.1576 2.55914L11.4376 4.26914C11.0459 4.65852 11.0441 5.29169 11.4335 5.68335C11.8229 6.07501 12.456 6.07685 12.8477 5.68747L14.5623 3.98284C15.3162 3.25721 16.3244 2.8558 17.371 2.8649C18.4197 2.87401 19.423 3.29469 20.1646 4.03632C20.9063 4.77795 21.3269 5.7812 21.336 6.82999C21.3451 7.87604 20.9441 8.88391 20.219 9.63768L17.2255 12.6312C16.82 13.0369 16.3319 13.3507 15.7945 13.5512C15.2571 13.7516 14.6828 13.8342 14.1107 13.7932C13.5386 13.7522 12.982 13.5887 12.4786 13.3137C11.9753 13.0387 11.537 12.6586 11.1934 12.1993C10.8626 11.7571 10.2359 11.6667 9.79366 11.9975C9.35141 12.3283 9.26107 12.955 9.59187 13.3973C10.1072 14.0862 10.7647 14.6563 11.5197 15.0688C12.2748 15.4813 13.1097 15.7266 13.9679 15.7881C14.826 15.8495 15.6874 15.7257 16.4935 15.425C17.2996 15.1243 18.0316 14.6538 18.6399 14.0453L21.6397 11.0454L21.6519 11.033C22.7449 9.9014 23.3496 8.38579 23.336 6.81261C23.3223 5.23943 22.6913 3.73455 21.5788 2.62211C20.4664 1.50966 18.9615 0.878643 17.3883 0.864973Z", fill: "currentColor" }), /* @__PURE__ */ _.createElement("path", { d: "M10.8173 7.80879C9.95915 7.74733 9.09779 7.87115 8.29168 8.17185C7.48563 8.47253 6.75354 8.94316 6.1453 9.55159L3.14543 12.5515L3.13325 12.5639C2.0403 13.6955 1.43553 15.2111 1.4492 16.7843C1.46287 18.3574 2.09389 19.8623 3.20633 20.9748C4.31878 22.0872 5.82366 22.7182 7.39684 22.7319C8.97002 22.7456 10.4856 22.1408 11.6172 21.0479L11.6296 21.0357L13.3396 19.3257C13.7302 18.9351 13.7302 18.302 13.3396 17.9115C12.9491 17.5209 12.316 17.5209 11.9254 17.9115L10.2219 19.615C9.46813 20.34 8.46026 20.7411 7.41422 20.732C6.36543 20.7229 5.36218 20.3022 4.62055 19.5606C3.87892 18.8189 3.45824 17.8157 3.44913 16.7669C3.44004 15.7208 3.84109 14.713 4.56613 13.9592L7.55977 10.9655C7.96528 10.5599 8.45329 10.2462 8.99069 10.0457C9.5281 9.84525 10.1023 9.7627 10.6744 9.80368C11.2466 9.84465 11.8032 10.0082 12.3065 10.2832C12.8099 10.5582 13.2482 10.9382 13.5918 11.3975C13.9226 11.8398 14.5493 11.9301 14.9915 11.5993C15.4338 11.2685 15.5241 10.6418 15.1933 10.1996C14.678 9.51063 14.0205 8.94057 13.2654 8.52806C12.5104 8.11555 11.6755 7.87025 10.8173 7.80879Z", fill: "currentColor" })), ii = (r) => /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 -960 960 960", width: "24px", fill: "#000000", ...r }, /* @__PURE__ */ _.createElement("path", { d: "m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" })), ai = (r) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ _.createElement("path", { d: "M12 11C12.5523 11 13 11.4477 13 12V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V12C11 11.4477 11.4477 11 12 11Z" }), /* @__PURE__ */ _.createElement("path", { d: "M12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9Z" }), /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z" })), oi = (r) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 2C5.79086 2 4 3.79086 4 6V6.17071C2.83481 6.58254 2 7.69378 2 9V11C2 12.6569 3.34315 14 5 14H11C12.6569 14 14 12.6569 14 11V9C14 7.69378 13.1652 6.58254 12 6.17071V6C12 3.79086 10.2091 2 8 2ZM10 6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6H10ZM4 9C4 8.44772 4.44772 8 5 8H11C11.5523 8 12 8.44772 12 9V11C12 11.5523 11.5523 12 11 12H5C4.44772 12 4 11.5523 4 11V9Z" })), li = (r) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.29289 15.7071C5.68342 16.0976 6.31658 16.0976 6.70711 15.7071L12 10.4142L17.2929 15.7071C17.6834 16.0976 18.3166 16.0976 18.7071 15.7071C19.0976 15.3166 19.0976 14.6834 18.7071 14.2929L12.7071 8.29289C12.5196 8.10536 12.2652 8 12 8C11.7348 8 11.4804 8.10536 11.2929 8.29289L5.29289 14.2929C4.90237 14.6834 4.90237 15.3166 5.29289 15.7071Z" })), ui = (r) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16C11.7348 16 11.4804 15.8946 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289Z" })), ci = (r) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 3C6 2.44772 6.44772 2 7 2H14C14.2652 2 14.5196 2.10536 14.7071 2.29289L19.7071 7.29289C19.8946 7.48043 20 7.73478 20 8V21C20 21.5523 19.5523 22 19 22H17C16.4477 22 16 21.5523 16 21C16 20.4477 16.4477 20 17 20H18V8.41421L13.5858 4H7C6.44772 4 6 3.55228 6 3Z", fill: "currentColor" }), /* @__PURE__ */ _.createElement("path", { d: "M6 9C6 9.55228 6.44772 10 7 10H13C13.5523 10 14 9.55228 14 9C14 8.44772 13.5523 8 13 8H11V7C11 6.44772 10.5523 6 10 6C9.44772 6 9 6.44772 9 7V8H8V6C8 5.44772 7.55228 5 7 5C6.44772 5 6 5.44772 6 6V9Z", fill: "currentColor" }), /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 21C6 21.2652 6.10536 21.5196 6.29289 21.7071C6.48043 21.8946 6.73478 22 7 22H13C13.5523 22 14 21.5523 14 21C14 20.4477 13.5523 20 13 20H11V19.5C11 18.1193 9.88071 17 8.5 17C7.11929 17 6 18.1193 6 19.5V21ZM9 19.5V20H8V19.5C8 19.2239 8.22386 19 8.5 19C8.77614 19 9 19.2239 9 19.5Z", fill: "currentColor" }), /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 15C6 15.5523 6.44772 16 7 16H13C13.5523 16 14 15.5523 14 15V14C14 12.3431 12.6569 11 11 11H9C7.34315 11 6 12.3431 6 14V15ZM11 13C11.5523 13 12 13.4477 12 14H8C8 13.4477 8.44772 13 9 13H11Z", fill: "currentColor" })), di = (r) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ _.createElement("path", { d: "M14.5 10.5L19.5 7.50005L16.5 4.00005L12.5 3.50005V9.00005L14.5 10.5Z", fill: "#F8B0B0" }), /* @__PURE__ */ _.createElement("path", { d: "M9.5 10.5L4.5 7.5L7 4.5L11.5 3.5V9L9.5 10.5Z", fill: "#F8E3B0" }), /* @__PURE__ */ _.createElement("path", { d: "M9 11L4.5 8.5L3 12L4 16L9 13.5V11Z", fill: "#BBF8B0" }), /* @__PURE__ */ _.createElement("path", { d: "M11.5 15.5V20.5L7.5 19.5L4.5 17L9.5 14L11.5 15.5Z", fill: "#B0F8F7" }), /* @__PURE__ */ _.createElement("path", { d: "M12 15.5L12.5 20.5L16.5 19.5L19 16.5L15 14L12 15.5Z", fill: "#B0B8F8" }), /* @__PURE__ */ _.createElement("path", { d: "M15 11L20 8L21 12L19.5 16L15 13V11Z", fill: "#F8B0F5" }), /* @__PURE__ */ _.createElement("path", { d: "M12 3V9M12 15V21M4.20581 7.5L9.40196 10.5M14.5981 13.5L19.7943 16.5M14.5981 10.5L19.7943 7.5M4.20581 16.5L9.40196 13.5", stroke: "#3C3F45", strokeWidth: 2 }), /* @__PURE__ */ _.createElement("circle", { cx: 12, cy: 12, r: 9, stroke: "#3C3F45", strokeWidth: 2 }), /* @__PURE__ */ _.createElement("circle", { cx: 12, cy: 12, r: 3, stroke: "#3C3F45", strokeWidth: 2 })), fi = (r) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ _.createElement("path", { d: "M12.2929 6.70711C11.9024 6.31658 11.9024 5.68342 12.2929 5.29289C12.6834 4.90237 13.3166 4.90237 13.7071 5.29289L19.7071 11.2929C20.0976 11.6834 20.0976 12.3166 19.7071 12.7071L13.7071 18.7071C13.3166 19.0976 12.6834 19.0976 12.2929 18.7071C11.9024 18.3166 11.9024 17.6834 12.2929 17.2929L16.5858 13H5C4.44771 13 4 12.5523 4 12C4 11.4477 4.44771 11 5 11H16.5858L12.2929 6.70711Z" })), hi = (r) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ _.createElement("path", { d: "M14 6C14 7.10457 13.1046 8 12 8C10.8954 8 10 7.10457 10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6Z" }), /* @__PURE__ */ _.createElement("path", { d: "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z" }), /* @__PURE__ */ _.createElement("path", { d: "M12 20C13.1046 20 14 19.1046 14 18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18C10 19.1046 10.8954 20 12 20Z" })), pi = (r) => /* @__PURE__ */ _.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ _.createElement("path", { d: "M5 0L0 2L5 4L10 2L5 0Z", fill: "white" }), /* @__PURE__ */ _.createElement("path", { d: "M5 5L2.5 4L0 5L5 7L10 5L7.5 4L5 5Z", fill: "white" }), /* @__PURE__ */ _.createElement("path", { d: "M5 8L2.5 7L0 8L5 10L10 8L7.5 7L5 8Z", fill: "white" })), gi = (r) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ _.createElement("path", { d: "M8 3.5C9.45238 3.5 10.8058 3.8444 11.8125 4.51367C12.831 5.19093 13.5 6.21043 13.5 7.5C13.5 8.78959 12.831 9.8091 11.8125 10.4863C10.8529 11.1242 9.57821 11.4654 8.20312 11.4961L8.85352 12.1465L8.91797 12.2246C9.04612 12.4187 9.02437 12.6827 8.85352 12.8535C8.68265 13.0244 8.41868 13.0461 8.22461 12.918L8.14648 12.8535L6.64648 11.3535C6.55272 11.2598 6.50001 11.1326 6.5 11C6.5 10.9006 6.52964 10.8042 6.58398 10.7227L6.64648 10.6465L8.14648 9.14648L8.22461 9.08203C8.41869 8.95387 8.68265 8.97562 8.85352 9.14648C9.02437 9.31735 9.04613 9.58132 8.91797 9.77539L8.85352 9.85352L8.21289 10.4932C9.43315 10.4612 10.4997 10.1589 11.2588 9.6543C12.0497 9.12847 12.5 8.39789 12.5 7.5C12.5 6.60214 12.0497 5.87156 11.2588 5.3457C10.4558 4.81188 9.30899 4.5 8 4.5C6.69101 4.5 5.5442 4.81188 4.74121 5.3457C3.95027 5.87156 3.50003 6.60214 3.5 7.5C3.5 7.91017 3.59285 8.27798 3.76172 8.60449L3.83887 8.74121L3.88184 8.83301C3.95982 9.0522 3.87585 9.3028 3.66895 9.42773C3.46227 9.55243 3.20162 9.51045 3.04395 9.33984L2.98242 9.25879L2.87305 9.06152C2.63152 8.59374 2.5 8.06947 2.5 7.5C2.50003 6.21043 3.16899 5.19093 4.1875 4.51367C5.19415 3.8444 6.54762 3.5 8 3.5Z", fill: "#2B2B2B", fillOpacity: 0.88 })), mi = (r) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ _.createElement("g", { clipPath: "url(#clip0_11031_191172)" }, /* @__PURE__ */ _.createElement("g", { clipPath: "url(#clip1_11031_191172)" }, /* @__PURE__ */ _.createElement("path", { d: "M12 0.5C5.64873 0.5 0.5 5.64873 0.5 12C0.5 18.3513 5.64873 23.5 12 23.5C12.3318 23.5 12.642 23.3354 12.8281 23.0606C13.0141 22.7859 13.0517 22.4367 12.9285 22.1286C12.0483 19.9281 12.2597 16.8353 14.2375 14.6753C15.3157 13.4978 16.502 12.8611 17.79 12.6109C19.0966 12.357 20.5721 12.4892 22.2253 12.9615C22.527 13.0477 22.8517 12.9873 23.1022 12.7983C23.3527 12.6094 23.5 12.3138 23.5 12C23.5 5.64873 18.3513 0.5 12 0.5Z", fill: "#7E9F5A" }), /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.75 16C17.2312 16 16 17.2312 16 18.75C16 20.2688 17.2312 21.5 18.75 21.5C20.2688 21.5 21.5 20.2688 21.5 18.75C21.5 17.2312 20.2688 16 18.75 16ZM14 18.75C14 16.1266 16.1266 14 18.75 14C21.3734 14 23.5 16.1266 23.5 18.75C23.5 21.3734 21.3734 23.5 18.75 23.5C16.1266 23.5 14 21.3734 14 18.75Z", fill: "#2B2B2B", fillOpacity: 0.88 }))), /* @__PURE__ */ _.createElement("defs", null, /* @__PURE__ */ _.createElement("clipPath", { id: "clip0_11031_191172" }, /* @__PURE__ */ _.createElement("rect", { width: 24, height: 24, fill: "white" })), /* @__PURE__ */ _.createElement("clipPath", { id: "clip1_11031_191172" }, /* @__PURE__ */ _.createElement("rect", { width: 24, height: 24, fill: "white" })))), yi = (r) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ _.createElement("g", { clipPath: "url(#clip0_11031_191177)" }, /* @__PURE__ */ _.createElement("g", { clipPath: "url(#clip1_11031_191177)" }, /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5C12.5523 21.5 13 21.9477 13 22.5C13 23.0523 12.5523 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 12.5523 23.0523 13 22.5 13C21.9477 13 21.5 12.5523 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5Z", fill: "#2B2B2B", fillOpacity: 0.88 }), /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 18.75C14 16.1266 16.1266 14 18.75 14C21.3734 14 23.5 16.1266 23.5 18.75C23.5 21.3734 21.3734 23.5 18.75 23.5C16.1266 23.5 14 21.3734 14 18.75Z", fill: "#7E9F5A" }))), /* @__PURE__ */ _.createElement("defs", null, /* @__PURE__ */ _.createElement("clipPath", { id: "clip0_11031_191177" }, /* @__PURE__ */ _.createElement("rect", { width: 24, height: 24, fill: "white" })), /* @__PURE__ */ _.createElement("clipPath", { id: "clip1_11031_191177" }, /* @__PURE__ */ _.createElement("rect", { width: 24, height: 24, fill: "white" })))), vi = (r) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 8C9.23858 8 7 10.2386 7 13C7 15.7614 9.23858 18 12 18C14.7614 18 17 15.7614 17 13C17 10.2386 14.7614 8 12 8ZM9 13C9 11.3431 10.3431 10 12 10C13.6569 10 15 11.3431 15 13C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13Z", fill: "white" }), /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.0704 2C9.06731 2 8.13061 2.5013 7.57422 3.3359L6.46482 5H3C2.20435 5 1.44129 5.31607 0.87868 5.87868C0.316071 6.44129 0 7.20435 0 8V19C0 19.7957 0.316071 20.5587 0.87868 21.1213C1.44129 21.6839 2.20435 22 3 22H21C21.7957 22 22.5587 21.6839 23.1213 21.1213C23.6839 20.5587 24 19.7957 24 19V8C24 7.20435 23.6839 6.44129 23.1213 5.87868C22.5587 5.31607 21.7957 5 21 5H17.5352L16.4258 3.3359C15.8694 2.5013 14.9327 2 13.9296 2H10.0704ZM9.23832 4.4453C9.42378 4.1671 9.73601 4 10.0704 4H13.9296C14.264 4 14.5762 4.1671 14.7617 4.4453L16.1679 6.5547C16.3534 6.8329 16.6656 7 17 7H21C21.2652 7 21.5196 7.10536 21.7071 7.29289C21.8946 7.48043 22 7.73478 22 8V19C22 19.2652 21.8946 19.5196 21.7071 19.7071C21.5196 19.8946 21.2652 20 21 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V8C2 7.73478 2.10536 7.48043 2.29289 7.29289C2.48043 7.10536 2.73478 7 3 7H7C7.33435 7 7.64658 6.8329 7.83205 6.5547L9.23832 4.4453Z", fill: "white" })), Ys = {
  ar: Yn,
  close: Qn,
  expandViewport: ei,
  settings: ti,
  shoppingBag: ri,
  spinner: si,
  share: ni,
  check: ii,
  lock: oi,
  info: ai,
  chevronUp: li,
  chevronDown: ui,
  pdf: ci,
  palette: di,
  arrow: fi,
  more: hi,
  asset: pi,
  rotate: gi,
  parent: mi,
  child: yi,
  camera: vi
}, bi = ({ type: r, className: e, style: t, colored: s, ...n }) => {
  const i = r ? Ys[r] : null;
  return i && /* @__PURE__ */ re("i", { className: de(Sr.icon, e), style: t, ...n, children: /* @__PURE__ */ re(i, { className: de(Sr.svg, { [Sr.colored]: s }) }) });
}, _i = (r) => Ys.hasOwnProperty(r), xi = "_button_1lyly_1", Ci = "_primary_1lyly_25", wi = "_secondary_1lyly_43", Si = "_ternary_1lyly_61", ki = "_ghost_1lyly_79", Oi = "_iconOnly_1lyly_96", Ei = "_icon_1lyly_96", Li = "_text_1lyly_110", _e = {
  button: xi,
  primary: Ci,
  secondary: wi,
  ternary: Si,
  ghost: ki,
  iconOnly: Oi,
  icon: Ei,
  text: Li
}, ds = (r) => typeof r == "string" && _i(r) ? /* @__PURE__ */ re(bi, { type: r }) : r, kr = qt(
  ({ className: r, variant: e = "primary", disabled: t, selected: s, children: n, onClick: i, iconEnd: a, iconStart: o, ...l }, u) => {
    const c = !n && (o || a);
    return /* @__PURE__ */ we(
      "button",
      {
        ref: u,
        ...l,
        className: de(
          _e.button,
          {
            [_e.primary]: e === "primary",
            [_e.secondary]: e === "secondary",
            [_e.ternary]: e === "ternary",
            [_e.ghost]: e === "ghost",
            [_e.iconOnly]: c,
            [_e.selected]: s
          },
          r
        ),
        onClick: i,
        disabled: t,
        children: [
          o && /* @__PURE__ */ re("span", { className: de(_e.icon, _e.iconStart), children: ds(o) }),
          n ? /* @__PURE__ */ re("p", { className: de(_e.text), children: n }) : void 0,
          a && /* @__PURE__ */ re("span", { className: de(_e.icon, _e.iconEnd), children: ds(a) })
        ]
      }
    );
  }
);
var Ai = {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
};
const Ti = /* @__PURE__ */ Jr(Ai);
var Ni = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function fs(r) {
  var e = { type: "tag", name: "", voidElement: !1, attrs: {}, children: [] }, t = r.match(/<\/?([^\s]+?)[/\s>]/);
  if (t && (e.name = t[1], (Ti[t[1]] || r.charAt(r.length - 2) === "/") && (e.voidElement = !0), e.name.startsWith("!--"))) {
    var s = r.indexOf("-->");
    return { type: "comment", comment: s !== -1 ? r.slice(4, s) : "" };
  }
  for (var n = new RegExp(Ni), i = null; (i = n.exec(r)) !== null; )
    if (i[0].trim())
      if (i[1]) {
        var a = i[1].trim(), o = [a, ""];
        a.indexOf("=") > -1 && (o = a.split("=")), e.attrs[o[0]] = o[1], n.lastIndex--;
      } else
        i[2] && (e.attrs[i[2]] = i[3].trim().substring(1, i[3].length - 1));
  return e;
}
var Ri = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, Pi = /^\s*$/, ji = /* @__PURE__ */ Object.create(null);
function Qs(r, e) {
  switch (e.type) {
    case "text":
      return r + e.content;
    case "tag":
      return r += "<" + e.name + (e.attrs ? function(t) {
        var s = [];
        for (var n in t)
          s.push(n + '="' + t[n] + '"');
        return s.length ? " " + s.join(" ") : "";
      }(e.attrs) : "") + (e.voidElement ? "/>" : ">"), e.voidElement ? r : r + e.children.reduce(Qs, "") + "</" + e.name + ">";
    case "comment":
      return r + "<!--" + e.comment + "-->";
  }
}
var Vi = { parse: function(r, e) {
  e || (e = {}), e.components || (e.components = ji);
  var t, s = [], n = [], i = -1, a = !1;
  if (r.indexOf("<") !== 0) {
    var o = r.indexOf("<");
    s.push({ type: "text", content: o === -1 ? r : r.substring(0, o) });
  }
  return r.replace(Ri, function(l, u) {
    if (a) {
      if (l !== "</" + t.name + ">")
        return;
      a = !1;
    }
    var c, f = l.charAt(1) !== "/", p = l.startsWith("<!--"), v = u + l.length, x = r.charAt(v);
    if (p) {
      var C = fs(l);
      return i < 0 ? (s.push(C), s) : ((c = n[i]).children.push(C), s);
    }
    if (f && (i++, (t = fs(l)).type === "tag" && e.components[t.name] && (t.type = "component", a = !0), t.voidElement || a || !x || x === "<" || t.children.push({ type: "text", content: r.slice(v, r.indexOf("<", v)) }), i === 0 && s.push(t), (c = n[i - 1]) && c.children.push(t), n[i] = t), (!f || t.voidElement) && (i > -1 && (t.voidElement || t.name === l.slice(2, -1)) && (i--, t = i === -1 ? s : n[i]), !a && x !== "<" && x)) {
      c = i === -1 ? s : n[i].children;
      var L = r.indexOf("<", v), V = r.slice(v, L === -1 ? void 0 : L);
      Pi.test(V) && (V = " "), (L > -1 && i + c.length >= 0 || V !== " ") && c.push({ type: "text", content: V });
    }
  }), s;
}, stringify: function(r) {
  return r.reduce(function(e, t) {
    return e + Qs("", t);
  }, "");
} };
const Xt = (r, e, t, s) => {
  var i, a, o, l;
  const n = [t, {
    code: e,
    ...s || {}
  }];
  if ((a = (i = r == null ? void 0 : r.services) == null ? void 0 : i.logger) != null && a.forward)
    return r.services.logger.forward(n, "warn", "react-i18next::", !0);
  Se(n[0]) && (n[0] = `react-i18next:: ${n[0]}`), (l = (o = r == null ? void 0 : r.services) == null ? void 0 : o.logger) != null && l.warn ? r.services.logger.warn(...n) : console != null && console.warn && console.warn(...n);
}, hs = {}, Lt = (r, e, t, s) => {
  Se(t) && hs[t] || (Se(t) && (hs[t] = /* @__PURE__ */ new Date()), Xt(r, e, t, s));
}, en = (r, e) => () => {
  if (r.isInitialized)
    e();
  else {
    const t = () => {
      setTimeout(() => {
        r.off("initialized", t);
      }, 0), e();
    };
    r.on("initialized", t);
  }
}, Ir = (r, e, t) => {
  r.loadNamespaces(e, en(r, t));
}, ps = (r, e, t, s) => {
  if (Se(t) && (t = [t]), r.options.preload && r.options.preload.indexOf(e) > -1)
    return Ir(r, t, s);
  t.forEach((n) => {
    r.options.ns.indexOf(n) < 0 && r.options.ns.push(n);
  }), r.loadLanguages(e, en(r, s));
}, Fi = (r, e, t = {}) => !e.languages || !e.languages.length ? (Lt(e, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: e.languages
}), !0) : e.hasLoadedNamespace(r, {
  lng: t.lng,
  precheck: (s, n) => {
    if (t.bindI18n && t.bindI18n.indexOf("languageChanging") > -1 && s.services.backendConnector.backend && s.isLanguageChangingTo && !n(s.isLanguageChangingTo, r))
      return !1;
  }
}), Se = (r) => typeof r == "string", qe = (r) => typeof r == "object" && r !== null, Ii = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Di = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, $i = (r) => Di[r], Mi = (r) => r.replace(Ii, $i);
let Dr = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Mi
};
const Zi = (r = {}) => {
  Dr = {
    ...Dr,
    ...r
  };
}, tn = () => Dr;
let rn;
const Bi = (r) => {
  rn = r;
}, Xr = () => rn, Or = (r, e) => {
  var s;
  if (!r)
    return !1;
  const t = ((s = r.props) == null ? void 0 : s.children) ?? r.children;
  return e ? t.length > 0 : !!t;
}, Er = (r) => {
  var t, s;
  if (!r)
    return [];
  const e = ((t = r.props) == null ? void 0 : t.children) ?? r.children;
  return (s = r.props) != null && s.i18nIsDynamicList ? ct(e) : e;
}, Ui = (r) => Array.isArray(r) && r.every(Qt), ct = (r) => Array.isArray(r) ? r : [r], qi = (r, e) => {
  const t = {
    ...e
  };
  return t.props = Object.assign(r.props, e.props), t;
}, sn = (r, e, t, s) => {
  if (!r)
    return "";
  let n = "";
  const i = ct(r), a = e != null && e.transSupportBasicHtmlNodes ? e.transKeepBasicHtmlNodesFor ?? [] : [];
  return i.forEach((o, l) => {
    if (Se(o)) {
      n += `${o}`;
      return;
    }
    if (Qt(o)) {
      const {
        props: u,
        type: c
      } = o, f = Object.keys(u).length, p = a.indexOf(c) > -1, v = u.children;
      if (!v && p && !f) {
        n += `<${c}/>`;
        return;
      }
      if (!v && (!p || f) || u.i18nIsDynamicList) {
        n += `<${l}></${l}>`;
        return;
      }
      if (p && f === 1 && Se(v)) {
        n += `<${c}>${v}</${c}>`;
        return;
      }
      const x = sn(v, e, t, s);
      n += `<${l}>${x}</${l}>`;
      return;
    }
    if (o === null) {
      Xt(t, "TRANS_NULL_VALUE", "Passed in a null value as child", {
        i18nKey: s
      });
      return;
    }
    if (qe(o)) {
      const {
        format: u,
        ...c
      } = o, f = Object.keys(c);
      if (f.length === 1) {
        const p = u ? `${f[0]}, ${u}` : f[0];
        n += `{{${p}}}`;
        return;
      }
      Xt(t, "TRANS_INVALID_OBJ", "Invalid child - Object should only have keys {{ value, format }} (format is optional).", {
        i18nKey: s,
        child: o
      });
      return;
    }
    Xt(t, "TRANS_INVALID_VAR", "Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.", {
      i18nKey: s,
      child: o
    });
  }), n;
}, Hi = (r, e, t, s, n, i, a) => {
  if (t === "")
    return [];
  const o = n.transKeepBasicHtmlNodesFor || [], l = t && new RegExp(o.map((V) => `<${V}`).join("|")).test(t);
  if (!r && !e && !l && !a)
    return [t];
  const u = e ?? {}, c = (V) => {
    ct(V).forEach((U) => {
      Se(U) || (Or(U) ? c(Er(U)) : qe(U) && !Qt(U) && Object.assign(u, U));
    });
  };
  c(r);
  const f = Vi.parse(`<0>${t}</0>`), p = {
    ...u,
    ...i
  }, v = (V, k, U) => {
    var P;
    const D = Er(V), Z = C(D, k.children, U);
    return Ui(D) && Z.length === 0 || (P = V.props) != null && P.i18nIsDynamicList ? D : Z;
  }, x = (V, k, U, D, Z) => {
    V.dummy ? (V.children = k, U.push(Ks(V, {
      key: D
    }, Z ? void 0 : k))) : U.push(...Zn.map([V], (P) => {
      const O = {
        ...P.props
      };
      return delete O.i18nIsDynamicList, Me(P.type, {
        ...O,
        key: D,
        ref: P.props.ref ?? P.ref
      }, Z ? null : k);
    }));
  }, C = (V, k, U) => {
    const D = ct(V);
    return ct(k).reduce((P, O, $) => {
      var Q, se;
      const J = ((se = (Q = O.children) == null ? void 0 : Q[0]) == null ? void 0 : se.content) && s.services.interpolator.interpolate(O.children[0].content, p, s.language);
      if (O.type === "tag") {
        let R = D[parseInt(O.name, 10)];
        !R && e && (R = e[O.name]), U.length === 1 && !R && (R = U[0][O.name]), R || (R = {});
        const M = Object.keys(O.attrs).length !== 0 ? qi({
          props: O.attrs
        }, R) : R, ee = Qt(M), h = ee && Or(O, !0) && !O.voidElement, y = l && qe(M) && M.dummy && !ee, I = qe(e) && Object.hasOwnProperty.call(e, O.name);
        if (Se(M)) {
          const j = s.services.interpolator.interpolate(M, p, s.language);
          P.push(j);
        } else if (Or(M) || h) {
          const j = v(M, O, U);
          x(M, j, P, $);
        } else if (y) {
          const j = C(D, O.children, U);
          x(M, j, P, $);
        } else if (Number.isNaN(parseFloat(O.name)))
          if (I) {
            const j = v(M, O, U);
            x(M, j, P, $, O.voidElement);
          } else if (n.transSupportBasicHtmlNodes && o.indexOf(O.name) > -1)
            if (O.voidElement)
              P.push(Me(O.name, {
                key: `${O.name}-${$}`
              }));
            else {
              const j = C(D, O.children, U);
              P.push(Me(O.name, {
                key: `${O.name}-${$}`
              }, j));
            }
          else if (O.voidElement)
            P.push(`<${O.name} />`);
          else {
            const j = C(D, O.children, U);
            P.push(`<${O.name}>${j}</${O.name}>`);
          }
        else if (qe(M) && !ee) {
          const j = O.children[0] ? J : null;
          j && P.push(j);
        } else
          x(M, J, P, $, O.children.length !== 1 || !J);
      } else if (O.type === "text") {
        const R = n.transWrapTextNodes, M = a ? n.unescape(s.services.interpolator.interpolate(O.content, p, s.language)) : s.services.interpolator.interpolate(O.content, p, s.language);
        R ? P.push(Me(R, {
          key: `${O.name}-${$}`
        }, M)) : P.push(M);
      }
      return P;
    }, []);
  }, L = C([{
    dummy: !0,
    children: r || []
  }], f, ct(r || []));
  return Er(L[0]);
}, nn = (r, e, t) => {
  const s = r.key || e, n = Ks(r, {
    key: s
  });
  if (!n.props || !n.props.children || t.indexOf(`${e}/>`) < 0 && t.indexOf(`${e} />`) < 0)
    return n;
  function i() {
    return Me(Bn, null, n);
  }
  return Me(i, {
    key: s
  });
}, zi = (r, e) => r.map((t, s) => nn(t, s, e)), Ki = (r, e) => {
  const t = {};
  return Object.keys(r).forEach((s) => {
    Object.assign(t, {
      [s]: nn(r[s], s, e)
    });
  }), t;
}, Wi = (r, e, t, s) => r ? Array.isArray(r) ? zi(r, e) : qe(r) ? Ki(r, e) : (Lt(t, "TRANS_INVALID_COMPONENTS", '<Trans /> "components" prop expects an object or array', {
  i18nKey: s
}), null) : null, Ji = (r) => !qe(r) || Array.isArray(r) ? !1 : Object.keys(r).reduce((e, t) => e && Number.isNaN(Number.parseFloat(t)), !0);
function Xi({
  children: r,
  count: e,
  parent: t,
  i18nKey: s,
  context: n,
  tOptions: i = {},
  values: a,
  defaults: o,
  components: l,
  ns: u,
  i18n: c,
  t: f,
  shouldUnescape: p,
  ...v
}) {
  var ee, h, y, I, j, G;
  const x = c || Xr();
  if (!x)
    return Lt(x, "NO_I18NEXT_INSTANCE", "Trans: You need to pass in an i18next instance using i18nextReactModule", {
      i18nKey: s
    }), r;
  const C = f || x.t.bind(x) || ((K) => K), L = {
    ...tn(),
    ...(ee = x.options) == null ? void 0 : ee.react
  };
  let V = u || C.ns || ((h = x.options) == null ? void 0 : h.defaultNS);
  V = Se(V) ? [V] : V || ["translation"];
  const k = sn(r, L, x, s), U = o || k || L.transEmptyNodeValue || s, {
    hashTransKey: D
  } = L, Z = s || (D ? D(k || U) : k || U);
  (I = (y = x.options) == null ? void 0 : y.interpolation) != null && I.defaultVariables && (a = a && Object.keys(a).length > 0 ? {
    ...a,
    ...x.options.interpolation.defaultVariables
  } : {
    ...x.options.interpolation.defaultVariables
  });
  const P = a || e !== void 0 && !((G = (j = x.options) == null ? void 0 : j.interpolation) != null && G.alwaysFormat) || !r ? i.interpolation : {
    interpolation: {
      ...i.interpolation,
      prefix: "#$?",
      suffix: "?$#"
    }
  }, O = {
    ...i,
    context: n || i.context,
    count: e,
    ...a,
    ...P,
    defaultValue: U,
    ns: V
  }, $ = Z ? C(Z, O) : U, J = Wi(l, $, x, s);
  let Q = J || r, se = null;
  Ji(J) && (se = J, Q = r);
  const R = Hi(Q, se, $, x, L, O, p), M = t ?? L.defaultTransParent;
  return M ? Me(M, v, R) : R;
}
const Gi = {
  type: "3rdParty",
  init(r) {
    Zi(r.options.react), Bi(r);
  }
}, Gr = Un();
class Yi {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(e) {
    e.forEach((t) => {
      this.usedNamespaces[t] || (this.usedNamespaces[t] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
function Qi({
  children: r,
  count: e,
  parent: t,
  i18nKey: s,
  context: n,
  tOptions: i = {},
  values: a,
  defaults: o,
  components: l,
  ns: u,
  i18n: c,
  t: f,
  shouldUnescape: p,
  ...v
}) {
  var k;
  const {
    i18n: x,
    defaultNS: C
  } = Ws(Gr) || {}, L = c || x || Xr(), V = f || (L == null ? void 0 : L.t.bind(L));
  return Xi({
    children: r,
    count: e,
    parent: t,
    i18nKey: s,
    context: n,
    tOptions: i,
    values: a,
    defaults: o,
    components: l,
    ns: u || (V == null ? void 0 : V.ns) || C || ((k = L == null ? void 0 : L.options) == null ? void 0 : k.defaultNS),
    i18n: L,
    t: f,
    shouldUnescape: p,
    ...v
  });
}
const ea = (r, e) => {
  const t = Wr();
  return Et(() => {
    t.current = r;
  }, [r, e]), t.current;
}, an = (r, e, t, s) => r.getFixedT(e, t, s), ta = (r, e, t, s) => Vr(an(r, e, t, s), [r, e, t, s]), gr = (r, e = {}) => {
  var D, Z, P, O;
  const {
    i18n: t
  } = e, {
    i18n: s,
    defaultNS: n
  } = Ws(Gr) || {}, i = t || s || Xr();
  if (i && !i.reportNamespaces && (i.reportNamespaces = new Yi()), !i) {
    Lt(i, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const $ = (Q, se) => Se(se) ? se : qe(se) && Se(se.defaultValue) ? se.defaultValue : Array.isArray(Q) ? Q[Q.length - 1] : Q, J = [$, {}, !1];
    return J.t = $, J.i18n = {}, J.ready = !1, J;
  }
  (D = i.options.react) != null && D.wait && Lt(i, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const a = {
    ...tn(),
    ...i.options.react,
    ...e
  }, {
    useSuspense: o,
    keyPrefix: l
  } = a;
  let u = r || n || ((Z = i.options) == null ? void 0 : Z.defaultNS);
  u = Se(u) ? [u] : u || ["translation"], (O = (P = i.reportNamespaces).addUsedNamespaces) == null || O.call(P, u);
  const c = (i.isInitialized || i.initializedStoreOnce) && u.every(($) => Fi($, i, a)), f = ta(i, e.lng || null, a.nsMode === "fallback" ? u : u[0], l), p = () => f, v = () => an(i, e.lng || null, a.nsMode === "fallback" ? u : u[0], l), [x, C] = Js(p);
  let L = u.join();
  e.lng && (L = `${e.lng}${L}`);
  const V = ea(L), k = Wr(!0);
  Et(() => {
    const {
      bindI18n: $,
      bindI18nStore: J
    } = a;
    k.current = !0, !c && !o && (e.lng ? ps(i, e.lng, u, () => {
      k.current && C(v);
    }) : Ir(i, u, () => {
      k.current && C(v);
    })), c && V && V !== L && k.current && C(v);
    const Q = () => {
      k.current && C(v);
    };
    return $ && (i == null || i.on($, Q)), J && (i == null || i.store.on(J, Q)), () => {
      k.current = !1, i && $ && ($ == null || $.split(" ").forEach((se) => i.off(se, Q))), J && i && J.split(" ").forEach((se) => i.store.off(se, Q));
    };
  }, [i, L]), Et(() => {
    k.current && c && C(p);
  }, [i, l, c]);
  const U = [x, i, c];
  if (U.t = x, U.i18n = i, U.ready = c, c || !c && !o)
    return U;
  throw new Promise(($) => {
    e.lng ? ps(i, e.lng, u, () => $()) : Ir(i, u, () => $());
  });
};
function ra({
  i18n: r,
  defaultNS: e,
  children: t
}) {
  const s = Fr(() => ({
    i18n: r,
    defaultNS: e
  }), [r, e]);
  return Me(Gr.Provider, {
    value: s
  }, t);
}
const sa = "_root_1vqhg_9", na = "_variantLabel_1vqhg_13", ia = "_variantH1_1vqhg_16", aa = "_heading1_1vqhg_19", oa = "_heading2_1vqhg_25", la = "_heading3_1vqhg_31", ua = "_heading4_1vqhg_37", ca = "_heading5_1vqhg_43", da = "_heading6_1vqhg_49", fa = "_hint_1vqhg_115", ha = "_button_1vqhg_121", vt = {
  root: sa,
  variantLabel: na,
  variantH1: ia,
  heading1: aa,
  heading2: oa,
  heading3: la,
  heading4: ua,
  heading5: ca,
  heading6: da,
  "title-lg": "_title-lg_1vqhg_55",
  "title-md": "_title-md_1vqhg_61",
  "sub-lg": "_sub-lg_1vqhg_67",
  "sub-md": "_sub-md_1vqhg_73",
  "body-lg": "_body-lg_1vqhg_79",
  "body-md": "_body-md_1vqhg_85",
  "paragraph-lg": "_paragraph-lg_1vqhg_91",
  "paragraph-md": "_paragraph-md_1vqhg_97",
  "paragraph-sm": "_paragraph-sm_1vqhg_103",
  "status-label": "_status-label_1vqhg_109",
  hint: fa,
  button: ha,
  "color-light": "_color-light_1vqhg_127",
  "color-base": "_color-base_1vqhg_131",
  "color-description": "_color-description_1vqhg_135",
  "color-disabled": "_color-disabled_1vqhg_139",
  "color-inherit": "_color-inherit_1vqhg_143"
}, pa = {
  heading1: "heading1",
  heading2: "heading2",
  heading3: "heading3",
  heading4: "heading4",
  heading5: "heading5",
  heading6: "heading6",
  "title-lg": "title-lg",
  "title-md": "title-md",
  "sub-lg": "sub-lg",
  "sub-md": "sub-md",
  "body-lg": "body-lg",
  "body-md": "body-md",
  "paragraph-lg": "paragraph-lg",
  "paragraph-md": "paragraph-md",
  "paragraph-sm": "paragraph-sm",
  "status-label": "status-label",
  hint: "hint",
  button: "button"
}, ga = {
  light: "color-light",
  base: "color-base",
  description: "color-description",
  disabled: "color-disabled",
  inherit: "color-inherit"
}, ht = ({
  component: r = "p",
  variant: e,
  color: t = "base",
  className: s,
  children: n
}) => /* @__PURE__ */ re(
  r,
  {
    className: de(
      vt.root,
      // ThemeDefinition.typography.root,
      {
        [vt.variantLabel]: e === "label",
        // [ThemeDefinition.typography.label]: variant === 'label',
        [vt.variantH1]: e === "h1",
        // [ThemeDefinition.typography.h1]: variant === 'h1',
        ...Object.fromEntries(
          Object.entries(pa).map(([i, a]) => [vt[a], e === i])
        ),
        ...Object.fromEntries(Object.entries(ga).map(([i, a]) => [vt[a], t === i]))
      },
      s
    ),
    children: n
  }
), z = (r) => typeof r == "string", bt = () => {
  let r, e;
  const t = new Promise((s, n) => {
    r = s, e = n;
  });
  return t.resolve = r, t.reject = e, t;
}, gs = (r) => r == null ? "" : "" + r, ma = (r, e, t) => {
  r.forEach((s) => {
    e[s] && (t[s] = e[s]);
  });
}, ya = /###/g, ms = (r) => r && r.indexOf("###") > -1 ? r.replace(ya, ".") : r, ys = (r) => !r || z(r), kt = (r, e, t) => {
  const s = z(e) ? e.split(".") : e;
  let n = 0;
  for (; n < s.length - 1; ) {
    if (ys(r))
      return {};
    const i = ms(s[n]);
    !r[i] && t && (r[i] = new t()), Object.prototype.hasOwnProperty.call(r, i) ? r = r[i] : r = {}, ++n;
  }
  return ys(r) ? {} : {
    obj: r,
    k: ms(s[n])
  };
}, vs = (r, e, t) => {
  const {
    obj: s,
    k: n
  } = kt(r, e, Object);
  if (s !== void 0 || e.length === 1) {
    s[n] = t;
    return;
  }
  let i = e[e.length - 1], a = e.slice(0, e.length - 1), o = kt(r, a, Object);
  for (; o.obj === void 0 && a.length; )
    i = `${a[a.length - 1]}.${i}`, a = a.slice(0, a.length - 1), o = kt(r, a, Object), o && o.obj && typeof o.obj[`${o.k}.${i}`] < "u" && (o.obj = void 0);
  o.obj[`${o.k}.${i}`] = t;
}, va = (r, e, t, s) => {
  const {
    obj: n,
    k: i
  } = kt(r, e, Object);
  n[i] = n[i] || [], n[i].push(t);
}, er = (r, e) => {
  const {
    obj: t,
    k: s
  } = kt(r, e);
  if (t)
    return t[s];
}, ba = (r, e, t) => {
  const s = er(r, t);
  return s !== void 0 ? s : er(e, t);
}, on = (r, e, t) => {
  for (const s in e)
    s !== "__proto__" && s !== "constructor" && (s in r ? z(r[s]) || r[s] instanceof String || z(e[s]) || e[s] instanceof String ? t && (r[s] = e[s]) : on(r[s], e[s], t) : r[s] = e[s]);
  return r;
}, at = (r) => r.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var _a = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const xa = (r) => z(r) ? r.replace(/[&<>"'\/]/g, (e) => _a[e]) : r;
class Ca {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const t = this.regExpMap.get(e);
    if (t !== void 0)
      return t;
    const s = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, s), this.regExpQueue.push(e), s;
  }
}
const wa = [" ", ",", "?", "!", ";"], Sa = new Ca(20), ka = (r, e, t) => {
  e = e || "", t = t || "";
  const s = wa.filter((a) => e.indexOf(a) < 0 && t.indexOf(a) < 0);
  if (s.length === 0)
    return !0;
  const n = Sa.getRegExp(`(${s.map((a) => a === "?" ? "\\?" : a).join("|")})`);
  let i = !n.test(r);
  if (!i) {
    const a = r.indexOf(t);
    a > 0 && !n.test(r.substring(0, a)) && (i = !0);
  }
  return i;
}, $r = function(r, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!r)
    return;
  if (r[e])
    return r[e];
  const s = e.split(t);
  let n = r;
  for (let i = 0; i < s.length; ) {
    if (!n || typeof n != "object")
      return;
    let a, o = "";
    for (let l = i; l < s.length; ++l)
      if (l !== i && (o += t), o += s[l], a = n[o], a !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof a) > -1 && l < s.length - 1)
          continue;
        i += l - i + 1;
        break;
      }
    n = a;
  }
  return n;
}, tr = (r) => r && r.replace("_", "-"), Oa = {
  type: "logger",
  log(r) {
    this.output("log", r);
  },
  warn(r) {
    this.output("warn", r);
  },
  error(r) {
    this.output("error", r);
  },
  output(r, e) {
    console && console[r] && console[r].apply(console, e);
  }
};
class rr {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, t);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = t.prefix || "i18next:", this.logger = e || Oa, this.options = t, this.debug = t.debug;
  }
  log() {
    for (var e = arguments.length, t = new Array(e), s = 0; s < e; s++)
      t[s] = arguments[s];
    return this.forward(t, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, t = new Array(e), s = 0; s < e; s++)
      t[s] = arguments[s];
    return this.forward(t, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, t = new Array(e), s = 0; s < e; s++)
      t[s] = arguments[s];
    return this.forward(t, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, t = new Array(e), s = 0; s < e; s++)
      t[s] = arguments[s];
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, t, s, n) {
    return n && !this.debug ? null : (z(e[0]) && (e[0] = `${s}${this.prefix} ${e[0]}`), this.logger[t](e));
  }
  create(e) {
    return new rr(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new rr(this.logger, e);
  }
}
var Re = new rr();
class mr {
  constructor() {
    this.observers = {};
  }
  on(e, t) {
    return e.split(" ").forEach((s) => {
      this.observers[s] || (this.observers[s] = /* @__PURE__ */ new Map());
      const n = this.observers[s].get(t) || 0;
      this.observers[s].set(t, n + 1);
    }), this;
  }
  off(e, t) {
    if (this.observers[e]) {
      if (!t) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(t);
    }
  }
  emit(e) {
    for (var t = arguments.length, s = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
      s[n - 1] = arguments[n];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((a) => {
      let [o, l] = a;
      for (let u = 0; u < l; u++)
        o(...s);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((a) => {
      let [o, l] = a;
      for (let u = 0; u < l; u++)
        o.apply(o, [e, ...s]);
    });
  }
}
class bs extends mr {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const t = this.options.ns.indexOf(e);
    t > -1 && this.options.ns.splice(t, 1);
  }
  getResource(e, t, s) {
    let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, a = n.ignoreJSONStructure !== void 0 ? n.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let o;
    e.indexOf(".") > -1 ? o = e.split(".") : (o = [e, t], s && (Array.isArray(s) ? o.push(...s) : z(s) && i ? o.push(...s.split(i)) : o.push(s)));
    const l = er(this.data, o);
    return !l && !t && !s && e.indexOf(".") > -1 && (e = o[0], t = o[1], s = o.slice(2).join(".")), l || !a || !z(s) ? l : $r(this.data && this.data[e] && this.data[e][t], s, i);
  }
  addResource(e, t, s, n) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const a = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let o = [e, t];
    s && (o = o.concat(a ? s.split(a) : s)), e.indexOf(".") > -1 && (o = e.split("."), n = t, t = o[1]), this.addNamespaces(t), vs(this.data, o, n), i.silent || this.emit("added", e, t, s, n);
  }
  addResources(e, t, s) {
    let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in s)
      (z(s[i]) || Array.isArray(s[i])) && this.addResource(e, t, i, s[i], {
        silent: !0
      });
    n.silent || this.emit("added", e, t, s);
  }
  addResourceBundle(e, t, s, n, i) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, o = [e, t];
    e.indexOf(".") > -1 && (o = e.split("."), n = s, s = t, t = o[1]), this.addNamespaces(t);
    let l = er(this.data, o) || {};
    a.skipCopy || (s = JSON.parse(JSON.stringify(s))), n ? on(l, s, i) : l = {
      ...l,
      ...s
    }, vs(this.data, o, l), a.silent || this.emit("added", e, t, s);
  }
  removeResourceBundle(e, t) {
    this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
  }
  hasResourceBundle(e, t) {
    return this.getResource(e, t) !== void 0;
  }
  getResourceBundle(e, t) {
    return t || (t = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(e, t)
    } : this.getResource(e, t);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const t = this.getDataByLanguage(e);
    return !!(t && Object.keys(t) || []).find((n) => t[n] && Object.keys(t[n]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var ln = {
  processors: {},
  addPostProcessor(r) {
    this.processors[r.name] = r;
  },
  handle(r, e, t, s, n) {
    return r.forEach((i) => {
      this.processors[i] && (e = this.processors[i].process(e, t, s, n));
    }), e;
  }
};
const _s = {};
class sr extends mr {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), ma(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Re.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (e == null)
      return !1;
    const s = this.resolve(e, t);
    return s && s.res !== void 0;
  }
  extractFromKey(e, t) {
    let s = t.nsSeparator !== void 0 ? t.nsSeparator : this.options.nsSeparator;
    s === void 0 && (s = ":");
    const n = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator;
    let i = t.ns || this.options.defaultNS || [];
    const a = s && e.indexOf(s) > -1, o = !this.options.userDefinedKeySeparator && !t.keySeparator && !this.options.userDefinedNsSeparator && !t.nsSeparator && !ka(e, s, n);
    if (a && !o) {
      const l = e.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: e,
          namespaces: z(i) ? [i] : i
        };
      const u = e.split(s);
      (s !== n || s === n && this.options.ns.indexOf(u[0]) > -1) && (i = u.shift()), e = u.join(n);
    }
    return {
      key: e,
      namespaces: z(i) ? [i] : i
    };
  }
  translate(e, t, s) {
    if (typeof t != "object" && this.options.overloadTranslationOptionHandler && (t = this.options.overloadTranslationOptionHandler(arguments)), typeof t == "object" && (t = {
      ...t
    }), t || (t = {}), e == null)
      return "";
    Array.isArray(e) || (e = [String(e)]);
    const n = t.returnDetails !== void 0 ? t.returnDetails : this.options.returnDetails, i = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator, {
      key: a,
      namespaces: o
    } = this.extractFromKey(e[e.length - 1], t), l = o[o.length - 1], u = t.lng || this.language, c = t.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (u && u.toLowerCase() === "cimode") {
      if (c) {
        const D = t.nsSeparator || this.options.nsSeparator;
        return n ? {
          res: `${l}${D}${a}`,
          usedKey: a,
          exactUsedKey: a,
          usedLng: u,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(t)
        } : `${l}${D}${a}`;
      }
      return n ? {
        res: a,
        usedKey: a,
        exactUsedKey: a,
        usedLng: u,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(t)
      } : a;
    }
    const f = this.resolve(e, t);
    let p = f && f.res;
    const v = f && f.usedKey || a, x = f && f.exactUsedKey || a, C = Object.prototype.toString.apply(p), L = ["[object Number]", "[object Function]", "[object RegExp]"], V = t.joinArrays !== void 0 ? t.joinArrays : this.options.joinArrays, k = !this.i18nFormat || this.i18nFormat.handleAsObject, U = !z(p) && typeof p != "boolean" && typeof p != "number";
    if (k && p && U && L.indexOf(C) < 0 && !(z(V) && Array.isArray(p))) {
      if (!t.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const D = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(v, p, {
          ...t,
          ns: o
        }) : `key '${a} (${this.language})' returned an object instead of string.`;
        return n ? (f.res = D, f.usedParams = this.getUsedParamsDetails(t), f) : D;
      }
      if (i) {
        const D = Array.isArray(p), Z = D ? [] : {}, P = D ? x : v;
        for (const O in p)
          if (Object.prototype.hasOwnProperty.call(p, O)) {
            const $ = `${P}${i}${O}`;
            Z[O] = this.translate($, {
              ...t,
              joinArrays: !1,
              ns: o
            }), Z[O] === $ && (Z[O] = p[O]);
          }
        p = Z;
      }
    } else if (k && z(V) && Array.isArray(p))
      p = p.join(V), p && (p = this.extendTranslation(p, e, t, s));
    else {
      let D = !1, Z = !1;
      const P = t.count !== void 0 && !z(t.count), O = sr.hasDefaultValue(t), $ = P ? this.pluralResolver.getSuffix(u, t.count, t) : "", J = t.ordinal && P ? this.pluralResolver.getSuffix(u, t.count, {
        ordinal: !1
      }) : "", Q = P && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), se = Q && t[`defaultValue${this.options.pluralSeparator}zero`] || t[`defaultValue${$}`] || t[`defaultValue${J}`] || t.defaultValue;
      !this.isValidLookup(p) && O && (D = !0, p = se), this.isValidLookup(p) || (Z = !0, p = a);
      const M = (t.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && Z ? void 0 : p, ee = O && se !== p && this.options.updateMissing;
      if (Z || D || ee) {
        if (this.logger.log(ee ? "updateKey" : "missingKey", u, l, a, ee ? se : p), i) {
          const j = this.resolve(a, {
            ...t,
            keySeparator: !1
          });
          j && j.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let h = [];
        const y = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && y && y[0])
          for (let j = 0; j < y.length; j++)
            h.push(y[j]);
        else
          this.options.saveMissingTo === "all" ? h = this.languageUtils.toResolveHierarchy(t.lng || this.language) : h.push(t.lng || this.language);
        const I = (j, G, K) => {
          const Ae = O && K !== p ? K : M;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(j, l, G, Ae, ee, t) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(j, l, G, Ae, ee, t), this.emit("missingKey", j, l, G, p);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && P ? h.forEach((j) => {
          const G = this.pluralResolver.getSuffixes(j, t);
          Q && t[`defaultValue${this.options.pluralSeparator}zero`] && G.indexOf(`${this.options.pluralSeparator}zero`) < 0 && G.push(`${this.options.pluralSeparator}zero`), G.forEach((K) => {
            I([j], a + K, t[`defaultValue${K}`] || se);
          });
        }) : I(h, a, se));
      }
      p = this.extendTranslation(p, e, t, f, s), Z && p === a && this.options.appendNamespaceToMissingKey && (p = `${l}:${a}`), (Z || D) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? p = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${a}` : a, D ? p : void 0) : p = this.options.parseMissingKeyHandler(p));
    }
    return n ? (f.res = p, f.usedParams = this.getUsedParamsDetails(t), f) : p;
  }
  extendTranslation(e, t, s, n, i) {
    var a = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...s
      }, s.lng || this.language || n.usedLng, n.usedNS, n.usedKey, {
        resolved: n
      });
    else if (!s.skipInterpolation) {
      s.interpolation && this.interpolator.init({
        ...s,
        interpolation: {
          ...this.options.interpolation,
          ...s.interpolation
        }
      });
      const u = z(e) && (s && s.interpolation && s.interpolation.skipOnVariables !== void 0 ? s.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let c;
      if (u) {
        const p = e.match(this.interpolator.nestingRegexp);
        c = p && p.length;
      }
      let f = s.replace && !z(s.replace) ? s.replace : s;
      if (this.options.interpolation.defaultVariables && (f = {
        ...this.options.interpolation.defaultVariables,
        ...f
      }), e = this.interpolator.interpolate(e, f, s.lng || this.language || n.usedLng, s), u) {
        const p = e.match(this.interpolator.nestingRegexp), v = p && p.length;
        c < v && (s.nest = !1);
      }
      !s.lng && this.options.compatibilityAPI !== "v1" && n && n.res && (s.lng = this.language || n.usedLng), s.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var p = arguments.length, v = new Array(p), x = 0; x < p; x++)
          v[x] = arguments[x];
        return i && i[0] === v[0] && !s.context ? (a.logger.warn(`It seems you are nesting recursively key: ${v[0]} in key: ${t[0]}`), null) : a.translate(...v, t);
      }, s)), s.interpolation && this.interpolator.reset();
    }
    const o = s.postProcess || this.options.postProcess, l = z(o) ? [o] : o;
    return e != null && l && l.length && s.applyPostProcessor !== !1 && (e = ln.handle(l, e, t, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...n,
        usedParams: this.getUsedParamsDetails(s)
      },
      ...s
    } : s, this)), e;
  }
  resolve(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s, n, i, a, o;
    return z(e) && (e = [e]), e.forEach((l) => {
      if (this.isValidLookup(s))
        return;
      const u = this.extractFromKey(l, t), c = u.key;
      n = c;
      let f = u.namespaces;
      this.options.fallbackNS && (f = f.concat(this.options.fallbackNS));
      const p = t.count !== void 0 && !z(t.count), v = p && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), x = t.context !== void 0 && (z(t.context) || typeof t.context == "number") && t.context !== "", C = t.lngs ? t.lngs : this.languageUtils.toResolveHierarchy(t.lng || this.language, t.fallbackLng);
      f.forEach((L) => {
        this.isValidLookup(s) || (o = L, !_s[`${C[0]}-${L}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(o) && (_s[`${C[0]}-${L}`] = !0, this.logger.warn(`key "${n}" for languages "${C.join(", ")}" won't get resolved as namespace "${o}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), C.forEach((V) => {
          if (this.isValidLookup(s))
            return;
          a = V;
          const k = [c];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(k, c, V, L, t);
          else {
            let D;
            p && (D = this.pluralResolver.getSuffix(V, t.count, t));
            const Z = `${this.options.pluralSeparator}zero`, P = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (p && (k.push(c + D), t.ordinal && D.indexOf(P) === 0 && k.push(c + D.replace(P, this.options.pluralSeparator)), v && k.push(c + Z)), x) {
              const O = `${c}${this.options.contextSeparator}${t.context}`;
              k.push(O), p && (k.push(O + D), t.ordinal && D.indexOf(P) === 0 && k.push(O + D.replace(P, this.options.pluralSeparator)), v && k.push(O + Z));
            }
          }
          let U;
          for (; U = k.pop(); )
            this.isValidLookup(s) || (i = U, s = this.getResource(V, L, U, t));
        }));
      });
    }), {
      res: s,
      usedKey: n,
      exactUsedKey: i,
      usedLng: a,
      usedNS: o
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, t, s) {
    let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, t, s, n) : this.resourceStore.getResource(e, t, s, n);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const t = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], s = e.replace && !z(e.replace);
    let n = s ? e.replace : e;
    if (s && typeof e.count < "u" && (n.count = e.count), this.options.interpolation.defaultVariables && (n = {
      ...this.options.interpolation.defaultVariables,
      ...n
    }), !s) {
      n = {
        ...n
      };
      for (const i of t)
        delete n[i];
    }
    return n;
  }
  static hasDefaultValue(e) {
    const t = "defaultValue";
    for (const s in e)
      if (Object.prototype.hasOwnProperty.call(e, s) && t === s.substring(0, t.length) && e[s] !== void 0)
        return !0;
    return !1;
  }
}
const Lr = (r) => r.charAt(0).toUpperCase() + r.slice(1);
class xs {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Re.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = tr(e), !e || e.indexOf("-") < 0)
      return null;
    const t = e.split("-");
    return t.length === 2 || (t.pop(), t[t.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(t.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = tr(e), !e || e.indexOf("-") < 0)
      return e;
    const t = e.split("-");
    return this.formatLanguageCode(t[0]);
  }
  formatLanguageCode(e) {
    if (z(e) && e.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let n = Intl.getCanonicalLocales(e)[0];
          if (n && this.options.lowerCaseLng && (n = n.toLowerCase()), n)
            return n;
        } catch {
        }
      const t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let s = e.split("-");
      return this.options.lowerCaseLng ? s = s.map((n) => n.toLowerCase()) : s.length === 2 ? (s[0] = s[0].toLowerCase(), s[1] = s[1].toUpperCase(), t.indexOf(s[1].toLowerCase()) > -1 && (s[1] = Lr(s[1].toLowerCase()))) : s.length === 3 && (s[0] = s[0].toLowerCase(), s[1].length === 2 && (s[1] = s[1].toUpperCase()), s[0] !== "sgn" && s[2].length === 2 && (s[2] = s[2].toUpperCase()), t.indexOf(s[1].toLowerCase()) > -1 && (s[1] = Lr(s[1].toLowerCase())), t.indexOf(s[2].toLowerCase()) > -1 && (s[2] = Lr(s[2].toLowerCase()))), s.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e)
      return null;
    let t;
    return e.forEach((s) => {
      if (t)
        return;
      const n = this.formatLanguageCode(s);
      (!this.options.supportedLngs || this.isSupportedCode(n)) && (t = n);
    }), !t && this.options.supportedLngs && e.forEach((s) => {
      if (t)
        return;
      const n = this.getLanguagePartFromCode(s);
      if (this.isSupportedCode(n))
        return t = n;
      t = this.options.supportedLngs.find((i) => {
        if (i === n)
          return i;
        if (!(i.indexOf("-") < 0 && n.indexOf("-") < 0) && (i.indexOf("-") > 0 && n.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === n || i.indexOf(n) === 0 && n.length > 1))
          return i;
      });
    }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t;
  }
  getFallbackCodes(e, t) {
    if (!e)
      return [];
    if (typeof e == "function" && (e = e(t)), z(e) && (e = [e]), Array.isArray(e))
      return e;
    if (!t)
      return e.default || [];
    let s = e[t];
    return s || (s = e[this.getScriptPartFromCode(t)]), s || (s = e[this.formatLanguageCode(t)]), s || (s = e[this.getLanguagePartFromCode(t)]), s || (s = e.default), s || [];
  }
  toResolveHierarchy(e, t) {
    const s = this.getFallbackCodes(t || this.options.fallbackLng || [], e), n = [], i = (a) => {
      a && (this.isSupportedCode(a) ? n.push(a) : this.logger.warn(`rejecting language code not found in supportedLngs: ${a}`));
    };
    return z(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(e))) : z(e) && i(this.formatLanguageCode(e)), s.forEach((a) => {
      n.indexOf(a) < 0 && i(this.formatLanguageCode(a));
    }), n;
  }
}
let Ea = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], La = {
  1: (r) => +(r > 1),
  2: (r) => +(r != 1),
  3: (r) => 0,
  4: (r) => r % 10 == 1 && r % 100 != 11 ? 0 : r % 10 >= 2 && r % 10 <= 4 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2,
  5: (r) => r == 0 ? 0 : r == 1 ? 1 : r == 2 ? 2 : r % 100 >= 3 && r % 100 <= 10 ? 3 : r % 100 >= 11 ? 4 : 5,
  6: (r) => r == 1 ? 0 : r >= 2 && r <= 4 ? 1 : 2,
  7: (r) => r == 1 ? 0 : r % 10 >= 2 && r % 10 <= 4 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2,
  8: (r) => r == 1 ? 0 : r == 2 ? 1 : r != 8 && r != 11 ? 2 : 3,
  9: (r) => +(r >= 2),
  10: (r) => r == 1 ? 0 : r == 2 ? 1 : r < 7 ? 2 : r < 11 ? 3 : 4,
  11: (r) => r == 1 || r == 11 ? 0 : r == 2 || r == 12 ? 1 : r > 2 && r < 20 ? 2 : 3,
  12: (r) => +(r % 10 != 1 || r % 100 == 11),
  13: (r) => +(r !== 0),
  14: (r) => r == 1 ? 0 : r == 2 ? 1 : r == 3 ? 2 : 3,
  15: (r) => r % 10 == 1 && r % 100 != 11 ? 0 : r % 10 >= 2 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2,
  16: (r) => r % 10 == 1 && r % 100 != 11 ? 0 : r !== 0 ? 1 : 2,
  17: (r) => r == 1 || r % 10 == 1 && r % 100 != 11 ? 0 : 1,
  18: (r) => r == 0 ? 0 : r == 1 ? 1 : 2,
  19: (r) => r == 1 ? 0 : r == 0 || r % 100 > 1 && r % 100 < 11 ? 1 : r % 100 > 10 && r % 100 < 20 ? 2 : 3,
  20: (r) => r == 1 ? 0 : r == 0 || r % 100 > 0 && r % 100 < 20 ? 1 : 2,
  21: (r) => r % 100 == 1 ? 1 : r % 100 == 2 ? 2 : r % 100 == 3 || r % 100 == 4 ? 3 : 0,
  22: (r) => r == 1 ? 0 : r == 2 ? 1 : (r < 0 || r > 10) && r % 10 == 0 ? 2 : 3
};
const Aa = ["v1", "v2", "v3"], Ta = ["v4"], Cs = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Na = () => {
  const r = {};
  return Ea.forEach((e) => {
    e.lngs.forEach((t) => {
      r[t] = {
        numbers: e.nr,
        plurals: La[e.fc]
      };
    });
  }), r;
};
class Ra {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = t, this.logger = Re.create("pluralResolver"), (!this.options.compatibilityJSON || Ta.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Na(), this.pluralRulesCache = {};
  }
  addRule(e, t) {
    this.rules[e] = t;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const s = tr(e === "dev" ? "en" : e), n = t.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({
        cleanedCode: s,
        type: n
      });
      if (i in this.pluralRulesCache)
        return this.pluralRulesCache[i];
      let a;
      try {
        a = new Intl.PluralRules(s, {
          type: n
        });
      } catch {
        if (!e.match(/-|_/))
          return;
        const l = this.languageUtils.getLanguagePartFromCode(e);
        a = this.getRule(l, t);
      }
      return this.pluralRulesCache[i] = a, a;
    }
    return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
  }
  needsPlural(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const s = this.getRule(e, t);
    return this.shouldUseIntlApi() ? s && s.resolvedOptions().pluralCategories.length > 1 : s && s.numbers.length > 1;
  }
  getPluralFormsOfKey(e, t) {
    let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, s).map((n) => `${t}${n}`);
  }
  getSuffixes(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const s = this.getRule(e, t);
    return s ? this.shouldUseIntlApi() ? s.resolvedOptions().pluralCategories.sort((n, i) => Cs[n] - Cs[i]).map((n) => `${this.options.prepend}${t.ordinal ? `ordinal${this.options.prepend}` : ""}${n}`) : s.numbers.map((n) => this.getSuffix(e, n, t)) : [];
  }
  getSuffix(e, t) {
    let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const n = this.getRule(e, s);
    return n ? this.shouldUseIntlApi() ? `${this.options.prepend}${s.ordinal ? `ordinal${this.options.prepend}` : ""}${n.select(t)}` : this.getSuffixRetroCompatible(n, t) : (this.logger.warn(`no plural rule found for: ${e}`), "");
  }
  getSuffixRetroCompatible(e, t) {
    const s = e.noAbs ? e.plurals(t) : e.plurals(Math.abs(t));
    let n = e.numbers[s];
    this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 && (n === 2 ? n = "plural" : n === 1 && (n = ""));
    const i = () => this.options.prepend && n.toString() ? this.options.prepend + n.toString() : n.toString();
    return this.options.compatibilityJSON === "v1" ? n === 1 ? "" : typeof n == "number" ? `_plural_${n.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 ? i() : this.options.prepend && s.toString() ? this.options.prepend + s.toString() : s.toString();
  }
  shouldUseIntlApi() {
    return !Aa.includes(this.options.compatibilityJSON);
  }
}
const ws = function(r, e, t) {
  let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", n = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = ba(r, e, t);
  return !i && n && z(t) && (i = $r(r, t, s), i === void 0 && (i = $r(e, t, s))), i;
}, Ar = (r) => r.replace(/\$/g, "$$$$");
class Pa {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Re.create("interpolator"), this.options = e, this.format = e.interpolation && e.interpolation.format || ((t) => t), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: t,
      escapeValue: s,
      useRawValueToEscape: n,
      prefix: i,
      prefixEscaped: a,
      suffix: o,
      suffixEscaped: l,
      formatSeparator: u,
      unescapeSuffix: c,
      unescapePrefix: f,
      nestingPrefix: p,
      nestingPrefixEscaped: v,
      nestingSuffix: x,
      nestingSuffixEscaped: C,
      nestingOptionsSeparator: L,
      maxReplaces: V,
      alwaysFormat: k
    } = e.interpolation;
    this.escape = t !== void 0 ? t : xa, this.escapeValue = s !== void 0 ? s : !0, this.useRawValueToEscape = n !== void 0 ? n : !1, this.prefix = i ? at(i) : a || "{{", this.suffix = o ? at(o) : l || "}}", this.formatSeparator = u || ",", this.unescapePrefix = c ? "" : f || "-", this.unescapeSuffix = this.unescapePrefix ? "" : c || "", this.nestingPrefix = p ? at(p) : v || at("$t("), this.nestingSuffix = x ? at(x) : C || at(")"), this.nestingOptionsSeparator = L || ",", this.maxReplaces = V || 1e3, this.alwaysFormat = k !== void 0 ? k : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (t, s) => t && t.source === s ? (t.lastIndex = 0, t) : new RegExp(s, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, t, s, n) {
    let i, a, o;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, u = (v) => {
      if (v.indexOf(this.formatSeparator) < 0) {
        const V = ws(t, l, v, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(V, void 0, s, {
          ...n,
          ...t,
          interpolationkey: v
        }) : V;
      }
      const x = v.split(this.formatSeparator), C = x.shift().trim(), L = x.join(this.formatSeparator).trim();
      return this.format(ws(t, l, C, this.options.keySeparator, this.options.ignoreJSONStructure), L, s, {
        ...n,
        ...t,
        interpolationkey: C
      });
    };
    this.resetRegExp();
    const c = n && n.missingInterpolationHandler || this.options.missingInterpolationHandler, f = n && n.interpolation && n.interpolation.skipOnVariables !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (v) => Ar(v)
    }, {
      regex: this.regexp,
      safeValue: (v) => this.escapeValue ? Ar(this.escape(v)) : Ar(v)
    }].forEach((v) => {
      for (o = 0; i = v.regex.exec(e); ) {
        const x = i[1].trim();
        if (a = u(x), a === void 0)
          if (typeof c == "function") {
            const L = c(e, i, n);
            a = z(L) ? L : "";
          } else if (n && Object.prototype.hasOwnProperty.call(n, x))
            a = "";
          else if (f) {
            a = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${x} for interpolating ${e}`), a = "";
        else
          !z(a) && !this.useRawValueToEscape && (a = gs(a));
        const C = v.safeValue(a);
        if (e = e.replace(i[0], C), f ? (v.regex.lastIndex += a.length, v.regex.lastIndex -= i[0].length) : v.regex.lastIndex = 0, o++, o >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, t) {
    let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n, i, a;
    const o = (l, u) => {
      const c = this.nestingOptionsSeparator;
      if (l.indexOf(c) < 0)
        return l;
      const f = l.split(new RegExp(`${c}[ ]*{`));
      let p = `{${f[1]}`;
      l = f[0], p = this.interpolate(p, a);
      const v = p.match(/'/g), x = p.match(/"/g);
      (v && v.length % 2 === 0 && !x || x.length % 2 !== 0) && (p = p.replace(/'/g, '"'));
      try {
        a = JSON.parse(p), u && (a = {
          ...u,
          ...a
        });
      } catch (C) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, C), `${l}${c}${p}`;
      }
      return a.defaultValue && a.defaultValue.indexOf(this.prefix) > -1 && delete a.defaultValue, l;
    };
    for (; n = this.nestingRegexp.exec(e); ) {
      let l = [];
      a = {
        ...s
      }, a = a.replace && !z(a.replace) ? a.replace : a, a.applyPostProcessor = !1, delete a.defaultValue;
      let u = !1;
      if (n[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(n[1])) {
        const c = n[1].split(this.formatSeparator).map((f) => f.trim());
        n[1] = c.shift(), l = c, u = !0;
      }
      if (i = t(o.call(this, n[1].trim(), a), a), i && n[0] === e && !z(i))
        return i;
      z(i) || (i = gs(i)), i || (this.logger.warn(`missed to resolve ${n[1]} for nesting ${e}`), i = ""), u && (i = l.reduce((c, f) => this.format(c, f, s.lng, {
        ...s,
        interpolationkey: n[1].trim()
      }), i.trim())), e = e.replace(n[0], i), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const ja = (r) => {
  let e = r.toLowerCase().trim();
  const t = {};
  if (r.indexOf("(") > -1) {
    const s = r.split("(");
    e = s[0].toLowerCase().trim();
    const n = s[1].substring(0, s[1].length - 1);
    e === "currency" && n.indexOf(":") < 0 ? t.currency || (t.currency = n.trim()) : e === "relativetime" && n.indexOf(":") < 0 ? t.range || (t.range = n.trim()) : n.split(";").forEach((a) => {
      if (a) {
        const [o, ...l] = a.split(":"), u = l.join(":").trim().replace(/^'+|'+$/g, ""), c = o.trim();
        t[c] || (t[c] = u), u === "false" && (t[c] = !1), u === "true" && (t[c] = !0), isNaN(u) || (t[c] = parseInt(u, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: t
  };
}, ot = (r) => {
  const e = {};
  return (t, s, n) => {
    let i = n;
    n && n.interpolationkey && n.formatParams && n.formatParams[n.interpolationkey] && n[n.interpolationkey] && (i = {
      ...i,
      [n.interpolationkey]: void 0
    });
    const a = s + JSON.stringify(i);
    let o = e[a];
    return o || (o = r(tr(s), n), e[a] = o), o(t);
  };
};
class Va {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Re.create("formatter"), this.options = e, this.formats = {
      number: ot((t, s) => {
        const n = new Intl.NumberFormat(t, {
          ...s
        });
        return (i) => n.format(i);
      }),
      currency: ot((t, s) => {
        const n = new Intl.NumberFormat(t, {
          ...s,
          style: "currency"
        });
        return (i) => n.format(i);
      }),
      datetime: ot((t, s) => {
        const n = new Intl.DateTimeFormat(t, {
          ...s
        });
        return (i) => n.format(i);
      }),
      relativetime: ot((t, s) => {
        const n = new Intl.RelativeTimeFormat(t, {
          ...s
        });
        return (i) => n.format(i, s.range || "day");
      }),
      list: ot((t, s) => {
        const n = new Intl.ListFormat(t, {
          ...s
        });
        return (i) => n.format(i);
      })
    }, this.init(e);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = t.interpolation.formatSeparator || ",";
  }
  add(e, t) {
    this.formats[e.toLowerCase().trim()] = t;
  }
  addCached(e, t) {
    this.formats[e.toLowerCase().trim()] = ot(t);
  }
  format(e, t, s) {
    let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = t.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((o) => o.indexOf(")") > -1)) {
      const o = i.findIndex((l) => l.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, o)].join(this.formatSeparator);
    }
    return i.reduce((o, l) => {
      const {
        formatName: u,
        formatOptions: c
      } = ja(l);
      if (this.formats[u]) {
        let f = o;
        try {
          const p = n && n.formatParams && n.formatParams[n.interpolationkey] || {}, v = p.locale || p.lng || n.locale || n.lng || s;
          f = this.formats[u](o, v, {
            ...c,
            ...n,
            ...p
          });
        } catch (p) {
          this.logger.warn(p);
        }
        return f;
      } else
        this.logger.warn(`there was no format function for ${u}`);
      return o;
    }, e);
  }
}
const Fa = (r, e) => {
  r.pending[e] !== void 0 && (delete r.pending[e], r.pendingCount--);
};
class Ia extends mr {
  constructor(e, t, s) {
    let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = t, this.services = s, this.languageUtils = s.languageUtils, this.options = n, this.logger = Re.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = n.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = n.maxRetries >= 0 ? n.maxRetries : 5, this.retryTimeout = n.retryTimeout >= 1 ? n.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(s, n.backend, n);
  }
  queueLoad(e, t, s, n) {
    const i = {}, a = {}, o = {}, l = {};
    return e.forEach((u) => {
      let c = !0;
      t.forEach((f) => {
        const p = `${u}|${f}`;
        !s.reload && this.store.hasResourceBundle(u, f) ? this.state[p] = 2 : this.state[p] < 0 || (this.state[p] === 1 ? a[p] === void 0 && (a[p] = !0) : (this.state[p] = 1, c = !1, a[p] === void 0 && (a[p] = !0), i[p] === void 0 && (i[p] = !0), l[f] === void 0 && (l[f] = !0)));
      }), c || (o[u] = !0);
    }), (Object.keys(i).length || Object.keys(a).length) && this.queue.push({
      pending: a,
      pendingCount: Object.keys(a).length,
      loaded: {},
      errors: [],
      callback: n
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(a),
      toLoadLanguages: Object.keys(o),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(e, t, s) {
    const n = e.split("|"), i = n[0], a = n[1];
    t && this.emit("failedLoading", i, a, t), !t && s && this.store.addResourceBundle(i, a, s, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = t ? -1 : 2, t && s && (this.state[e] = 0);
    const o = {};
    this.queue.forEach((l) => {
      va(l.loaded, [i], a), Fa(l, e), t && l.errors.push(t), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((u) => {
        o[u] || (o[u] = {});
        const c = l.loaded[u];
        c.length && c.forEach((f) => {
          o[u][f] === void 0 && (o[u][f] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", o), this.queue = this.queue.filter((l) => !l.done);
  }
  read(e, t, s) {
    let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, a = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length)
      return a(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: t,
        fcName: s,
        tried: n,
        wait: i,
        callback: a
      });
      return;
    }
    this.readingCalls++;
    const o = (u, c) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const f = this.waitingReads.shift();
        this.read(f.lng, f.ns, f.fcName, f.tried, f.wait, f.callback);
      }
      if (u && c && n < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, t, s, n + 1, i * 2, a);
        }, i);
        return;
      }
      a(u, c);
    }, l = this.backend[s].bind(this.backend);
    if (l.length === 2) {
      try {
        const u = l(e, t);
        u && typeof u.then == "function" ? u.then((c) => o(null, c)).catch(o) : o(null, u);
      } catch (u) {
        o(u);
      }
      return;
    }
    return l(e, t, o);
  }
  prepareLoading(e, t) {
    let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), n && n();
    z(e) && (e = this.languageUtils.toResolveHierarchy(e)), z(t) && (t = [t]);
    const i = this.queueLoad(e, t, s, n);
    if (!i.toLoad.length)
      return i.pending.length || n(), null;
    i.toLoad.forEach((a) => {
      this.loadOne(a);
    });
  }
  load(e, t, s) {
    this.prepareLoading(e, t, {}, s);
  }
  reload(e, t, s) {
    this.prepareLoading(e, t, {
      reload: !0
    }, s);
  }
  loadOne(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const s = e.split("|"), n = s[0], i = s[1];
    this.read(n, i, "read", void 0, void 0, (a, o) => {
      a && this.logger.warn(`${t}loading namespace ${i} for language ${n} failed`, a), !a && o && this.logger.log(`${t}loaded namespace ${i} for language ${n}`, o), this.loaded(e, a, o);
    });
  }
  saveMissing(e, t, s, n, i) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t)) {
      this.logger.warn(`did not save key "${s}" as the namespace "${t}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(s == null || s === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...a,
          isUpdate: i
        }, u = this.backend.create.bind(this.backend);
        if (u.length < 6)
          try {
            let c;
            u.length === 5 ? c = u(e, t, s, n, l) : c = u(e, t, s, n), c && typeof c.then == "function" ? c.then((f) => o(null, f)).catch(o) : o(null, c);
          } catch (c) {
            o(c);
          }
        else
          u(e, t, s, n, o, l);
      }
      !e || !e[0] || this.store.addResource(e[0], t, s, n);
    }
  }
}
const Ss = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (r) => {
    let e = {};
    if (typeof r[1] == "object" && (e = r[1]), z(r[1]) && (e.defaultValue = r[1]), z(r[2]) && (e.tDescription = r[2]), typeof r[2] == "object" || typeof r[3] == "object") {
      const t = r[3] || r[2];
      Object.keys(t).forEach((s) => {
        e[s] = t[s];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (r) => r,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), ks = (r) => (z(r.ns) && (r.ns = [r.ns]), z(r.fallbackLng) && (r.fallbackLng = [r.fallbackLng]), z(r.fallbackNS) && (r.fallbackNS = [r.fallbackNS]), r.supportedLngs && r.supportedLngs.indexOf("cimode") < 0 && (r.supportedLngs = r.supportedLngs.concat(["cimode"])), r), Wt = () => {
}, Da = (r) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(r)).forEach((t) => {
    typeof r[t] == "function" && (r[t] = r[t].bind(r));
  });
};
class At extends mr {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = ks(e), this.services = {}, this.logger = Re, this.modules = {
      external: []
    }, Da(this), t && !this.isInitialized && !e.isClone) {
      if (!this.options.initImmediate)
        return this.init(e, t), this;
      setTimeout(() => {
        this.init(e, t);
      }, 0);
    }
  }
  init() {
    var e = this;
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof t == "function" && (s = t, t = {}), !t.defaultNS && t.defaultNS !== !1 && t.ns && (z(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const n = Ss();
    this.options = {
      ...n,
      ...this.options,
      ...ks(t)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...n.interpolation,
      ...this.options.interpolation
    }), t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const i = (c) => c ? typeof c == "function" ? new c() : c : null;
    if (!this.options.isClone) {
      this.modules.logger ? Re.init(i(this.modules.logger), this.options) : Re.init(null, this.options);
      let c;
      this.modules.formatter ? c = this.modules.formatter : typeof Intl < "u" && (c = Va);
      const f = new xs(this.options);
      this.store = new bs(this.options.resources, this.options);
      const p = this.services;
      p.logger = Re, p.resourceStore = this.store, p.languageUtils = f, p.pluralResolver = new Ra(f, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), c && (!this.options.interpolation.format || this.options.interpolation.format === n.interpolation.format) && (p.formatter = i(c), p.formatter.init(p, this.options), this.options.interpolation.format = p.formatter.format.bind(p.formatter)), p.interpolator = new Pa(this.options), p.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, p.backendConnector = new Ia(i(this.modules.backend), p.resourceStore, p, this.options), p.backendConnector.on("*", function(v) {
        for (var x = arguments.length, C = new Array(x > 1 ? x - 1 : 0), L = 1; L < x; L++)
          C[L - 1] = arguments[L];
        e.emit(v, ...C);
      }), this.modules.languageDetector && (p.languageDetector = i(this.modules.languageDetector), p.languageDetector.init && p.languageDetector.init(p, this.options.detection, this.options)), this.modules.i18nFormat && (p.i18nFormat = i(this.modules.i18nFormat), p.i18nFormat.init && p.i18nFormat.init(this)), this.translator = new sr(this.services, this.options), this.translator.on("*", function(v) {
        for (var x = arguments.length, C = new Array(x > 1 ? x - 1 : 0), L = 1; L < x; L++)
          C[L - 1] = arguments[L];
        e.emit(v, ...C);
      }), this.modules.external.forEach((v) => {
        v.init && v.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, s || (s = Wt), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const c = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      c.length > 0 && c[0] !== "dev" && (this.options.lng = c[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((c) => {
      this[c] = function() {
        return e.store[c](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((c) => {
      this[c] = function() {
        return e.store[c](...arguments), e;
      };
    });
    const l = bt(), u = () => {
      const c = (f, p) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(p), s(f, p);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return c(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, c);
    };
    return this.options.resources || !this.options.initImmediate ? u() : setTimeout(u, 0), l;
  }
  loadResources(e) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Wt;
    const n = z(e) ? e : this.language;
    if (typeof e == "function" && (s = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (n && n.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return s();
      const i = [], a = (o) => {
        if (!o || o === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(o).forEach((u) => {
          u !== "cimode" && i.indexOf(u) < 0 && i.push(u);
        });
      };
      n ? a(n) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => a(l)), this.options.preload && this.options.preload.forEach((o) => a(o)), this.services.backendConnector.load(i, this.options.ns, (o) => {
        !o && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), s(o);
      });
    } else
      s(null);
  }
  reloadResources(e, t, s) {
    const n = bt();
    return typeof e == "function" && (s = e, e = void 0), typeof t == "function" && (s = t, t = void 0), e || (e = this.languages), t || (t = this.options.ns), s || (s = Wt), this.services.backendConnector.reload(e, t, (i) => {
      n.resolve(), s(i);
    }), n;
  }
  use(e) {
    if (!e)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && ln.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let t = 0; t < this.languages.length; t++) {
        const s = this.languages[t];
        if (!(["cimode", "dev"].indexOf(s) > -1) && this.store.hasLanguageSomeTranslations(s)) {
          this.resolvedLanguage = s;
          break;
        }
      }
  }
  changeLanguage(e, t) {
    var s = this;
    this.isLanguageChangingTo = e;
    const n = bt();
    this.emit("languageChanging", e);
    const i = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, a = (l, u) => {
      u ? (i(u), this.translator.changeLanguage(u), this.isLanguageChangingTo = void 0, this.emit("languageChanged", u), this.logger.log("languageChanged", u)) : this.isLanguageChangingTo = void 0, n.resolve(function() {
        return s.t(...arguments);
      }), t && t(l, function() {
        return s.t(...arguments);
      });
    }, o = (l) => {
      !e && !l && this.services.languageDetector && (l = []);
      const u = z(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      u && (this.language || i(u), this.translator.language || this.translator.changeLanguage(u), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(u)), this.loadResources(u, (c) => {
        a(c, u);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? o(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(o) : this.services.languageDetector.detect(o) : o(e), n;
  }
  getFixedT(e, t, s) {
    var n = this;
    const i = function(a, o) {
      let l;
      if (typeof o != "object") {
        for (var u = arguments.length, c = new Array(u > 2 ? u - 2 : 0), f = 2; f < u; f++)
          c[f - 2] = arguments[f];
        l = n.options.overloadTranslationOptionHandler([a, o].concat(c));
      } else
        l = {
          ...o
        };
      l.lng = l.lng || i.lng, l.lngs = l.lngs || i.lngs, l.ns = l.ns || i.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || s || i.keyPrefix);
      const p = n.options.keySeparator || ".";
      let v;
      return l.keyPrefix && Array.isArray(a) ? v = a.map((x) => `${l.keyPrefix}${p}${x}`) : v = l.keyPrefix ? `${l.keyPrefix}${p}${a}` : a, n.t(v, l);
    };
    return z(e) ? i.lng = e : i.lngs = e, i.ns = t, i.keyPrefix = s, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const s = t.lng || this.resolvedLanguage || this.languages[0], n = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (s.toLowerCase() === "cimode")
      return !0;
    const a = (o, l) => {
      const u = this.services.backendConnector.state[`${o}|${l}`];
      return u === -1 || u === 0 || u === 2;
    };
    if (t.precheck) {
      const o = t.precheck(this, a);
      if (o !== void 0)
        return o;
    }
    return !!(this.hasResourceBundle(s, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || a(s, e) && (!n || a(i, e)));
  }
  loadNamespaces(e, t) {
    const s = bt();
    return this.options.ns ? (z(e) && (e = [e]), e.forEach((n) => {
      this.options.ns.indexOf(n) < 0 && this.options.ns.push(n);
    }), this.loadResources((n) => {
      s.resolve(), t && t(n);
    }), s) : (t && t(), Promise.resolve());
  }
  loadLanguages(e, t) {
    const s = bt();
    z(e) && (e = [e]);
    const n = this.options.preload || [], i = e.filter((a) => n.indexOf(a) < 0 && this.services.languageUtils.isSupportedCode(a));
    return i.length ? (this.options.preload = n.concat(i), this.loadResources((a) => {
      s.resolve(), t && t(a);
    }), s) : (t && t(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e)
      return "rtl";
    const t = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], s = this.services && this.services.languageUtils || new xs(Ss());
    return t.indexOf(s.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    return new At(e, t);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Wt;
    const s = e.forkResourceStore;
    s && delete e.forkResourceStore;
    const n = {
      ...this.options,
      ...e,
      isClone: !0
    }, i = new At(n);
    return (e.debug !== void 0 || e.prefix !== void 0) && (i.logger = i.logger.clone(e)), ["store", "services", "language"].forEach((o) => {
      i[o] = this[o];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, s && (i.store = new bs(this.store.data, n), i.services.resourceStore = i.store), i.translator = new sr(i.services, n), i.translator.on("*", function(o) {
      for (var l = arguments.length, u = new Array(l > 1 ? l - 1 : 0), c = 1; c < l; c++)
        u[c - 1] = arguments[c];
      i.emit(o, ...u);
    }), i.init(n, t), i.translator.options = n, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const fe = At.createInstance();
fe.createInstance = At.createInstance;
fe.createInstance;
fe.dir;
fe.init;
fe.loadResources;
fe.reloadResources;
fe.use;
fe.changeLanguage;
fe.getFixedT;
fe.t;
fe.exists;
fe.setDefaultNamespace;
fe.hasLoadedNamespace;
fe.loadNamespaces;
fe.loadLanguages;
function Mr(r) {
  "@babel/helpers - typeof";
  return Mr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Mr(r);
}
function un() {
  return typeof XMLHttpRequest == "function" || (typeof XMLHttpRequest > "u" ? "undefined" : Mr(XMLHttpRequest)) === "object";
}
function $a(r) {
  return !!r && typeof r.then == "function";
}
function Ma(r) {
  return $a(r) ? r : Promise.resolve(r);
}
function Za(r) {
  throw new Error('Could not dynamically require "' + r + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Zr = { exports: {} }, Jt = { exports: {} }, Os;
function Ba() {
  return Os || (Os = 1, function(r, e) {
    var t = typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof St < "u" && St, s = function() {
      function i() {
        this.fetch = !1, this.DOMException = t.DOMException;
      }
      return i.prototype = t, new i();
    }();
    (function(i) {
      (function(a) {
        var o = typeof i < "u" && i || typeof self < "u" && self || typeof o < "u" && o, l = {
          searchParams: "URLSearchParams" in o,
          iterable: "Symbol" in o && "iterator" in Symbol,
          blob: "FileReader" in o && "Blob" in o && function() {
            try {
              return new Blob(), !0;
            } catch {
              return !1;
            }
          }(),
          formData: "FormData" in o,
          arrayBuffer: "ArrayBuffer" in o
        };
        function u(h) {
          return h && DataView.prototype.isPrototypeOf(h);
        }
        if (l.arrayBuffer)
          var c = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]"
          ], f = ArrayBuffer.isView || function(h) {
            return h && c.indexOf(Object.prototype.toString.call(h)) > -1;
          };
        function p(h) {
          if (typeof h != "string" && (h = String(h)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(h) || h === "")
            throw new TypeError('Invalid character in header field name: "' + h + '"');
          return h.toLowerCase();
        }
        function v(h) {
          return typeof h != "string" && (h = String(h)), h;
        }
        function x(h) {
          var y = {
            next: function() {
              var I = h.shift();
              return { done: I === void 0, value: I };
            }
          };
          return l.iterable && (y[Symbol.iterator] = function() {
            return y;
          }), y;
        }
        function C(h) {
          this.map = {}, h instanceof C ? h.forEach(function(y, I) {
            this.append(I, y);
          }, this) : Array.isArray(h) ? h.forEach(function(y) {
            this.append(y[0], y[1]);
          }, this) : h && Object.getOwnPropertyNames(h).forEach(function(y) {
            this.append(y, h[y]);
          }, this);
        }
        C.prototype.append = function(h, y) {
          h = p(h), y = v(y);
          var I = this.map[h];
          this.map[h] = I ? I + ", " + y : y;
        }, C.prototype.delete = function(h) {
          delete this.map[p(h)];
        }, C.prototype.get = function(h) {
          return h = p(h), this.has(h) ? this.map[h] : null;
        }, C.prototype.has = function(h) {
          return this.map.hasOwnProperty(p(h));
        }, C.prototype.set = function(h, y) {
          this.map[p(h)] = v(y);
        }, C.prototype.forEach = function(h, y) {
          for (var I in this.map)
            this.map.hasOwnProperty(I) && h.call(y, this.map[I], I, this);
        }, C.prototype.keys = function() {
          var h = [];
          return this.forEach(function(y, I) {
            h.push(I);
          }), x(h);
        }, C.prototype.values = function() {
          var h = [];
          return this.forEach(function(y) {
            h.push(y);
          }), x(h);
        }, C.prototype.entries = function() {
          var h = [];
          return this.forEach(function(y, I) {
            h.push([I, y]);
          }), x(h);
        }, l.iterable && (C.prototype[Symbol.iterator] = C.prototype.entries);
        function L(h) {
          if (h.bodyUsed)
            return Promise.reject(new TypeError("Already read"));
          h.bodyUsed = !0;
        }
        function V(h) {
          return new Promise(function(y, I) {
            h.onload = function() {
              y(h.result);
            }, h.onerror = function() {
              I(h.error);
            };
          });
        }
        function k(h) {
          var y = new FileReader(), I = V(y);
          return y.readAsArrayBuffer(h), I;
        }
        function U(h) {
          var y = new FileReader(), I = V(y);
          return y.readAsText(h), I;
        }
        function D(h) {
          for (var y = new Uint8Array(h), I = new Array(y.length), j = 0; j < y.length; j++)
            I[j] = String.fromCharCode(y[j]);
          return I.join("");
        }
        function Z(h) {
          if (h.slice)
            return h.slice(0);
          var y = new Uint8Array(h.byteLength);
          return y.set(new Uint8Array(h)), y.buffer;
        }
        function P() {
          return this.bodyUsed = !1, this._initBody = function(h) {
            this.bodyUsed = this.bodyUsed, this._bodyInit = h, h ? typeof h == "string" ? this._bodyText = h : l.blob && Blob.prototype.isPrototypeOf(h) ? this._bodyBlob = h : l.formData && FormData.prototype.isPrototypeOf(h) ? this._bodyFormData = h : l.searchParams && URLSearchParams.prototype.isPrototypeOf(h) ? this._bodyText = h.toString() : l.arrayBuffer && l.blob && u(h) ? (this._bodyArrayBuffer = Z(h.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : l.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(h) || f(h)) ? this._bodyArrayBuffer = Z(h) : this._bodyText = h = Object.prototype.toString.call(h) : this._bodyText = "", this.headers.get("content-type") || (typeof h == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : l.searchParams && URLSearchParams.prototype.isPrototypeOf(h) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, l.blob && (this.blob = function() {
            var h = L(this);
            if (h)
              return h;
            if (this._bodyBlob)
              return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }, this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
              var h = L(this);
              return h || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
                this._bodyArrayBuffer.buffer.slice(
                  this._bodyArrayBuffer.byteOffset,
                  this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
                )
              ) : Promise.resolve(this._bodyArrayBuffer));
            } else
              return this.blob().then(k);
          }), this.text = function() {
            var h = L(this);
            if (h)
              return h;
            if (this._bodyBlob)
              return U(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(D(this._bodyArrayBuffer));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, l.formData && (this.formData = function() {
            return this.text().then(Q);
          }), this.json = function() {
            return this.text().then(JSON.parse);
          }, this;
        }
        var O = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
        function $(h) {
          var y = h.toUpperCase();
          return O.indexOf(y) > -1 ? y : h;
        }
        function J(h, y) {
          if (!(this instanceof J))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          y = y || {};
          var I = y.body;
          if (h instanceof J) {
            if (h.bodyUsed)
              throw new TypeError("Already read");
            this.url = h.url, this.credentials = h.credentials, y.headers || (this.headers = new C(h.headers)), this.method = h.method, this.mode = h.mode, this.signal = h.signal, !I && h._bodyInit != null && (I = h._bodyInit, h.bodyUsed = !0);
          } else
            this.url = String(h);
          if (this.credentials = y.credentials || this.credentials || "same-origin", (y.headers || !this.headers) && (this.headers = new C(y.headers)), this.method = $(y.method || this.method || "GET"), this.mode = y.mode || this.mode || null, this.signal = y.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && I)
            throw new TypeError("Body not allowed for GET or HEAD requests");
          if (this._initBody(I), (this.method === "GET" || this.method === "HEAD") && (y.cache === "no-store" || y.cache === "no-cache")) {
            var j = /([?&])_=[^&]*/;
            if (j.test(this.url))
              this.url = this.url.replace(j, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
            else {
              var G = /\?/;
              this.url += (G.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
            }
          }
        }
        J.prototype.clone = function() {
          return new J(this, { body: this._bodyInit });
        };
        function Q(h) {
          var y = new FormData();
          return h.trim().split("&").forEach(function(I) {
            if (I) {
              var j = I.split("="), G = j.shift().replace(/\+/g, " "), K = j.join("=").replace(/\+/g, " ");
              y.append(decodeURIComponent(G), decodeURIComponent(K));
            }
          }), y;
        }
        function se(h) {
          var y = new C(), I = h.replace(/\r?\n[\t ]+/g, " ");
          return I.split("\r").map(function(j) {
            return j.indexOf(`
`) === 0 ? j.substr(1, j.length) : j;
          }).forEach(function(j) {
            var G = j.split(":"), K = G.shift().trim();
            if (K) {
              var Ae = G.join(":").trim();
              y.append(K, Ae);
            }
          }), y;
        }
        P.call(J.prototype);
        function R(h, y) {
          if (!(this instanceof R))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          y || (y = {}), this.type = "default", this.status = y.status === void 0 ? 200 : y.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = y.statusText === void 0 ? "" : "" + y.statusText, this.headers = new C(y.headers), this.url = y.url || "", this._initBody(h);
        }
        P.call(R.prototype), R.prototype.clone = function() {
          return new R(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new C(this.headers),
            url: this.url
          });
        }, R.error = function() {
          var h = new R(null, { status: 0, statusText: "" });
          return h.type = "error", h;
        };
        var M = [301, 302, 303, 307, 308];
        R.redirect = function(h, y) {
          if (M.indexOf(y) === -1)
            throw new RangeError("Invalid status code");
          return new R(null, { status: y, headers: { location: h } });
        }, a.DOMException = o.DOMException;
        try {
          new a.DOMException();
        } catch {
          a.DOMException = function(y, I) {
            this.message = y, this.name = I;
            var j = Error(y);
            this.stack = j.stack;
          }, a.DOMException.prototype = Object.create(Error.prototype), a.DOMException.prototype.constructor = a.DOMException;
        }
        function ee(h, y) {
          return new Promise(function(I, j) {
            var G = new J(h, y);
            if (G.signal && G.signal.aborted)
              return j(new a.DOMException("Aborted", "AbortError"));
            var K = new XMLHttpRequest();
            function Ae() {
              K.abort();
            }
            K.onload = function() {
              var me = {
                status: K.status,
                statusText: K.statusText,
                headers: se(K.getAllResponseHeaders() || "")
              };
              me.url = "responseURL" in K ? K.responseURL : me.headers.get("X-Request-URL");
              var Ge = "response" in K ? K.response : K.responseText;
              setTimeout(function() {
                I(new R(Ge, me));
              }, 0);
            }, K.onerror = function() {
              setTimeout(function() {
                j(new TypeError("Network request failed"));
              }, 0);
            }, K.ontimeout = function() {
              setTimeout(function() {
                j(new TypeError("Network request failed"));
              }, 0);
            }, K.onabort = function() {
              setTimeout(function() {
                j(new a.DOMException("Aborted", "AbortError"));
              }, 0);
            };
            function Kt(me) {
              try {
                return me === "" && o.location.href ? o.location.href : me;
              } catch {
                return me;
              }
            }
            K.open(G.method, Kt(G.url), !0), G.credentials === "include" ? K.withCredentials = !0 : G.credentials === "omit" && (K.withCredentials = !1), "responseType" in K && (l.blob ? K.responseType = "blob" : l.arrayBuffer && G.headers.get("Content-Type") && G.headers.get("Content-Type").indexOf("application/octet-stream") !== -1 && (K.responseType = "arraybuffer")), y && typeof y.headers == "object" && !(y.headers instanceof C) ? Object.getOwnPropertyNames(y.headers).forEach(function(me) {
              K.setRequestHeader(me, v(y.headers[me]));
            }) : G.headers.forEach(function(me, Ge) {
              K.setRequestHeader(Ge, me);
            }), G.signal && (G.signal.addEventListener("abort", Ae), K.onreadystatechange = function() {
              K.readyState === 4 && G.signal.removeEventListener("abort", Ae);
            }), K.send(typeof G._bodyInit > "u" ? null : G._bodyInit);
          });
        }
        return ee.polyfill = !0, o.fetch || (o.fetch = ee, o.Headers = C, o.Request = J, o.Response = R), a.Headers = C, a.Request = J, a.Response = R, a.fetch = ee, a;
      })({});
    })(s), s.fetch.ponyfill = !0, delete s.fetch.polyfill;
    var n = t.fetch ? t : s;
    e = n.fetch, e.default = n.fetch, e.fetch = n.fetch, e.Headers = n.Headers, e.Request = n.Request, e.Response = n.Response, r.exports = e;
  }(Jt, Jt.exports)), Jt.exports;
}
(function(r, e) {
  var t = typeof fetch == "function" ? fetch : void 0;
  if (typeof St < "u" && St.fetch ? t = St.fetch : typeof window < "u" && window.fetch && (t = window.fetch), typeof Za < "u" && typeof window > "u") {
    var s = t || Ba();
    s.default && (s = s.default), e.default = s, r.exports = e.default;
  }
})(Zr, Zr.exports);
var cn = Zr.exports;
const dn = /* @__PURE__ */ Jr(cn), Es = /* @__PURE__ */ qn({
  __proto__: null,
  default: dn
}, [cn]);
function Ls(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(r);
    e && (s = s.filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    })), t.push.apply(t, s);
  }
  return t;
}
function As(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ls(Object(t), !0).forEach(function(s) {
      Ua(r, s, t[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : Ls(Object(t)).forEach(function(s) {
      Object.defineProperty(r, s, Object.getOwnPropertyDescriptor(t, s));
    });
  }
  return r;
}
function Ua(r, e, t) {
  return (e = qa(e)) in r ? Object.defineProperty(r, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : r[e] = t, r;
}
function qa(r) {
  var e = Ha(r, "string");
  return rt(e) == "symbol" ? e : e + "";
}
function Ha(r, e) {
  if (rt(r) != "object" || !r)
    return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var s = t.call(r, e);
    if (rt(s) != "object")
      return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(r);
}
function rt(r) {
  "@babel/helpers - typeof";
  return rt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, rt(r);
}
var ze = typeof fetch == "function" ? fetch : void 0;
typeof global < "u" && global.fetch ? ze = global.fetch : typeof window < "u" && window.fetch && (ze = window.fetch);
var Tt;
un() && (typeof global < "u" && global.XMLHttpRequest ? Tt = global.XMLHttpRequest : typeof window < "u" && window.XMLHttpRequest && (Tt = window.XMLHttpRequest));
var nr;
typeof ActiveXObject == "function" && (typeof global < "u" && global.ActiveXObject ? nr = global.ActiveXObject : typeof window < "u" && window.ActiveXObject && (nr = window.ActiveXObject));
!ze && Es && !Tt && !nr && (ze = dn || Es);
typeof ze != "function" && (ze = void 0);
var Br = function(e, t) {
  if (t && rt(t) === "object") {
    var s = "";
    for (var n in t)
      s += "&" + encodeURIComponent(n) + "=" + encodeURIComponent(t[n]);
    if (!s)
      return e;
    e = e + (e.indexOf("?") !== -1 ? "&" : "?") + s.slice(1);
  }
  return e;
}, Ts = function(e, t, s, n) {
  var i = function(l) {
    if (!l.ok)
      return s(l.statusText || "Error", {
        status: l.status
      });
    l.text().then(function(u) {
      s(null, {
        status: l.status,
        data: u
      });
    }).catch(s);
  };
  if (n) {
    var a = n(e, t);
    if (a instanceof Promise) {
      a.then(i).catch(s);
      return;
    }
  }
  typeof fetch == "function" ? fetch(e, t).then(i).catch(s) : ze(e, t).then(i).catch(s);
}, Ns = !1, za = function(e, t, s, n) {
  e.queryStringParams && (t = Br(t, e.queryStringParams));
  var i = As({}, typeof e.customHeaders == "function" ? e.customHeaders() : e.customHeaders);
  typeof window > "u" && typeof global < "u" && typeof global.process < "u" && global.process.versions && global.process.versions.node && (i["User-Agent"] = "i18next-http-backend (node/".concat(global.process.version, "; ").concat(global.process.platform, " ").concat(global.process.arch, ")")), s && (i["Content-Type"] = "application/json");
  var a = typeof e.requestOptions == "function" ? e.requestOptions(s) : e.requestOptions, o = As({
    method: s ? "POST" : "GET",
    body: s ? e.stringify(s) : void 0,
    headers: i
  }, Ns ? {} : a), l = typeof e.alternateFetch == "function" && e.alternateFetch.length >= 1 ? e.alternateFetch : void 0;
  try {
    Ts(t, o, n, l);
  } catch (u) {
    if (!a || Object.keys(a).length === 0 || !u.message || u.message.indexOf("not implemented") < 0)
      return n(u);
    try {
      Object.keys(a).forEach(function(c) {
        delete o[c];
      }), Ts(t, o, n, l), Ns = !0;
    } catch (c) {
      n(c);
    }
  }
}, Ka = function(e, t, s, n) {
  s && rt(s) === "object" && (s = Br("", s).slice(1)), e.queryStringParams && (t = Br(t, e.queryStringParams));
  try {
    var i;
    Tt ? i = new Tt() : i = new nr("MSXML2.XMLHTTP.3.0"), i.open(s ? "POST" : "GET", t, 1), e.crossDomain || i.setRequestHeader("X-Requested-With", "XMLHttpRequest"), i.withCredentials = !!e.withCredentials, s && i.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), i.overrideMimeType && i.overrideMimeType("application/json");
    var a = e.customHeaders;
    if (a = typeof a == "function" ? a() : a, a)
      for (var o in a)
        i.setRequestHeader(o, a[o]);
    i.onreadystatechange = function() {
      i.readyState > 3 && n(i.status >= 400 ? i.statusText : null, {
        status: i.status,
        data: i.responseText
      });
    }, i.send(s);
  } catch (l) {
    console && console.log(l);
  }
}, Wa = function(e, t, s, n) {
  if (typeof s == "function" && (n = s, s = void 0), n = n || function() {
  }, ze && t.indexOf("file:") !== 0)
    return za(e, t, s, n);
  if (un() || typeof ActiveXObject == "function")
    return Ka(e, t, s, n);
  n(new Error("No fetch and no xhr implementation found!"));
};
function pt(r) {
  "@babel/helpers - typeof";
  return pt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, pt(r);
}
function Rs(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(r);
    e && (s = s.filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    })), t.push.apply(t, s);
  }
  return t;
}
function Tr(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Rs(Object(t), !0).forEach(function(s) {
      fn(r, s, t[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : Rs(Object(t)).forEach(function(s) {
      Object.defineProperty(r, s, Object.getOwnPropertyDescriptor(t, s));
    });
  }
  return r;
}
function Ja(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Xa(r, e) {
  for (var t = 0; t < e.length; t++) {
    var s = e[t];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(r, hn(s.key), s);
  }
}
function Ga(r, e, t) {
  return e && Xa(r.prototype, e), Object.defineProperty(r, "prototype", { writable: !1 }), r;
}
function fn(r, e, t) {
  return (e = hn(e)) in r ? Object.defineProperty(r, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : r[e] = t, r;
}
function hn(r) {
  var e = Ya(r, "string");
  return pt(e) == "symbol" ? e : e + "";
}
function Ya(r, e) {
  if (pt(r) != "object" || !r)
    return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var s = t.call(r, e);
    if (pt(s) != "object")
      return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(r);
}
var Qa = function() {
  return {
    loadPath: "/locales/{{lng}}/{{ns}}.json",
    addPath: "/locales/add/{{lng}}/{{ns}}",
    parse: function(t) {
      return JSON.parse(t);
    },
    stringify: JSON.stringify,
    parsePayload: function(t, s, n) {
      return fn({}, s, n || "");
    },
    parseLoadPayload: function(t, s) {
    },
    request: Wa,
    reloadInterval: typeof window < "u" ? !1 : 60 * 60 * 1e3,
    customHeaders: {},
    queryStringParams: {},
    crossDomain: !1,
    withCredentials: !1,
    overrideMimeType: !1,
    requestOptions: {
      mode: "cors",
      credentials: "same-origin",
      cache: "default"
    }
  };
}, pn = function() {
  function r(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    Ja(this, r), this.services = e, this.options = t, this.allOptions = s, this.type = "backend", this.init(e, t, s);
  }
  return Ga(r, [{
    key: "init",
    value: function(t) {
      var s = this, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (this.services = t, this.options = Tr(Tr(Tr({}, Qa()), this.options || {}), n), this.allOptions = i, this.services && this.options.reloadInterval) {
        var a = setInterval(function() {
          return s.reload();
        }, this.options.reloadInterval);
        pt(a) === "object" && typeof a.unref == "function" && a.unref();
      }
    }
  }, {
    key: "readMulti",
    value: function(t, s, n) {
      this._readAny(t, t, s, s, n);
    }
  }, {
    key: "read",
    value: function(t, s, n) {
      this._readAny([t], t, [s], s, n);
    }
  }, {
    key: "_readAny",
    value: function(t, s, n, i, a) {
      var o = this, l = this.options.loadPath;
      typeof this.options.loadPath == "function" && (l = this.options.loadPath(t, n)), l = Ma(l), l.then(function(u) {
        if (!u)
          return a(null, {});
        var c = o.services.interpolator.interpolate(u, {
          lng: t.join("+"),
          ns: n.join("+")
        });
        o.loadUrl(c, a, s, i);
      });
    }
  }, {
    key: "loadUrl",
    value: function(t, s, n, i) {
      var a = this, o = typeof n == "string" ? [n] : n, l = typeof i == "string" ? [i] : i, u = this.options.parseLoadPayload(o, l);
      this.options.request(this.options, t, u, function(c, f) {
        if (f && (f.status >= 500 && f.status < 600 || !f.status))
          return s("failed loading " + t + "; status code: " + f.status, !0);
        if (f && f.status >= 400 && f.status < 500)
          return s("failed loading " + t + "; status code: " + f.status, !1);
        if (!f && c && c.message) {
          var p = c.message.toLowerCase(), v = ["failed", "fetch", "network", "load"].find(function(L) {
            return p.indexOf(L) > -1;
          });
          if (v)
            return s("failed loading " + t + ": " + c.message, !0);
        }
        if (c)
          return s(c, !1);
        var x, C;
        try {
          typeof f.data == "string" ? x = a.options.parse(f.data, n, i) : x = f.data;
        } catch {
          C = "failed parsing " + t + " to json";
        }
        if (C)
          return s(C, !1);
        s(null, x);
      });
    }
  }, {
    key: "create",
    value: function(t, s, n, i, a) {
      var o = this;
      if (this.options.addPath) {
        typeof t == "string" && (t = [t]);
        var l = this.options.parsePayload(s, n, i), u = 0, c = [], f = [];
        t.forEach(function(p) {
          var v = o.options.addPath;
          typeof o.options.addPath == "function" && (v = o.options.addPath(p, s));
          var x = o.services.interpolator.interpolate(v, {
            lng: p,
            ns: s
          });
          o.options.request(o.options, x, l, function(C, L) {
            u += 1, c.push(C), f.push(L), u === t.length && typeof a == "function" && a(c, f);
          });
        });
      }
    }
  }, {
    key: "reload",
    value: function() {
      var t = this, s = this.services, n = s.backendConnector, i = s.languageUtils, a = s.logger, o = n.language;
      if (!(o && o.toLowerCase() === "cimode")) {
        var l = [], u = function(f) {
          var p = i.toResolveHierarchy(f);
          p.forEach(function(v) {
            l.indexOf(v) < 0 && l.push(v);
          });
        };
        u(o), this.allOptions.preload && this.allOptions.preload.forEach(function(c) {
          return u(c);
        }), l.forEach(function(c) {
          t.allOptions.ns.forEach(function(f) {
            n.read(c, f, "read", null, null, function(p, v) {
              p && a.warn("loading namespace ".concat(f, " for language ").concat(c, " failed"), p), !p && v && a.log("loaded namespace ".concat(f, " for language ").concat(c), v), n.loaded("".concat(c, "|").concat(f), p, v);
            });
          });
        });
      }
    }
  }]);
}();
pn.type = "backend";
const eo = {
  next: "Next",
  cancel: "Cancel",
  delete: "Delete",
  ok: "OK",
  close: "Close"
}, to = {
  delete: {
    confirmation: {
      title: "Delete Product",
      message: "Are you sure you want to delete entity? This action cannot be undone."
    },
    deleting: {
      title: "Deleting product",
      message: "Please wait..."
    },
    conflict: {
      title: "Product in use",
      message: "This product is used in composite products and will be removed from them.",
      deleteAnyway: "Delete anyway"
    },
    success: {
      title: "Product deleted successfully",
      message: "The product has been deleted."
    },
    error: {
      title: "Deletion error"
    }
  }
}, ro = {
  msgActionUnavailable: "Action unavailable"
}, so = {
  field: {
    required: "Required"
  },
  validation: {
    required: "This field is required",
    is_email: "Invalid email"
  },
  "request-quote": {
    title: {
      contactDetails: "Contact details"
    },
    submitButton: "Send",
    pending: {
      title: "Sending request",
      text: "Please wait"
    },
    success: {
      title: "Sent",
      text: `Request was successfully sent. 
We will contact you soon.`
    },
    error: {
      title: "Sending error",
      text: "An unexpected error has occurred, please try requesting later."
    },
    "accept-conditions": {
      validation: "Please, read and accept privacy policy.",
      text: "I accept <1>privacy policy</1>"
    },
    label: {
      firstName: "First name",
      lastName: "Last name",
      fullName: "Full name",
      companyName: "Company name",
      email: "Email",
      phone: "Phone",
      country: "Country",
      city: "City",
      street: "Street",
      buildingNumber: "House No.",
      zipCode: "ZIP code",
      notes: "Comments"
    }
  }
}, no = {
  buttons: eo,
  modals: to,
  messages: ro,
  form: so
}, io = {
  next: "Nächste"
}, ao = {
  field: {
    required: "Erforderlich"
  },
  validation: {
    required: "Dieses Feld ist erforderlich",
    is_email: "Ungültige E-Mail"
  },
  "request-quote": {
    title: {
      contactDetails: "Kontaktdetails"
    },
    submitButton: "Senden",
    pending: {
      title: "Anfrage senden",
      text: "Bitte warten"
    },
    success: {
      title: "Gesendet",
      text: `Anfrage wurde erfolgreich gesendet. 
Wir werden Sie bald kontaktieren.`
    },
    error: {
      title: "Fehler beim Senden",
      text: "Ein unerwarteter Fehler ist aufgetreten, bitte versuchen Sie es später."
    },
    "accept-conditions": {
      validation: "Bitte lesen und akzeptieren Sie die Datenschutzbestimmungen.",
      text: "Ich akzeptiere <1>Datenschutzbestimmungen</1>"
    },
    label: {
      firstName: "Vorname",
      lastName: "Nachname",
      fullName: "Vollständiger Name",
      companyName: "Unternehmen",
      email: "E-Mail",
      phone: "Telefon",
      country: "Land",
      city: "Stadt",
      street: "Straße",
      buildingNumber: "Hausnummer",
      zipCode: "Postleitzahl",
      notes: "Kommentare"
    }
  }
}, oo = {
  buttons: io,
  form: ao
}, lo = "locale";
fe.use(Gi).use(pn).init({
  lng: localStorage.getItem(lo) || "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: !1
  },
  ns: ["translation"],
  resources: {
    en: {
      translation: {
        ...no
      }
    },
    de: {
      translation: {
        ...oo
      }
    }
  }
});
const uo = fe, yr = (r) => qt((e, t) => /* @__PURE__ */ re(ra, { i18n: uo, children: /* @__PURE__ */ re(r, { ...e, ref: t }) })), co = "_errors_sgqqp_1", fo = {
  errors: co
}, ho = ({
  className: r,
  error: e
}) => {
  const { t } = gr();
  return /* @__PURE__ */ re("div", { className: de(fo.errors, r), children: /* @__PURE__ */ re(ht, { variant: "paragraph-sm", component: "span", color: "inherit", children: (e == null ? void 0 : e.message) && t(e.message) }) });
}, Yr = yr(ho), po = "_label_euxgf_1", go = "_svg_euxgf_6", mo = "_field_euxgf_12", yo = "_svgWrapper_euxgf_18", vo = "_tick_euxgf_38", bo = "_input_euxgf_44", _o = "_error_euxgf_68", Ye = {
  label: po,
  svg: go,
  field: mo,
  svgWrapper: yo,
  tick: vo,
  input: bo,
  error: _o
}, xo = qt(
  ({ error: r, noErrorPlaceholder: e, label: t, className: s, ...n }, i) => {
    const a = r || !e;
    return /* @__PURE__ */ we("div", { className: s, children: [
      /* @__PURE__ */ re("label", { className: Ye.label, children: /* @__PURE__ */ we("div", { className: Ye.field, children: [
        /* @__PURE__ */ re(
          "input",
          {
            ref: i,
            ...n,
            "data-invalid": !!(r != null && r.message),
            "data-visually-hidden": !0,
            className: Ye.input,
            type: "checkbox"
          }
        ),
        /* @__PURE__ */ re("div", { className: Ye.svgWrapper, children: /* @__PURE__ */ re("svg", { className: Ye.svg, viewBox: "0 0 16 16", children: /* @__PURE__ */ re(
          "polyline",
          {
            fill: "none",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            stroke: "white",
            strokeWidth: "2",
            points: "5 8 7 10 11 6",
            strokeDasharray: "10",
            className: Ye.tick
          }
        ) }) }),
        t
      ] }) }),
      a && /* @__PURE__ */ re(Yr, { className: Ye.error, error: r })
    ] });
  }
), Co = "_label_juslb_1", wo = "_input_juslb_8", So = "_invalid_juslb_42", He = {
  label: Co,
  input: wo,
  invalid: So
}, ko = qt(function({ label: e, withValidation: t, required: s, error: n, disabled: i, className: a, type: o = "text", ...l }, u) {
  const { t: c } = gr("translation"), f = Xs();
  return /* @__PURE__ */ we("div", { className: de(He.container, a), children: [
    e && /* @__PURE__ */ we("label", { htmlFor: f, className: He.label, children: [
      /* @__PURE__ */ re(ht, { variant: "paragraph-sm", color: i ? "disabled" : "description", component: "span", children: e }),
      s && /* @__PURE__ */ we(ht, { variant: "paragraph-sm", component: "span", color: "disabled", children: [
        "(",
        c("form.field.required"),
        ")"
      ] })
    ] }),
    /* @__PURE__ */ re(
      "input",
      {
        ...l,
        ref: u,
        id: f,
        disabled: i,
        className: de(He.input, { [He.invalid]: !!n }),
        type: o
      }
    ),
    t && /* @__PURE__ */ re(Yr, { error: n })
  ] });
}), Oo = yr(ko), Eo = qt(function({ label: e, withValidation: t, required: s, error: n, disabled: i, className: a, rows: o = 4, ...l }, u) {
  const { t: c } = gr("translation"), f = Xs();
  return /* @__PURE__ */ we("div", { className: de(He.container, a), children: [
    e && /* @__PURE__ */ we("label", { htmlFor: f, className: He.label, children: [
      /* @__PURE__ */ re(ht, { variant: "paragraph-sm", color: i ? "disabled" : "description", component: "span", children: e }),
      s && /* @__PURE__ */ we(ht, { variant: "paragraph-sm", component: "span", color: "disabled", children: [
        "(",
        c("form.field.required"),
        ")"
      ] })
    ] }),
    /* @__PURE__ */ re(
      "textarea",
      {
        ...l,
        rows: o,
        ref: u,
        id: f,
        disabled: i,
        className: de(He.input, { [He.invalid]: !!n })
      }
    ),
    t && /* @__PURE__ */ re(Yr, { error: n })
  ] });
}), Lo = yr(Eo);
var Ht = (r) => r.type === "checkbox", Qe = (r) => r instanceof Date, pe = (r) => r == null;
const gn = (r) => typeof r == "object";
var ae = (r) => !pe(r) && !Array.isArray(r) && gn(r) && !Qe(r), Ao = (r) => ae(r) && r.target ? Ht(r.target) ? r.target.checked : r.target.value : r, To = (r) => r.substring(0, r.search(/\.\d+(\.|$)/)) || r, No = (r, e) => r.has(To(e)), Ro = (r) => {
  const e = r.constructor && r.constructor.prototype;
  return ae(e) && e.hasOwnProperty("isPrototypeOf");
}, Qr = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function xe(r) {
  let e;
  const t = Array.isArray(r), s = typeof FileList < "u" ? r instanceof FileList : !1;
  if (r instanceof Date)
    e = new Date(r);
  else if (r instanceof Set)
    e = new Set(r);
  else if (!(Qr && (r instanceof Blob || s)) && (t || ae(r)))
    if (e = t ? [] : {}, !t && !Ro(r))
      e = r;
    else
      for (const n in r)
        r.hasOwnProperty(n) && (e[n] = xe(r[n]));
  else
    return r;
  return e;
}
var vr = (r) => Array.isArray(r) ? r.filter(Boolean) : [], oe = (r) => r === void 0, N = (r, e, t) => {
  if (!e || !ae(r))
    return t;
  const s = vr(e.split(/[,[\].]+?/)).reduce((n, i) => pe(n) ? n : n[i], r);
  return oe(s) || s === r ? oe(r[e]) ? t : r[e] : s;
}, Te = (r) => typeof r == "boolean", es = (r) => /^\w*$/.test(r), mn = (r) => vr(r.replace(/["|']|\]/g, "").split(/\.|\[/)), ne = (r, e, t) => {
  let s = -1;
  const n = es(e) ? [e] : mn(e), i = n.length, a = i - 1;
  for (; ++s < i; ) {
    const o = n[s];
    let l = t;
    if (s !== a) {
      const u = r[o];
      l = ae(u) || Array.isArray(u) ? u : isNaN(+n[s + 1]) ? {} : [];
    }
    if (o === "__proto__" || o === "constructor" || o === "prototype")
      return;
    r[o] = l, r = r[o];
  }
  return r;
};
const Ps = {
  BLUR: "blur",
  FOCUS_OUT: "focusout"
}, ke = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Ie = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
};
Ce.createContext(null);
var Po = (r, e, t, s = !0) => {
  const n = {
    defaultValues: e._defaultValues
  };
  for (const i in r)
    Object.defineProperty(n, i, {
      get: () => {
        const a = i;
        return e._proxyFormState[a] !== ke.all && (e._proxyFormState[a] = !s || ke.all), r[a];
      }
    });
  return n;
}, ve = (r) => ae(r) && !Object.keys(r).length, jo = (r, e, t, s) => {
  t(r);
  const { name: n, ...i } = r;
  return ve(i) || Object.keys(i).length >= Object.keys(e).length || Object.keys(i).find((a) => e[a] === ke.all);
}, Gt = (r) => Array.isArray(r) ? r : [r];
function Vo(r) {
  const e = Ce.useRef(r);
  e.current = r, Ce.useEffect(() => {
    const t = !r.disabled && e.current.subject && e.current.subject.subscribe({
      next: e.current.next
    });
    return () => {
      t && t.unsubscribe();
    };
  }, [r.disabled]);
}
var Pe = (r) => typeof r == "string", Fo = (r, e, t, s, n) => Pe(r) ? (s && e.watch.add(r), N(t, r, n)) : Array.isArray(r) ? r.map((i) => (s && e.watch.add(i), N(t, i))) : (s && (e.watchAll = !0), t), yn = (r, e, t, s, n) => e ? {
  ...t[r],
  types: {
    ...t[r] && t[r].types ? t[r].types : {},
    [s]: n || !0
  }
} : {}, js = (r) => ({
  isOnSubmit: !r || r === ke.onSubmit,
  isOnBlur: r === ke.onBlur,
  isOnChange: r === ke.onChange,
  isOnAll: r === ke.all,
  isOnTouch: r === ke.onTouched
}), Vs = (r, e, t) => !t && (e.watchAll || e.watch.has(r) || [...e.watch].some((s) => r.startsWith(s) && /^\.\w+/.test(r.slice(s.length))));
const Ot = (r, e, t, s) => {
  for (const n of t || Object.keys(r)) {
    const i = N(r, n);
    if (i) {
      const { _f: a, ...o } = i;
      if (a) {
        if (a.refs && a.refs[0] && e(a.refs[0], n) && !s)
          return !0;
        if (a.ref && e(a.ref, a.name) && !s)
          return !0;
        if (Ot(o, e))
          break;
      } else if (ae(o) && Ot(o, e))
        break;
    }
  }
};
var Io = (r, e, t) => {
  const s = Gt(N(r, t));
  return ne(s, "root", e[t]), ne(r, t, s), r;
}, ts = (r) => r.type === "file", Ne = (r) => typeof r == "function", ir = (r) => {
  if (!Qr)
    return !1;
  const e = r ? r.ownerDocument : 0;
  return r instanceof (e && e.defaultView ? e.defaultView.HTMLElement : HTMLElement);
}, Yt = (r) => Pe(r), rs = (r) => r.type === "radio", ar = (r) => r instanceof RegExp;
const Fs = {
  value: !1,
  isValid: !1
}, Is = { value: !0, isValid: !0 };
var vn = (r) => {
  if (Array.isArray(r)) {
    if (r.length > 1) {
      const e = r.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: e, isValid: !!e.length };
    }
    return r[0].checked && !r[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      r[0].attributes && !oe(r[0].attributes.value) ? oe(r[0].value) || r[0].value === "" ? Is : { value: r[0].value, isValid: !0 } : Is
    ) : Fs;
  }
  return Fs;
};
const Ds = {
  isValid: !1,
  value: null
};
var bn = (r) => Array.isArray(r) ? r.reduce((e, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : e, Ds) : Ds;
function $s(r, e, t = "validate") {
  if (Yt(r) || Array.isArray(r) && r.every(Yt) || Te(r) && !r)
    return {
      type: t,
      message: Yt(r) ? r : "",
      ref: e
    };
}
var lt = (r) => ae(r) && !ar(r) ? r : {
  value: r,
  message: ""
}, Ms = async (r, e, t, s, n, i) => {
  const { ref: a, refs: o, required: l, maxLength: u, minLength: c, min: f, max: p, pattern: v, validate: x, name: C, valueAsNumber: L, mount: V } = r._f, k = N(t, C);
  if (!V || e.has(C))
    return {};
  const U = o ? o[0] : a, D = (R) => {
    n && U.reportValidity && (U.setCustomValidity(Te(R) ? "" : R || ""), U.reportValidity());
  }, Z = {}, P = rs(a), O = Ht(a), $ = P || O, J = (L || ts(a)) && oe(a.value) && oe(k) || ir(a) && a.value === "" || k === "" || Array.isArray(k) && !k.length, Q = yn.bind(null, C, s, Z), se = (R, M, ee, h = Ie.maxLength, y = Ie.minLength) => {
    const I = R ? M : ee;
    Z[C] = {
      type: R ? h : y,
      message: I,
      ref: a,
      ...Q(R ? h : y, I)
    };
  };
  if (i ? !Array.isArray(k) || !k.length : l && (!$ && (J || pe(k)) || Te(k) && !k || O && !vn(o).isValid || P && !bn(o).isValid)) {
    const { value: R, message: M } = Yt(l) ? { value: !!l, message: l } : lt(l);
    if (R && (Z[C] = {
      type: Ie.required,
      message: M,
      ref: U,
      ...Q(Ie.required, M)
    }, !s))
      return D(M), Z;
  }
  if (!J && (!pe(f) || !pe(p))) {
    let R, M;
    const ee = lt(p), h = lt(f);
    if (!pe(k) && !isNaN(k)) {
      const y = a.valueAsNumber || k && +k;
      pe(ee.value) || (R = y > ee.value), pe(h.value) || (M = y < h.value);
    } else {
      const y = a.valueAsDate || new Date(k), I = (K) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + K), j = a.type == "time", G = a.type == "week";
      Pe(ee.value) && k && (R = j ? I(k) > I(ee.value) : G ? k > ee.value : y > new Date(ee.value)), Pe(h.value) && k && (M = j ? I(k) < I(h.value) : G ? k < h.value : y < new Date(h.value));
    }
    if ((R || M) && (se(!!R, ee.message, h.message, Ie.max, Ie.min), !s))
      return D(Z[C].message), Z;
  }
  if ((u || c) && !J && (Pe(k) || i && Array.isArray(k))) {
    const R = lt(u), M = lt(c), ee = !pe(R.value) && k.length > +R.value, h = !pe(M.value) && k.length < +M.value;
    if ((ee || h) && (se(ee, R.message, M.message), !s))
      return D(Z[C].message), Z;
  }
  if (v && !J && Pe(k)) {
    const { value: R, message: M } = lt(v);
    if (ar(R) && !k.match(R) && (Z[C] = {
      type: Ie.pattern,
      message: M,
      ref: a,
      ...Q(Ie.pattern, M)
    }, !s))
      return D(M), Z;
  }
  if (x) {
    if (Ne(x)) {
      const R = await x(k, t), M = $s(R, U);
      if (M && (Z[C] = {
        ...M,
        ...Q(Ie.validate, M.message)
      }, !s))
        return D(M.message), Z;
    } else if (ae(x)) {
      let R = {};
      for (const M in x) {
        if (!ve(R) && !s)
          break;
        const ee = $s(await x[M](k, t), U, M);
        ee && (R = {
          ...ee,
          ...Q(M, ee.message)
        }, D(ee.message), s && (Z[C] = R));
      }
      if (!ve(R) && (Z[C] = {
        ref: U,
        ...R
      }, !s))
        return Z;
    }
  }
  return D(!0), Z;
};
function Do(r, e) {
  const t = e.slice(0, -1).length;
  let s = 0;
  for (; s < t; )
    r = oe(r) ? s++ : r[e[s++]];
  return r;
}
function $o(r) {
  for (const e in r)
    if (r.hasOwnProperty(e) && !oe(r[e]))
      return !1;
  return !0;
}
function le(r, e) {
  const t = Array.isArray(e) ? e : es(e) ? [e] : mn(e), s = t.length === 1 ? r : Do(r, t), n = t.length - 1, i = t[n];
  return s && delete s[i], n !== 0 && (ae(s) && ve(s) || Array.isArray(s) && $o(s)) && le(r, t.slice(0, -1)), r;
}
var Nr = () => {
  let r = [];
  return {
    get observers() {
      return r;
    },
    next: (n) => {
      for (const i of r)
        i.next && i.next(n);
    },
    subscribe: (n) => (r.push(n), {
      unsubscribe: () => {
        r = r.filter((i) => i !== n);
      }
    }),
    unsubscribe: () => {
      r = [];
    }
  };
}, Ur = (r) => pe(r) || !gn(r);
function Ue(r, e) {
  if (Ur(r) || Ur(e))
    return r === e;
  if (Qe(r) && Qe(e))
    return r.getTime() === e.getTime();
  const t = Object.keys(r), s = Object.keys(e);
  if (t.length !== s.length)
    return !1;
  for (const n of t) {
    const i = r[n];
    if (!s.includes(n))
      return !1;
    if (n !== "ref") {
      const a = e[n];
      if (Qe(i) && Qe(a) || ae(i) && ae(a) || Array.isArray(i) && Array.isArray(a) ? !Ue(i, a) : i !== a)
        return !1;
    }
  }
  return !0;
}
var _n = (r) => r.type === "select-multiple", Mo = (r) => rs(r) || Ht(r), Rr = (r) => ir(r) && r.isConnected, xn = (r) => {
  for (const e in r)
    if (Ne(r[e]))
      return !0;
  return !1;
};
function or(r, e = {}) {
  const t = Array.isArray(r);
  if (ae(r) || t)
    for (const s in r)
      Array.isArray(r[s]) || ae(r[s]) && !xn(r[s]) ? (e[s] = Array.isArray(r[s]) ? [] : {}, or(r[s], e[s])) : pe(r[s]) || (e[s] = !0);
  return e;
}
function Cn(r, e, t) {
  const s = Array.isArray(r);
  if (ae(r) || s)
    for (const n in r)
      Array.isArray(r[n]) || ae(r[n]) && !xn(r[n]) ? oe(e) || Ur(t[n]) ? t[n] = Array.isArray(r[n]) ? or(r[n], []) : { ...or(r[n]) } : Cn(r[n], pe(e) ? {} : e[n], t[n]) : t[n] = !Ue(r[n], e[n]);
  return t;
}
var _t = (r, e) => Cn(r, e, or(e)), wn = (r, { valueAsNumber: e, valueAsDate: t, setValueAs: s }) => oe(r) ? r : e ? r === "" ? NaN : r && +r : t && Pe(r) ? new Date(r) : s ? s(r) : r;
function Pr(r) {
  const e = r.ref;
  return ts(e) ? e.files : rs(e) ? bn(r.refs).value : _n(e) ? [...e.selectedOptions].map(({ value: t }) => t) : Ht(e) ? vn(r.refs).value : wn(oe(e.value) ? r.ref.value : e.value, r);
}
var Zo = (r, e, t, s) => {
  const n = {};
  for (const i of r) {
    const a = N(e, i);
    a && ne(n, i, a._f);
  }
  return {
    criteriaMode: t,
    names: [...r],
    fields: n,
    shouldUseNativeValidation: s
  };
}, xt = (r) => oe(r) ? r : ar(r) ? r.source : ae(r) ? ar(r.value) ? r.value.source : r.value : r;
const Zs = "AsyncFunction";
var Bo = (r) => !!r && !!r.validate && !!(Ne(r.validate) && r.validate.constructor.name === Zs || ae(r.validate) && Object.values(r.validate).find((e) => e.constructor.name === Zs)), Uo = (r) => r.mount && (r.required || r.min || r.max || r.maxLength || r.minLength || r.pattern || r.validate);
function Bs(r, e, t) {
  const s = N(r, t);
  if (s || es(t))
    return {
      error: s,
      name: t
    };
  const n = t.split(".");
  for (; n.length; ) {
    const i = n.join("."), a = N(e, i), o = N(r, i);
    if (a && !Array.isArray(a) && t !== i)
      return { name: t };
    if (o && o.type)
      return {
        name: i,
        error: o
      };
    n.pop();
  }
  return {
    name: t
  };
}
var qo = (r, e, t, s, n) => n.isOnAll ? !1 : !t && n.isOnTouch ? !(e || r) : (t ? s.isOnBlur : n.isOnBlur) ? !r : (t ? s.isOnChange : n.isOnChange) ? r : !0, Ho = (r, e) => !vr(N(r, e)).length && le(r, e);
const zo = {
  mode: ke.onSubmit,
  reValidateMode: ke.onChange,
  shouldFocusError: !0
};
function Ko(r = {}) {
  let e = {
    ...zo,
    ...r
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Ne(e.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1
  }, s = {}, n = ae(e.defaultValues) || ae(e.values) ? xe(e.defaultValues || e.values) || {} : {}, i = e.shouldUnregister ? {} : xe(n), a = {
    action: !1,
    mount: !1,
    watch: !1
  }, o = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, l, u = 0;
  const c = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, f = {
    values: Nr(),
    array: Nr(),
    state: Nr()
  }, p = js(e.mode), v = js(e.reValidateMode), x = e.criteriaMode === ke.all, C = (d) => (g) => {
    clearTimeout(u), u = setTimeout(d, g);
  }, L = async (d) => {
    if (!e.disabled && (c.isValid || d)) {
      const g = e.resolver ? ve((await $()).errors) : await Q(s, !0);
      g !== t.isValid && f.state.next({
        isValid: g
      });
    }
  }, V = (d, g) => {
    !e.disabled && (c.isValidating || c.validatingFields) && ((d || Array.from(o.mount)).forEach((m) => {
      m && (g ? ne(t.validatingFields, m, g) : le(t.validatingFields, m));
    }), f.state.next({
      validatingFields: t.validatingFields,
      isValidating: !ve(t.validatingFields)
    }));
  }, k = (d, g = [], m, A, S = !0, w = !0) => {
    if (A && m && !e.disabled) {
      if (a.action = !0, w && Array.isArray(N(s, d))) {
        const B = m(N(s, d), A.argA, A.argB);
        S && ne(s, d, B);
      }
      if (w && Array.isArray(N(t.errors, d))) {
        const B = m(N(t.errors, d), A.argA, A.argB);
        S && ne(t.errors, d, B), Ho(t.errors, d);
      }
      if (c.touchedFields && w && Array.isArray(N(t.touchedFields, d))) {
        const B = m(N(t.touchedFields, d), A.argA, A.argB);
        S && ne(t.touchedFields, d, B);
      }
      c.dirtyFields && (t.dirtyFields = _t(n, i)), f.state.next({
        name: d,
        isDirty: R(d, g),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      ne(i, d, g);
  }, U = (d, g) => {
    ne(t.errors, d, g), f.state.next({
      errors: t.errors
    });
  }, D = (d) => {
    t.errors = d, f.state.next({
      errors: t.errors,
      isValid: !1
    });
  }, Z = (d, g, m, A) => {
    const S = N(s, d);
    if (S) {
      const w = N(i, d, oe(m) ? N(n, d) : m);
      oe(w) || A && A.defaultChecked || g ? ne(i, d, g ? w : Pr(S._f)) : h(d, w), a.mount && L();
    }
  }, P = (d, g, m, A, S) => {
    let w = !1, B = !1;
    const Y = {
      name: d
    };
    if (!e.disabled) {
      const ue = !!(N(s, d) && N(s, d)._f && N(s, d)._f.disabled);
      if (!m || A) {
        c.isDirty && (B = t.isDirty, t.isDirty = Y.isDirty = R(), w = B !== Y.isDirty);
        const ce = ue || Ue(N(n, d), g);
        B = !!(!ue && N(t.dirtyFields, d)), ce || ue ? le(t.dirtyFields, d) : ne(t.dirtyFields, d, !0), Y.dirtyFields = t.dirtyFields, w = w || c.dirtyFields && B !== !ce;
      }
      if (m) {
        const ce = N(t.touchedFields, d);
        ce || (ne(t.touchedFields, d, m), Y.touchedFields = t.touchedFields, w = w || c.touchedFields && ce !== m);
      }
      w && S && f.state.next(Y);
    }
    return w ? Y : {};
  }, O = (d, g, m, A) => {
    const S = N(t.errors, d), w = c.isValid && Te(g) && t.isValid !== g;
    if (e.delayError && m ? (l = C(() => U(d, m)), l(e.delayError)) : (clearTimeout(u), l = null, m ? ne(t.errors, d, m) : le(t.errors, d)), (m ? !Ue(S, m) : S) || !ve(A) || w) {
      const B = {
        ...A,
        ...w && Te(g) ? { isValid: g } : {},
        errors: t.errors,
        name: d
      };
      t = {
        ...t,
        ...B
      }, f.state.next(B);
    }
  }, $ = async (d) => {
    V(d, !0);
    const g = await e.resolver(i, e.context, Zo(d || o.mount, s, e.criteriaMode, e.shouldUseNativeValidation));
    return V(d), g;
  }, J = async (d) => {
    const { errors: g } = await $(d);
    if (d)
      for (const m of d) {
        const A = N(g, m);
        A ? ne(t.errors, m, A) : le(t.errors, m);
      }
    else
      t.errors = g;
    return g;
  }, Q = async (d, g, m = {
    valid: !0
  }) => {
    for (const A in d) {
      const S = d[A];
      if (S) {
        const { _f: w, ...B } = S;
        if (w) {
          const Y = o.array.has(w.name), ue = S._f && Bo(S._f);
          ue && c.validatingFields && V([A], !0);
          const ce = await Ms(S, o.disabled, i, x, e.shouldUseNativeValidation && !g, Y);
          if (ue && c.validatingFields && V([A]), ce[w.name] && (m.valid = !1, g))
            break;
          !g && (N(ce, w.name) ? Y ? Io(t.errors, ce, w.name) : ne(t.errors, w.name, ce[w.name]) : le(t.errors, w.name));
        }
        !ve(B) && await Q(B, g, m);
      }
    }
    return m.valid;
  }, se = () => {
    for (const d of o.unMount) {
      const g = N(s, d);
      g && (g._f.refs ? g._f.refs.every((m) => !Rr(m)) : !Rr(g._f.ref)) && _r(d);
    }
    o.unMount = /* @__PURE__ */ new Set();
  }, R = (d, g) => !e.disabled && (d && g && ne(i, d, g), !Ue(Ae(), n)), M = (d, g, m) => Fo(d, o, {
    ...a.mount ? i : oe(g) ? n : Pe(d) ? { [d]: g } : g
  }, m, g), ee = (d) => vr(N(a.mount ? i : n, d, e.shouldUnregister ? N(n, d, []) : [])), h = (d, g, m = {}) => {
    const A = N(s, d);
    let S = g;
    if (A) {
      const w = A._f;
      w && (!w.disabled && ne(i, d, wn(g, w)), S = ir(w.ref) && pe(g) ? "" : g, _n(w.ref) ? [...w.ref.options].forEach((B) => B.selected = S.includes(B.value)) : w.refs ? Ht(w.ref) ? w.refs.length > 1 ? w.refs.forEach((B) => (!B.defaultChecked || !B.disabled) && (B.checked = Array.isArray(S) ? !!S.find((Y) => Y === B.value) : S === B.value)) : w.refs[0] && (w.refs[0].checked = !!S) : w.refs.forEach((B) => B.checked = B.value === S) : ts(w.ref) ? w.ref.value = "" : (w.ref.value = S, w.ref.type || f.values.next({
        name: d,
        values: { ...i }
      })));
    }
    (m.shouldDirty || m.shouldTouch) && P(d, S, m.shouldTouch, m.shouldDirty, !0), m.shouldValidate && K(d);
  }, y = (d, g, m) => {
    for (const A in g) {
      const S = g[A], w = `${d}.${A}`, B = N(s, w);
      (o.array.has(d) || ae(S) || B && !B._f) && !Qe(S) ? y(w, S, m) : h(w, S, m);
    }
  }, I = (d, g, m = {}) => {
    const A = N(s, d), S = o.array.has(d), w = xe(g);
    ne(i, d, w), S ? (f.array.next({
      name: d,
      values: { ...i }
    }), (c.isDirty || c.dirtyFields) && m.shouldDirty && f.state.next({
      name: d,
      dirtyFields: _t(n, i),
      isDirty: R(d, w)
    })) : A && !A._f && !pe(w) ? y(d, w, m) : h(d, w, m), Vs(d, o) && f.state.next({ ...t }), f.values.next({
      name: a.mount ? d : void 0,
      values: { ...i }
    });
  }, j = async (d) => {
    a.mount = !0;
    const g = d.target;
    let m = g.name, A = !0;
    const S = N(s, m), w = () => g.type ? Pr(S._f) : Ao(d), B = (Y) => {
      A = Number.isNaN(Y) || Qe(Y) && isNaN(Y.getTime()) || Ue(Y, N(i, m, Y));
    };
    if (S) {
      let Y, ue;
      const ce = w(), Be = d.type === Ps.BLUR || d.type === Ps.FOCUS_OUT, Dn = !Uo(S._f) && !e.resolver && !N(t.errors, m) && !S._f.deps || qo(Be, N(t.touchedFields, m), t.isSubmitted, v, p), Cr = Vs(m, o, Be);
      ne(i, m, ce), Be ? (S._f.onBlur && S._f.onBlur(d), l && l(0)) : S._f.onChange && S._f.onChange(d);
      const wr = P(m, ce, Be, !1), $n = !ve(wr) || Cr;
      if (!Be && f.values.next({
        name: m,
        type: d.type,
        values: { ...i }
      }), Dn)
        return c.isValid && (e.mode === "onBlur" && Be ? L() : Be || L()), $n && f.state.next({ name: m, ...Cr ? {} : wr });
      if (!Be && Cr && f.state.next({ ...t }), e.resolver) {
        const { errors: us } = await $([m]);
        if (B(ce), A) {
          const Mn = Bs(t.errors, s, m), cs = Bs(us, s, Mn.name || m);
          Y = cs.error, m = cs.name, ue = ve(us);
        }
      } else
        V([m], !0), Y = (await Ms(S, o.disabled, i, x, e.shouldUseNativeValidation))[m], V([m]), B(ce), A && (Y ? ue = !1 : c.isValid && (ue = await Q(s, !0)));
      A && (S._f.deps && K(S._f.deps), O(m, ue, Y, wr));
    }
  }, G = (d, g) => {
    if (N(t.errors, g) && d.focus)
      return d.focus(), 1;
  }, K = async (d, g = {}) => {
    let m, A;
    const S = Gt(d);
    if (e.resolver) {
      const w = await J(oe(d) ? d : S);
      m = ve(w), A = d ? !S.some((B) => N(w, B)) : m;
    } else
      d ? (A = (await Promise.all(S.map(async (w) => {
        const B = N(s, w);
        return await Q(B && B._f ? { [w]: B } : B);
      }))).every(Boolean), !(!A && !t.isValid) && L()) : A = m = await Q(s);
    return f.state.next({
      ...!Pe(d) || c.isValid && m !== t.isValid ? {} : { name: d },
      ...e.resolver || !d ? { isValid: m } : {},
      errors: t.errors
    }), g.shouldFocus && !A && Ot(s, G, d ? S : o.mount), A;
  }, Ae = (d) => {
    const g = {
      ...a.mount ? i : n
    };
    return oe(d) ? g : Pe(d) ? N(g, d) : d.map((m) => N(g, m));
  }, Kt = (d, g) => ({
    invalid: !!N((g || t).errors, d),
    isDirty: !!N((g || t).dirtyFields, d),
    error: N((g || t).errors, d),
    isValidating: !!N(t.validatingFields, d),
    isTouched: !!N((g || t).touchedFields, d)
  }), me = (d) => {
    d && Gt(d).forEach((g) => le(t.errors, g)), f.state.next({
      errors: d ? t.errors : {}
    });
  }, Ge = (d, g, m) => {
    const A = (N(s, d, { _f: {} })._f || {}).ref, S = N(t.errors, d) || {}, { ref: w, message: B, type: Y, ...ue } = S;
    ne(t.errors, d, {
      ...ue,
      ...g,
      ref: A
    }), f.state.next({
      name: d,
      errors: t.errors,
      isValid: !1
    }), m && m.shouldFocus && A && A.focus && A.focus();
  }, Vn = (d, g) => Ne(d) ? f.values.subscribe({
    next: (m) => d(M(void 0, g), m)
  }) : M(d, g, !0), _r = (d, g = {}) => {
    for (const m of d ? Gt(d) : o.mount)
      o.mount.delete(m), o.array.delete(m), g.keepValue || (le(s, m), le(i, m)), !g.keepError && le(t.errors, m), !g.keepDirty && le(t.dirtyFields, m), !g.keepTouched && le(t.touchedFields, m), !g.keepIsValidating && le(t.validatingFields, m), !e.shouldUnregister && !g.keepDefaultValue && le(n, m);
    f.values.next({
      values: { ...i }
    }), f.state.next({
      ...t,
      ...g.keepDirty ? { isDirty: R() } : {}
    }), !g.keepIsValid && L();
  }, ns = ({ disabled: d, name: g, field: m, fields: A }) => {
    (Te(d) && a.mount || d || o.disabled.has(g)) && (d ? o.disabled.add(g) : o.disabled.delete(g), P(g, Pr(m ? m._f : N(A, g)._f), !1, !1, !0));
  }, xr = (d, g = {}) => {
    let m = N(s, d);
    const A = Te(g.disabled) || Te(e.disabled);
    return ne(s, d, {
      ...m || {},
      _f: {
        ...m && m._f ? m._f : { ref: { name: d } },
        name: d,
        mount: !0,
        ...g
      }
    }), o.mount.add(d), m ? ns({
      field: m,
      disabled: Te(g.disabled) ? g.disabled : e.disabled,
      name: d
    }) : Z(d, !0, g.value), {
      ...A ? { disabled: g.disabled || e.disabled } : {},
      ...e.progressive ? {
        required: !!g.required,
        min: xt(g.min),
        max: xt(g.max),
        minLength: xt(g.minLength),
        maxLength: xt(g.maxLength),
        pattern: xt(g.pattern)
      } : {},
      name: d,
      onChange: j,
      onBlur: j,
      ref: (S) => {
        if (S) {
          xr(d, g), m = N(s, d);
          const w = oe(S.value) && S.querySelectorAll && S.querySelectorAll("input,select,textarea")[0] || S, B = Mo(w), Y = m._f.refs || [];
          if (B ? Y.find((ue) => ue === w) : w === m._f.ref)
            return;
          ne(s, d, {
            _f: {
              ...m._f,
              ...B ? {
                refs: [
                  ...Y.filter(Rr),
                  w,
                  ...Array.isArray(N(n, d)) ? [{}] : []
                ],
                ref: { type: w.type, name: d }
              } : { ref: w }
            }
          }), Z(d, !1, void 0, w);
        } else
          m = N(s, d, {}), m._f && (m._f.mount = !1), (e.shouldUnregister || g.shouldUnregister) && !(No(o.array, d) && a.action) && o.unMount.add(d);
      }
    };
  }, is = () => e.shouldFocusError && Ot(s, G, o.mount), Fn = (d) => {
    Te(d) && (f.state.next({ disabled: d }), Ot(s, (g, m) => {
      const A = N(s, m);
      A && (g.disabled = A._f.disabled || d, Array.isArray(A._f.refs) && A._f.refs.forEach((S) => {
        S.disabled = A._f.disabled || d;
      }));
    }, 0, !1));
  }, as = (d, g) => async (m) => {
    let A;
    m && (m.preventDefault && m.preventDefault(), m.persist && m.persist());
    let S = xe(i);
    if (o.disabled.size)
      for (const w of o.disabled)
        ne(S, w, void 0);
    if (f.state.next({
      isSubmitting: !0
    }), e.resolver) {
      const { errors: w, values: B } = await $();
      t.errors = w, S = B;
    } else
      await Q(s);
    if (le(t.errors, "root"), ve(t.errors)) {
      f.state.next({
        errors: {}
      });
      try {
        await d(S, m);
      } catch (w) {
        A = w;
      }
    } else
      g && await g({ ...t.errors }, m), is(), setTimeout(is);
    if (f.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: ve(t.errors) && !A,
      submitCount: t.submitCount + 1,
      errors: t.errors
    }), A)
      throw A;
  }, In = (d, g = {}) => {
    N(s, d) && (oe(g.defaultValue) ? I(d, xe(N(n, d))) : (I(d, g.defaultValue), ne(n, d, xe(g.defaultValue))), g.keepTouched || le(t.touchedFields, d), g.keepDirty || (le(t.dirtyFields, d), t.isDirty = g.defaultValue ? R(d, xe(N(n, d))) : R()), g.keepError || (le(t.errors, d), c.isValid && L()), f.state.next({ ...t }));
  }, os = (d, g = {}) => {
    const m = d ? xe(d) : n, A = xe(m), S = ve(d), w = S ? n : A;
    if (g.keepDefaultValues || (n = m), !g.keepValues) {
      if (g.keepDirtyValues) {
        const B = /* @__PURE__ */ new Set([
          ...o.mount,
          ...Object.keys(_t(n, i))
        ]);
        for (const Y of Array.from(B))
          N(t.dirtyFields, Y) ? ne(w, Y, N(i, Y)) : I(Y, N(w, Y));
      } else {
        if (Qr && oe(d))
          for (const B of o.mount) {
            const Y = N(s, B);
            if (Y && Y._f) {
              const ue = Array.isArray(Y._f.refs) ? Y._f.refs[0] : Y._f.ref;
              if (ir(ue)) {
                const ce = ue.closest("form");
                if (ce) {
                  ce.reset();
                  break;
                }
              }
            }
          }
        s = {};
      }
      i = e.shouldUnregister ? g.keepDefaultValues ? xe(n) : {} : xe(w), f.array.next({
        values: { ...w }
      }), f.values.next({
        values: { ...w }
      });
    }
    o = {
      mount: g.keepDirtyValues ? o.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, a.mount = !c.isValid || !!g.keepIsValid || !!g.keepDirtyValues, a.watch = !!e.shouldUnregister, f.state.next({
      submitCount: g.keepSubmitCount ? t.submitCount : 0,
      isDirty: S ? !1 : g.keepDirty ? t.isDirty : !!(g.keepDefaultValues && !Ue(d, n)),
      isSubmitted: g.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: S ? {} : g.keepDirtyValues ? g.keepDefaultValues && i ? _t(n, i) : t.dirtyFields : g.keepDefaultValues && d ? _t(n, d) : g.keepDirty ? t.dirtyFields : {},
      touchedFields: g.keepTouched ? t.touchedFields : {},
      errors: g.keepErrors ? t.errors : {},
      isSubmitSuccessful: g.keepIsSubmitSuccessful ? t.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, ls = (d, g) => os(Ne(d) ? d(i) : d, g);
  return {
    control: {
      register: xr,
      unregister: _r,
      getFieldState: Kt,
      handleSubmit: as,
      setError: Ge,
      _executeSchema: $,
      _getWatch: M,
      _getDirty: R,
      _updateValid: L,
      _removeUnmounted: se,
      _updateFieldArray: k,
      _updateDisabledField: ns,
      _getFieldArray: ee,
      _reset: os,
      _resetDefaultValues: () => Ne(e.defaultValues) && e.defaultValues().then((d) => {
        ls(d, e.resetOptions), f.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (d) => {
        t = {
          ...t,
          ...d
        };
      },
      _disableForm: Fn,
      _subjects: f,
      _proxyFormState: c,
      _setErrors: D,
      get _fields() {
        return s;
      },
      get _formValues() {
        return i;
      },
      get _state() {
        return a;
      },
      set _state(d) {
        a = d;
      },
      get _defaultValues() {
        return n;
      },
      get _names() {
        return o;
      },
      set _names(d) {
        o = d;
      },
      get _formState() {
        return t;
      },
      set _formState(d) {
        t = d;
      },
      get _options() {
        return e;
      },
      set _options(d) {
        e = {
          ...e,
          ...d
        };
      }
    },
    trigger: K,
    register: xr,
    handleSubmit: as,
    watch: Vn,
    setValue: I,
    getValues: Ae,
    reset: ls,
    resetField: In,
    clearErrors: me,
    unregister: _r,
    setError: Ge,
    setFocus: (d, g = {}) => {
      const m = N(s, d), A = m && m._f;
      if (A) {
        const S = A.refs ? A.refs[0] : A.ref;
        S.focus && (S.focus(), g.shouldSelect && Ne(S.select) && S.select());
      }
    },
    getFieldState: Kt
  };
}
function Wo(r = {}) {
  const e = Ce.useRef(void 0), t = Ce.useRef(void 0), [s, n] = Ce.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Ne(r.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: r.errors || {},
    disabled: r.disabled || !1,
    defaultValues: Ne(r.defaultValues) ? void 0 : r.defaultValues
  });
  e.current || (e.current = {
    ...Ko(r),
    formState: s
  });
  const i = e.current.control;
  return i._options = r, Vo({
    subject: i._subjects.state,
    next: (a) => {
      jo(a, i._proxyFormState, i._updateFormState) && n({ ...i._formState });
    }
  }), Ce.useEffect(() => i._disableForm(r.disabled), [i, r.disabled]), Ce.useEffect(() => {
    if (i._proxyFormState.isDirty) {
      const a = i._getDirty();
      a !== s.isDirty && i._subjects.state.next({
        isDirty: a
      });
    }
  }, [i, s.isDirty]), Ce.useEffect(() => {
    r.values && !Ue(r.values, t.current) ? (i._reset(r.values, i._options.resetOptions), t.current = r.values, n((a) => ({ ...a }))) : i._resetDefaultValues();
  }, [r.values, i]), Ce.useEffect(() => {
    r.errors && i._setErrors(r.errors);
  }, [r.errors, i]), Ce.useEffect(() => {
    i._state.mount || (i._updateValid(), i._state.mount = !0), i._state.watch && (i._state.watch = !1, i._subjects.state.next({ ...i._formState })), i._removeUnmounted();
  }), Ce.useEffect(() => {
    r.shouldUnregister && i._subjects.values.next({
      values: i._getWatch()
    });
  }, [r.shouldUnregister, i]), e.current.formState = Po(s, i), e.current;
}
var te;
(function(r) {
  r.assertEqual = (n) => n;
  function e(n) {
  }
  r.assertIs = e;
  function t(n) {
    throw new Error();
  }
  r.assertNever = t, r.arrayToEnum = (n) => {
    const i = {};
    for (const a of n)
      i[a] = a;
    return i;
  }, r.getValidEnumValues = (n) => {
    const i = r.objectKeys(n).filter((o) => typeof n[n[o]] != "number"), a = {};
    for (const o of i)
      a[o] = n[o];
    return r.objectValues(a);
  }, r.objectValues = (n) => r.objectKeys(n).map(function(i) {
    return n[i];
  }), r.objectKeys = typeof Object.keys == "function" ? (n) => Object.keys(n) : (n) => {
    const i = [];
    for (const a in n)
      Object.prototype.hasOwnProperty.call(n, a) && i.push(a);
    return i;
  }, r.find = (n, i) => {
    for (const a of n)
      if (i(a))
        return a;
  }, r.isInteger = typeof Number.isInteger == "function" ? (n) => Number.isInteger(n) : (n) => typeof n == "number" && isFinite(n) && Math.floor(n) === n;
  function s(n, i = " | ") {
    return n.map((a) => typeof a == "string" ? `'${a}'` : a).join(i);
  }
  r.joinValues = s, r.jsonStringifyReplacer = (n, i) => typeof i == "bigint" ? i.toString() : i;
})(te || (te = {}));
var qr;
(function(r) {
  r.mergeShapes = (e, t) => ({
    ...e,
    ...t
    // second overwrites first
  });
})(qr || (qr = {}));
const T = te.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), $e = (r) => {
  switch (typeof r) {
    case "undefined":
      return T.undefined;
    case "string":
      return T.string;
    case "number":
      return isNaN(r) ? T.nan : T.number;
    case "boolean":
      return T.boolean;
    case "function":
      return T.function;
    case "bigint":
      return T.bigint;
    case "symbol":
      return T.symbol;
    case "object":
      return Array.isArray(r) ? T.array : r === null ? T.null : r.then && typeof r.then == "function" && r.catch && typeof r.catch == "function" ? T.promise : typeof Map < "u" && r instanceof Map ? T.map : typeof Set < "u" && r instanceof Set ? T.set : typeof Date < "u" && r instanceof Date ? T.date : T.object;
    default:
      return T.unknown;
  }
}, b = te.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), Jo = (r) => JSON.stringify(r, null, 2).replace(/"([^"]+)":/g, "$1:");
class be extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (s) => {
      this.issues = [...this.issues, s];
    }, this.addIssues = (s = []) => {
      this.issues = [...this.issues, ...s];
    };
    const t = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, t) : this.__proto__ = t, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const t = e || function(i) {
      return i.message;
    }, s = { _errors: [] }, n = (i) => {
      for (const a of i.issues)
        if (a.code === "invalid_union")
          a.unionErrors.map(n);
        else if (a.code === "invalid_return_type")
          n(a.returnTypeError);
        else if (a.code === "invalid_arguments")
          n(a.argumentsError);
        else if (a.path.length === 0)
          s._errors.push(t(a));
        else {
          let o = s, l = 0;
          for (; l < a.path.length; ) {
            const u = a.path[l];
            l === a.path.length - 1 ? (o[u] = o[u] || { _errors: [] }, o[u]._errors.push(t(a))) : o[u] = o[u] || { _errors: [] }, o = o[u], l++;
          }
        }
    };
    return n(this), s;
  }
  static assert(e) {
    if (!(e instanceof be))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, te.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (t) => t.message) {
    const t = {}, s = [];
    for (const n of this.issues)
      n.path.length > 0 ? (t[n.path[0]] = t[n.path[0]] || [], t[n.path[0]].push(e(n))) : s.push(e(n));
    return { formErrors: s, fieldErrors: t };
  }
  get formErrors() {
    return this.flatten();
  }
}
be.create = (r) => new be(r);
const gt = (r, e) => {
  let t;
  switch (r.code) {
    case b.invalid_type:
      r.received === T.undefined ? t = "Required" : t = `Expected ${r.expected}, received ${r.received}`;
      break;
    case b.invalid_literal:
      t = `Invalid literal value, expected ${JSON.stringify(r.expected, te.jsonStringifyReplacer)}`;
      break;
    case b.unrecognized_keys:
      t = `Unrecognized key(s) in object: ${te.joinValues(r.keys, ", ")}`;
      break;
    case b.invalid_union:
      t = "Invalid input";
      break;
    case b.invalid_union_discriminator:
      t = `Invalid discriminator value. Expected ${te.joinValues(r.options)}`;
      break;
    case b.invalid_enum_value:
      t = `Invalid enum value. Expected ${te.joinValues(r.options)}, received '${r.received}'`;
      break;
    case b.invalid_arguments:
      t = "Invalid function arguments";
      break;
    case b.invalid_return_type:
      t = "Invalid function return type";
      break;
    case b.invalid_date:
      t = "Invalid date";
      break;
    case b.invalid_string:
      typeof r.validation == "object" ? "includes" in r.validation ? (t = `Invalid input: must include "${r.validation.includes}"`, typeof r.validation.position == "number" && (t = `${t} at one or more positions greater than or equal to ${r.validation.position}`)) : "startsWith" in r.validation ? t = `Invalid input: must start with "${r.validation.startsWith}"` : "endsWith" in r.validation ? t = `Invalid input: must end with "${r.validation.endsWith}"` : te.assertNever(r.validation) : r.validation !== "regex" ? t = `Invalid ${r.validation}` : t = "Invalid";
      break;
    case b.too_small:
      r.type === "array" ? t = `Array must contain ${r.exact ? "exactly" : r.inclusive ? "at least" : "more than"} ${r.minimum} element(s)` : r.type === "string" ? t = `String must contain ${r.exact ? "exactly" : r.inclusive ? "at least" : "over"} ${r.minimum} character(s)` : r.type === "number" ? t = `Number must be ${r.exact ? "exactly equal to " : r.inclusive ? "greater than or equal to " : "greater than "}${r.minimum}` : r.type === "date" ? t = `Date must be ${r.exact ? "exactly equal to " : r.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(r.minimum))}` : t = "Invalid input";
      break;
    case b.too_big:
      r.type === "array" ? t = `Array must contain ${r.exact ? "exactly" : r.inclusive ? "at most" : "less than"} ${r.maximum} element(s)` : r.type === "string" ? t = `String must contain ${r.exact ? "exactly" : r.inclusive ? "at most" : "under"} ${r.maximum} character(s)` : r.type === "number" ? t = `Number must be ${r.exact ? "exactly" : r.inclusive ? "less than or equal to" : "less than"} ${r.maximum}` : r.type === "bigint" ? t = `BigInt must be ${r.exact ? "exactly" : r.inclusive ? "less than or equal to" : "less than"} ${r.maximum}` : r.type === "date" ? t = `Date must be ${r.exact ? "exactly" : r.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(r.maximum))}` : t = "Invalid input";
      break;
    case b.custom:
      t = "Invalid input";
      break;
    case b.invalid_intersection_types:
      t = "Intersection results could not be merged";
      break;
    case b.not_multiple_of:
      t = `Number must be a multiple of ${r.multipleOf}`;
      break;
    case b.not_finite:
      t = "Number must be finite";
      break;
    default:
      t = e.defaultError, te.assertNever(r);
  }
  return { message: t };
};
let Sn = gt;
function Xo(r) {
  Sn = r;
}
function lr() {
  return Sn;
}
const ur = (r) => {
  const { data: e, path: t, errorMaps: s, issueData: n } = r, i = [...t, ...n.path || []], a = {
    ...n,
    path: i
  };
  if (n.message !== void 0)
    return {
      ...n,
      path: i,
      message: n.message
    };
  let o = "";
  const l = s.filter((u) => !!u).slice().reverse();
  for (const u of l)
    o = u(a, { data: e, defaultError: o }).message;
  return {
    ...n,
    path: i,
    message: o
  };
}, Go = [];
function E(r, e) {
  const t = lr(), s = ur({
    issueData: e,
    data: r.data,
    path: r.path,
    errorMaps: [
      r.common.contextualErrorMap,
      // contextual error map is first priority
      r.schemaErrorMap,
      // then schema-bound map if available
      t,
      // then global override map
      t === gt ? void 0 : gt
      // then global default map
    ].filter((n) => !!n)
  });
  r.common.issues.push(s);
}
class he {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, t) {
    const s = [];
    for (const n of t) {
      if (n.status === "aborted")
        return H;
      n.status === "dirty" && e.dirty(), s.push(n.value);
    }
    return { status: e.value, value: s };
  }
  static async mergeObjectAsync(e, t) {
    const s = [];
    for (const n of t) {
      const i = await n.key, a = await n.value;
      s.push({
        key: i,
        value: a
      });
    }
    return he.mergeObjectSync(e, s);
  }
  static mergeObjectSync(e, t) {
    const s = {};
    for (const n of t) {
      const { key: i, value: a } = n;
      if (i.status === "aborted" || a.status === "aborted")
        return H;
      i.status === "dirty" && e.dirty(), a.status === "dirty" && e.dirty(), i.value !== "__proto__" && (typeof a.value < "u" || n.alwaysSet) && (s[i.value] = a.value);
    }
    return { status: e.value, value: s };
  }
}
const H = Object.freeze({
  status: "aborted"
}), dt = (r) => ({ status: "dirty", value: r }), ge = (r) => ({ status: "valid", value: r }), Hr = (r) => r.status === "aborted", zr = (r) => r.status === "dirty", st = (r) => r.status === "valid", Nt = (r) => typeof Promise < "u" && r instanceof Promise;
function cr(r, e, t, s) {
  if (typeof e == "function" ? r !== e || !0 : !e.has(r))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(r);
}
function kn(r, e, t, s, n) {
  if (typeof e == "function" ? r !== e || !0 : !e.has(r))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(r, t), t;
}
var F;
(function(r) {
  r.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, r.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(F || (F = {}));
var Ct, wt;
class Ve {
  constructor(e, t, s, n) {
    this._cachedPath = [], this.parent = e, this.data = t, this._path = s, this._key = n;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Us = (r, e) => {
  if (st(e))
    return { success: !0, data: e.value };
  if (!r.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const t = new be(r.common.issues);
      return this._error = t, this._error;
    }
  };
};
function W(r) {
  if (!r)
    return {};
  const { errorMap: e, invalid_type_error: t, required_error: s, description: n } = r;
  if (e && (t || s))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: n } : { errorMap: (a, o) => {
    var l, u;
    const { message: c } = r;
    return a.code === "invalid_enum_value" ? { message: c ?? o.defaultError } : typeof o.data > "u" ? { message: (l = c ?? s) !== null && l !== void 0 ? l : o.defaultError } : a.code !== "invalid_type" ? { message: o.defaultError } : { message: (u = c ?? t) !== null && u !== void 0 ? u : o.defaultError };
  }, description: n };
}
class X {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return $e(e.data);
  }
  _getOrReturnCtx(e, t) {
    return t || {
      common: e.parent.common,
      data: e.data,
      parsedType: $e(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new he(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: $e(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const t = this._parse(e);
    if (Nt(t))
      throw new Error("Synchronous parse encountered promise.");
    return t;
  }
  _parseAsync(e) {
    const t = this._parse(e);
    return Promise.resolve(t);
  }
  parse(e, t) {
    const s = this.safeParse(e, t);
    if (s.success)
      return s.data;
    throw s.error;
  }
  safeParse(e, t) {
    var s;
    const n = {
      common: {
        issues: [],
        async: (s = t == null ? void 0 : t.async) !== null && s !== void 0 ? s : !1,
        contextualErrorMap: t == null ? void 0 : t.errorMap
      },
      path: (t == null ? void 0 : t.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: $e(e)
    }, i = this._parseSync({ data: e, path: n.path, parent: n });
    return Us(n, i);
  }
  "~validate"(e) {
    var t, s;
    const n = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: $e(e)
    };
    if (!this["~standard"].async)
      try {
        const i = this._parseSync({ data: e, path: [], parent: n });
        return st(i) ? {
          value: i.value
        } : {
          issues: n.common.issues
        };
      } catch (i) {
        !((s = (t = i == null ? void 0 : i.message) === null || t === void 0 ? void 0 : t.toLowerCase()) === null || s === void 0) && s.includes("encountered") && (this["~standard"].async = !0), n.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: n }).then((i) => st(i) ? {
      value: i.value
    } : {
      issues: n.common.issues
    });
  }
  async parseAsync(e, t) {
    const s = await this.safeParseAsync(e, t);
    if (s.success)
      return s.data;
    throw s.error;
  }
  async safeParseAsync(e, t) {
    const s = {
      common: {
        issues: [],
        contextualErrorMap: t == null ? void 0 : t.errorMap,
        async: !0
      },
      path: (t == null ? void 0 : t.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: $e(e)
    }, n = this._parse({ data: e, path: s.path, parent: s }), i = await (Nt(n) ? n : Promise.resolve(n));
    return Us(s, i);
  }
  refine(e, t) {
    const s = (n) => typeof t == "string" || typeof t > "u" ? { message: t } : typeof t == "function" ? t(n) : t;
    return this._refinement((n, i) => {
      const a = e(n), o = () => i.addIssue({
        code: b.custom,
        ...s(n)
      });
      return typeof Promise < "u" && a instanceof Promise ? a.then((l) => l ? !0 : (o(), !1)) : a ? !0 : (o(), !1);
    });
  }
  refinement(e, t) {
    return this._refinement((s, n) => e(s) ? !0 : (n.addIssue(typeof t == "function" ? t(s, n) : t), !1));
  }
  _refinement(e) {
    return new Le({
      schema: this,
      typeName: q.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (t) => this["~validate"](t)
    };
  }
  optional() {
    return je.create(this, this._def);
  }
  nullable() {
    return Xe.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Ee.create(this);
  }
  promise() {
    return yt.create(this, this._def);
  }
  or(e) {
    return Vt.create([this, e], this._def);
  }
  and(e) {
    return Ft.create(this, e, this._def);
  }
  transform(e) {
    return new Le({
      ...W(this._def),
      schema: this,
      typeName: q.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const t = typeof e == "function" ? e : () => e;
    return new Zt({
      ...W(this._def),
      innerType: this,
      defaultValue: t,
      typeName: q.ZodDefault
    });
  }
  brand() {
    return new ss({
      typeName: q.ZodBranded,
      type: this,
      ...W(this._def)
    });
  }
  catch(e) {
    const t = typeof e == "function" ? e : () => e;
    return new Bt({
      ...W(this._def),
      innerType: this,
      catchValue: t,
      typeName: q.ZodCatch
    });
  }
  describe(e) {
    const t = this.constructor;
    return new t({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return zt.create(this, e);
  }
  readonly() {
    return Ut.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Yo = /^c[^\s-]{8,}$/i, Qo = /^[0-9a-z]+$/, el = /^[0-9A-HJKMNP-TV-Z]{26}$/i, tl = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, rl = /^[a-z0-9_-]{21}$/i, sl = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, nl = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, il = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, al = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let jr;
const ol = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, ll = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, ul = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, cl = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, dl = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, fl = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, On = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", hl = new RegExp(`^${On}$`);
function En(r) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return r.precision ? e = `${e}\\.\\d{${r.precision}}` : r.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function pl(r) {
  return new RegExp(`^${En(r)}$`);
}
function Ln(r) {
  let e = `${On}T${En(r)}`;
  const t = [];
  return t.push(r.local ? "Z?" : "Z"), r.offset && t.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${t.join("|")})`, new RegExp(`^${e}$`);
}
function gl(r, e) {
  return !!((e === "v4" || !e) && ol.test(r) || (e === "v6" || !e) && ul.test(r));
}
function ml(r, e) {
  if (!sl.test(r))
    return !1;
  try {
    const [t] = r.split("."), s = t.replace(/-/g, "+").replace(/_/g, "/").padEnd(t.length + (4 - t.length % 4) % 4, "="), n = JSON.parse(atob(s));
    return !(typeof n != "object" || n === null || !n.typ || !n.alg || e && n.alg !== e);
  } catch {
    return !1;
  }
}
function yl(r, e) {
  return !!((e === "v4" || !e) && ll.test(r) || (e === "v6" || !e) && cl.test(r));
}
class Oe extends X {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== T.string) {
      const i = this._getOrReturnCtx(e);
      return E(i, {
        code: b.invalid_type,
        expected: T.string,
        received: i.parsedType
      }), H;
    }
    const s = new he();
    let n;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (n = this._getOrReturnCtx(e, n), E(n, {
          code: b.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), s.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (n = this._getOrReturnCtx(e, n), E(n, {
          code: b.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), s.dirty());
      else if (i.kind === "length") {
        const a = e.data.length > i.value, o = e.data.length < i.value;
        (a || o) && (n = this._getOrReturnCtx(e, n), a ? E(n, {
          code: b.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : o && E(n, {
          code: b.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), s.dirty());
      } else if (i.kind === "email")
        il.test(e.data) || (n = this._getOrReturnCtx(e, n), E(n, {
          validation: "email",
          code: b.invalid_string,
          message: i.message
        }), s.dirty());
      else if (i.kind === "emoji")
        jr || (jr = new RegExp(al, "u")), jr.test(e.data) || (n = this._getOrReturnCtx(e, n), E(n, {
          validation: "emoji",
          code: b.invalid_string,
          message: i.message
        }), s.dirty());
      else if (i.kind === "uuid")
        tl.test(e.data) || (n = this._getOrReturnCtx(e, n), E(n, {
          validation: "uuid",
          code: b.invalid_string,
          message: i.message
        }), s.dirty());
      else if (i.kind === "nanoid")
        rl.test(e.data) || (n = this._getOrReturnCtx(e, n), E(n, {
          validation: "nanoid",
          code: b.invalid_string,
          message: i.message
        }), s.dirty());
      else if (i.kind === "cuid")
        Yo.test(e.data) || (n = this._getOrReturnCtx(e, n), E(n, {
          validation: "cuid",
          code: b.invalid_string,
          message: i.message
        }), s.dirty());
      else if (i.kind === "cuid2")
        Qo.test(e.data) || (n = this._getOrReturnCtx(e, n), E(n, {
          validation: "cuid2",
          code: b.invalid_string,
          message: i.message
        }), s.dirty());
      else if (i.kind === "ulid")
        el.test(e.data) || (n = this._getOrReturnCtx(e, n), E(n, {
          validation: "ulid",
          code: b.invalid_string,
          message: i.message
        }), s.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          n = this._getOrReturnCtx(e, n), E(n, {
            validation: "url",
            code: b.invalid_string,
            message: i.message
          }), s.dirty();
        }
      else
        i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (n = this._getOrReturnCtx(e, n), E(n, {
          validation: "regex",
          code: b.invalid_string,
          message: i.message
        }), s.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "includes" ? e.data.includes(i.value, i.position) || (n = this._getOrReturnCtx(e, n), E(n, {
          code: b.invalid_string,
          validation: { includes: i.value, position: i.position },
          message: i.message
        }), s.dirty()) : i.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : i.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (n = this._getOrReturnCtx(e, n), E(n, {
          code: b.invalid_string,
          validation: { startsWith: i.value },
          message: i.message
        }), s.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (n = this._getOrReturnCtx(e, n), E(n, {
          code: b.invalid_string,
          validation: { endsWith: i.value },
          message: i.message
        }), s.dirty()) : i.kind === "datetime" ? Ln(i).test(e.data) || (n = this._getOrReturnCtx(e, n), E(n, {
          code: b.invalid_string,
          validation: "datetime",
          message: i.message
        }), s.dirty()) : i.kind === "date" ? hl.test(e.data) || (n = this._getOrReturnCtx(e, n), E(n, {
          code: b.invalid_string,
          validation: "date",
          message: i.message
        }), s.dirty()) : i.kind === "time" ? pl(i).test(e.data) || (n = this._getOrReturnCtx(e, n), E(n, {
          code: b.invalid_string,
          validation: "time",
          message: i.message
        }), s.dirty()) : i.kind === "duration" ? nl.test(e.data) || (n = this._getOrReturnCtx(e, n), E(n, {
          validation: "duration",
          code: b.invalid_string,
          message: i.message
        }), s.dirty()) : i.kind === "ip" ? gl(e.data, i.version) || (n = this._getOrReturnCtx(e, n), E(n, {
          validation: "ip",
          code: b.invalid_string,
          message: i.message
        }), s.dirty()) : i.kind === "jwt" ? ml(e.data, i.alg) || (n = this._getOrReturnCtx(e, n), E(n, {
          validation: "jwt",
          code: b.invalid_string,
          message: i.message
        }), s.dirty()) : i.kind === "cidr" ? yl(e.data, i.version) || (n = this._getOrReturnCtx(e, n), E(n, {
          validation: "cidr",
          code: b.invalid_string,
          message: i.message
        }), s.dirty()) : i.kind === "base64" ? dl.test(e.data) || (n = this._getOrReturnCtx(e, n), E(n, {
          validation: "base64",
          code: b.invalid_string,
          message: i.message
        }), s.dirty()) : i.kind === "base64url" ? fl.test(e.data) || (n = this._getOrReturnCtx(e, n), E(n, {
          validation: "base64url",
          code: b.invalid_string,
          message: i.message
        }), s.dirty()) : te.assertNever(i);
    return { status: s.value, value: e.data };
  }
  _regex(e, t, s) {
    return this.refinement((n) => e.test(n), {
      validation: t,
      code: b.invalid_string,
      ...F.errToObj(s)
    });
  }
  _addCheck(e) {
    return new Oe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...F.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...F.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...F.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...F.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...F.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...F.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...F.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...F.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...F.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...F.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...F.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...F.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...F.errToObj(e) });
  }
  datetime(e) {
    var t, s;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (t = e == null ? void 0 : e.offset) !== null && t !== void 0 ? t : !1,
      local: (s = e == null ? void 0 : e.local) !== null && s !== void 0 ? s : !1,
      ...F.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...F.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...F.errToObj(e) });
  }
  regex(e, t) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...F.errToObj(t)
    });
  }
  includes(e, t) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: t == null ? void 0 : t.position,
      ...F.errToObj(t == null ? void 0 : t.message)
    });
  }
  startsWith(e, t) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...F.errToObj(t)
    });
  }
  endsWith(e, t) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...F.errToObj(t)
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...F.errToObj(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...F.errToObj(t)
    });
  }
  length(e, t) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...F.errToObj(t)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, F.errToObj(e));
  }
  trim() {
    return new Oe({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Oe({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Oe({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
Oe.create = (r) => {
  var e;
  return new Oe({
    checks: [],
    typeName: q.ZodString,
    coerce: (e = r == null ? void 0 : r.coerce) !== null && e !== void 0 ? e : !1,
    ...W(r)
  });
};
function vl(r, e) {
  const t = (r.toString().split(".")[1] || "").length, s = (e.toString().split(".")[1] || "").length, n = t > s ? t : s, i = parseInt(r.toFixed(n).replace(".", "")), a = parseInt(e.toFixed(n).replace(".", ""));
  return i % a / Math.pow(10, n);
}
class Ke extends X {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== T.number) {
      const i = this._getOrReturnCtx(e);
      return E(i, {
        code: b.invalid_type,
        expected: T.number,
        received: i.parsedType
      }), H;
    }
    let s;
    const n = new he();
    for (const i of this._def.checks)
      i.kind === "int" ? te.isInteger(e.data) || (s = this._getOrReturnCtx(e, s), E(s, {
        code: b.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), n.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (s = this._getOrReturnCtx(e, s), E(s, {
        code: b.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), n.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (s = this._getOrReturnCtx(e, s), E(s, {
        code: b.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), n.dirty()) : i.kind === "multipleOf" ? vl(e.data, i.value) !== 0 && (s = this._getOrReturnCtx(e, s), E(s, {
        code: b.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), n.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (s = this._getOrReturnCtx(e, s), E(s, {
        code: b.not_finite,
        message: i.message
      }), n.dirty()) : te.assertNever(i);
    return { status: n.value, value: e.data };
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, F.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, F.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, F.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, F.toString(t));
  }
  setLimit(e, t, s, n) {
    return new Ke({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: s,
          message: F.toString(n)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Ke({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: F.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: F.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: F.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: F.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: F.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: F.toString(t)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: F.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: F.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: F.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && te.isInteger(e.value));
  }
  get isFinite() {
    let e = null, t = null;
    for (const s of this._def.checks) {
      if (s.kind === "finite" || s.kind === "int" || s.kind === "multipleOf")
        return !0;
      s.kind === "min" ? (t === null || s.value > t) && (t = s.value) : s.kind === "max" && (e === null || s.value < e) && (e = s.value);
    }
    return Number.isFinite(t) && Number.isFinite(e);
  }
}
Ke.create = (r) => new Ke({
  checks: [],
  typeName: q.ZodNumber,
  coerce: (r == null ? void 0 : r.coerce) || !1,
  ...W(r)
});
class We extends X {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== T.bigint)
      return this._getInvalidInput(e);
    let s;
    const n = new he();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (s = this._getOrReturnCtx(e, s), E(s, {
        code: b.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), n.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (s = this._getOrReturnCtx(e, s), E(s, {
        code: b.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), n.dirty()) : i.kind === "multipleOf" ? e.data % i.value !== BigInt(0) && (s = this._getOrReturnCtx(e, s), E(s, {
        code: b.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), n.dirty()) : te.assertNever(i);
    return { status: n.value, value: e.data };
  }
  _getInvalidInput(e) {
    const t = this._getOrReturnCtx(e);
    return E(t, {
      code: b.invalid_type,
      expected: T.bigint,
      received: t.parsedType
    }), H;
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, F.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, F.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, F.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, F.toString(t));
  }
  setLimit(e, t, s, n) {
    return new We({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: s,
          message: F.toString(n)
        }
      ]
    });
  }
  _addCheck(e) {
    return new We({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: F.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: F.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: F.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: F.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: F.toString(t)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
We.create = (r) => {
  var e;
  return new We({
    checks: [],
    typeName: q.ZodBigInt,
    coerce: (e = r == null ? void 0 : r.coerce) !== null && e !== void 0 ? e : !1,
    ...W(r)
  });
};
class Rt extends X {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== T.boolean) {
      const s = this._getOrReturnCtx(e);
      return E(s, {
        code: b.invalid_type,
        expected: T.boolean,
        received: s.parsedType
      }), H;
    }
    return ge(e.data);
  }
}
Rt.create = (r) => new Rt({
  typeName: q.ZodBoolean,
  coerce: (r == null ? void 0 : r.coerce) || !1,
  ...W(r)
});
class nt extends X {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== T.date) {
      const i = this._getOrReturnCtx(e);
      return E(i, {
        code: b.invalid_type,
        expected: T.date,
        received: i.parsedType
      }), H;
    }
    if (isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return E(i, {
        code: b.invalid_date
      }), H;
    }
    const s = new he();
    let n;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (n = this._getOrReturnCtx(e, n), E(n, {
        code: b.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), s.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (n = this._getOrReturnCtx(e, n), E(n, {
        code: b.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), s.dirty()) : te.assertNever(i);
    return {
      status: s.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new nt({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: F.toString(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: F.toString(t)
    });
  }
  get minDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
}
nt.create = (r) => new nt({
  checks: [],
  coerce: (r == null ? void 0 : r.coerce) || !1,
  typeName: q.ZodDate,
  ...W(r)
});
class dr extends X {
  _parse(e) {
    if (this._getType(e) !== T.symbol) {
      const s = this._getOrReturnCtx(e);
      return E(s, {
        code: b.invalid_type,
        expected: T.symbol,
        received: s.parsedType
      }), H;
    }
    return ge(e.data);
  }
}
dr.create = (r) => new dr({
  typeName: q.ZodSymbol,
  ...W(r)
});
class Pt extends X {
  _parse(e) {
    if (this._getType(e) !== T.undefined) {
      const s = this._getOrReturnCtx(e);
      return E(s, {
        code: b.invalid_type,
        expected: T.undefined,
        received: s.parsedType
      }), H;
    }
    return ge(e.data);
  }
}
Pt.create = (r) => new Pt({
  typeName: q.ZodUndefined,
  ...W(r)
});
class jt extends X {
  _parse(e) {
    if (this._getType(e) !== T.null) {
      const s = this._getOrReturnCtx(e);
      return E(s, {
        code: b.invalid_type,
        expected: T.null,
        received: s.parsedType
      }), H;
    }
    return ge(e.data);
  }
}
jt.create = (r) => new jt({
  typeName: q.ZodNull,
  ...W(r)
});
class mt extends X {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return ge(e.data);
  }
}
mt.create = (r) => new mt({
  typeName: q.ZodAny,
  ...W(r)
});
class et extends X {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return ge(e.data);
  }
}
et.create = (r) => new et({
  typeName: q.ZodUnknown,
  ...W(r)
});
class Ze extends X {
  _parse(e) {
    const t = this._getOrReturnCtx(e);
    return E(t, {
      code: b.invalid_type,
      expected: T.never,
      received: t.parsedType
    }), H;
  }
}
Ze.create = (r) => new Ze({
  typeName: q.ZodNever,
  ...W(r)
});
class fr extends X {
  _parse(e) {
    if (this._getType(e) !== T.undefined) {
      const s = this._getOrReturnCtx(e);
      return E(s, {
        code: b.invalid_type,
        expected: T.void,
        received: s.parsedType
      }), H;
    }
    return ge(e.data);
  }
}
fr.create = (r) => new fr({
  typeName: q.ZodVoid,
  ...W(r)
});
class Ee extends X {
  _parse(e) {
    const { ctx: t, status: s } = this._processInputParams(e), n = this._def;
    if (t.parsedType !== T.array)
      return E(t, {
        code: b.invalid_type,
        expected: T.array,
        received: t.parsedType
      }), H;
    if (n.exactLength !== null) {
      const a = t.data.length > n.exactLength.value, o = t.data.length < n.exactLength.value;
      (a || o) && (E(t, {
        code: a ? b.too_big : b.too_small,
        minimum: o ? n.exactLength.value : void 0,
        maximum: a ? n.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: n.exactLength.message
      }), s.dirty());
    }
    if (n.minLength !== null && t.data.length < n.minLength.value && (E(t, {
      code: b.too_small,
      minimum: n.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: n.minLength.message
    }), s.dirty()), n.maxLength !== null && t.data.length > n.maxLength.value && (E(t, {
      code: b.too_big,
      maximum: n.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: n.maxLength.message
    }), s.dirty()), t.common.async)
      return Promise.all([...t.data].map((a, o) => n.type._parseAsync(new Ve(t, a, t.path, o)))).then((a) => he.mergeArray(s, a));
    const i = [...t.data].map((a, o) => n.type._parseSync(new Ve(t, a, t.path, o)));
    return he.mergeArray(s, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, t) {
    return new Ee({
      ...this._def,
      minLength: { value: e, message: F.toString(t) }
    });
  }
  max(e, t) {
    return new Ee({
      ...this._def,
      maxLength: { value: e, message: F.toString(t) }
    });
  }
  length(e, t) {
    return new Ee({
      ...this._def,
      exactLength: { value: e, message: F.toString(t) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
Ee.create = (r, e) => new Ee({
  type: r,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: q.ZodArray,
  ...W(e)
});
function ut(r) {
  if (r instanceof ie) {
    const e = {};
    for (const t in r.shape) {
      const s = r.shape[t];
      e[t] = je.create(ut(s));
    }
    return new ie({
      ...r._def,
      shape: () => e
    });
  } else
    return r instanceof Ee ? new Ee({
      ...r._def,
      type: ut(r.element)
    }) : r instanceof je ? je.create(ut(r.unwrap())) : r instanceof Xe ? Xe.create(ut(r.unwrap())) : r instanceof Fe ? Fe.create(r.items.map((e) => ut(e))) : r;
}
class ie extends X {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), t = te.objectKeys(e);
    return this._cached = { shape: e, keys: t };
  }
  _parse(e) {
    if (this._getType(e) !== T.object) {
      const u = this._getOrReturnCtx(e);
      return E(u, {
        code: b.invalid_type,
        expected: T.object,
        received: u.parsedType
      }), H;
    }
    const { status: s, ctx: n } = this._processInputParams(e), { shape: i, keys: a } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof Ze && this._def.unknownKeys === "strip"))
      for (const u in n.data)
        a.includes(u) || o.push(u);
    const l = [];
    for (const u of a) {
      const c = i[u], f = n.data[u];
      l.push({
        key: { status: "valid", value: u },
        value: c._parse(new Ve(n, f, n.path, u)),
        alwaysSet: u in n.data
      });
    }
    if (this._def.catchall instanceof Ze) {
      const u = this._def.unknownKeys;
      if (u === "passthrough")
        for (const c of o)
          l.push({
            key: { status: "valid", value: c },
            value: { status: "valid", value: n.data[c] }
          });
      else if (u === "strict")
        o.length > 0 && (E(n, {
          code: b.unrecognized_keys,
          keys: o
        }), s.dirty());
      else if (u !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const c of o) {
        const f = n.data[c];
        l.push({
          key: { status: "valid", value: c },
          value: u._parse(
            new Ve(n, f, n.path, c)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: c in n.data
        });
      }
    }
    return n.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const c of l) {
        const f = await c.key, p = await c.value;
        u.push({
          key: f,
          value: p,
          alwaysSet: c.alwaysSet
        });
      }
      return u;
    }).then((u) => he.mergeObjectSync(s, u)) : he.mergeObjectSync(s, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return F.errToObj, new ie({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (t, s) => {
          var n, i, a, o;
          const l = (a = (i = (n = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(n, t, s).message) !== null && a !== void 0 ? a : s.defaultError;
          return t.code === "unrecognized_keys" ? {
            message: (o = F.errToObj(e).message) !== null && o !== void 0 ? o : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new ie({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new ie({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new ie({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new ie({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: q.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, t) {
    return this.augment({ [e]: t });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new ie({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const t = {};
    return te.objectKeys(e).forEach((s) => {
      e[s] && this.shape[s] && (t[s] = this.shape[s]);
    }), new ie({
      ...this._def,
      shape: () => t
    });
  }
  omit(e) {
    const t = {};
    return te.objectKeys(this.shape).forEach((s) => {
      e[s] || (t[s] = this.shape[s]);
    }), new ie({
      ...this._def,
      shape: () => t
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return ut(this);
  }
  partial(e) {
    const t = {};
    return te.objectKeys(this.shape).forEach((s) => {
      const n = this.shape[s];
      e && !e[s] ? t[s] = n : t[s] = n.optional();
    }), new ie({
      ...this._def,
      shape: () => t
    });
  }
  required(e) {
    const t = {};
    return te.objectKeys(this.shape).forEach((s) => {
      if (e && !e[s])
        t[s] = this.shape[s];
      else {
        let i = this.shape[s];
        for (; i instanceof je; )
          i = i._def.innerType;
        t[s] = i;
      }
    }), new ie({
      ...this._def,
      shape: () => t
    });
  }
  keyof() {
    return An(te.objectKeys(this.shape));
  }
}
ie.create = (r, e) => new ie({
  shape: () => r,
  unknownKeys: "strip",
  catchall: Ze.create(),
  typeName: q.ZodObject,
  ...W(e)
});
ie.strictCreate = (r, e) => new ie({
  shape: () => r,
  unknownKeys: "strict",
  catchall: Ze.create(),
  typeName: q.ZodObject,
  ...W(e)
});
ie.lazycreate = (r, e) => new ie({
  shape: r,
  unknownKeys: "strip",
  catchall: Ze.create(),
  typeName: q.ZodObject,
  ...W(e)
});
class Vt extends X {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), s = this._def.options;
    function n(i) {
      for (const o of i)
        if (o.result.status === "valid")
          return o.result;
      for (const o of i)
        if (o.result.status === "dirty")
          return t.common.issues.push(...o.ctx.common.issues), o.result;
      const a = i.map((o) => new be(o.ctx.common.issues));
      return E(t, {
        code: b.invalid_union,
        unionErrors: a
      }), H;
    }
    if (t.common.async)
      return Promise.all(s.map(async (i) => {
        const a = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: t.data,
            path: t.path,
            parent: a
          }),
          ctx: a
        };
      })).then(n);
    {
      let i;
      const a = [];
      for (const l of s) {
        const u = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        }, c = l._parseSync({
          data: t.data,
          path: t.path,
          parent: u
        });
        if (c.status === "valid")
          return c;
        c.status === "dirty" && !i && (i = { result: c, ctx: u }), u.common.issues.length && a.push(u.common.issues);
      }
      if (i)
        return t.common.issues.push(...i.ctx.common.issues), i.result;
      const o = a.map((l) => new be(l));
      return E(t, {
        code: b.invalid_union,
        unionErrors: o
      }), H;
    }
  }
  get options() {
    return this._def.options;
  }
}
Vt.create = (r, e) => new Vt({
  options: r,
  typeName: q.ZodUnion,
  ...W(e)
});
const De = (r) => r instanceof Dt ? De(r.schema) : r instanceof Le ? De(r.innerType()) : r instanceof $t ? [r.value] : r instanceof Je ? r.options : r instanceof Mt ? te.objectValues(r.enum) : r instanceof Zt ? De(r._def.innerType) : r instanceof Pt ? [void 0] : r instanceof jt ? [null] : r instanceof je ? [void 0, ...De(r.unwrap())] : r instanceof Xe ? [null, ...De(r.unwrap())] : r instanceof ss || r instanceof Ut ? De(r.unwrap()) : r instanceof Bt ? De(r._def.innerType) : [];
class br extends X {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== T.object)
      return E(t, {
        code: b.invalid_type,
        expected: T.object,
        received: t.parsedType
      }), H;
    const s = this.discriminator, n = t.data[s], i = this.optionsMap.get(n);
    return i ? t.common.async ? i._parseAsync({
      data: t.data,
      path: t.path,
      parent: t
    }) : i._parseSync({
      data: t.data,
      path: t.path,
      parent: t
    }) : (E(t, {
      code: b.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [s]
    }), H);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, t, s) {
    const n = /* @__PURE__ */ new Map();
    for (const i of t) {
      const a = De(i.shape[e]);
      if (!a.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const o of a) {
        if (n.has(o))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);
        n.set(o, i);
      }
    }
    return new br({
      typeName: q.ZodDiscriminatedUnion,
      discriminator: e,
      options: t,
      optionsMap: n,
      ...W(s)
    });
  }
}
function Kr(r, e) {
  const t = $e(r), s = $e(e);
  if (r === e)
    return { valid: !0, data: r };
  if (t === T.object && s === T.object) {
    const n = te.objectKeys(e), i = te.objectKeys(r).filter((o) => n.indexOf(o) !== -1), a = { ...r, ...e };
    for (const o of i) {
      const l = Kr(r[o], e[o]);
      if (!l.valid)
        return { valid: !1 };
      a[o] = l.data;
    }
    return { valid: !0, data: a };
  } else if (t === T.array && s === T.array) {
    if (r.length !== e.length)
      return { valid: !1 };
    const n = [];
    for (let i = 0; i < r.length; i++) {
      const a = r[i], o = e[i], l = Kr(a, o);
      if (!l.valid)
        return { valid: !1 };
      n.push(l.data);
    }
    return { valid: !0, data: n };
  } else
    return t === T.date && s === T.date && +r == +e ? { valid: !0, data: r } : { valid: !1 };
}
class Ft extends X {
  _parse(e) {
    const { status: t, ctx: s } = this._processInputParams(e), n = (i, a) => {
      if (Hr(i) || Hr(a))
        return H;
      const o = Kr(i.value, a.value);
      return o.valid ? ((zr(i) || zr(a)) && t.dirty(), { status: t.value, value: o.data }) : (E(s, {
        code: b.invalid_intersection_types
      }), H);
    };
    return s.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: s.data,
        path: s.path,
        parent: s
      }),
      this._def.right._parseAsync({
        data: s.data,
        path: s.path,
        parent: s
      })
    ]).then(([i, a]) => n(i, a)) : n(this._def.left._parseSync({
      data: s.data,
      path: s.path,
      parent: s
    }), this._def.right._parseSync({
      data: s.data,
      path: s.path,
      parent: s
    }));
  }
}
Ft.create = (r, e, t) => new Ft({
  left: r,
  right: e,
  typeName: q.ZodIntersection,
  ...W(t)
});
class Fe extends X {
  _parse(e) {
    const { status: t, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== T.array)
      return E(s, {
        code: b.invalid_type,
        expected: T.array,
        received: s.parsedType
      }), H;
    if (s.data.length < this._def.items.length)
      return E(s, {
        code: b.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), H;
    !this._def.rest && s.data.length > this._def.items.length && (E(s, {
      code: b.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), t.dirty());
    const i = [...s.data].map((a, o) => {
      const l = this._def.items[o] || this._def.rest;
      return l ? l._parse(new Ve(s, a, s.path, o)) : null;
    }).filter((a) => !!a);
    return s.common.async ? Promise.all(i).then((a) => he.mergeArray(t, a)) : he.mergeArray(t, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new Fe({
      ...this._def,
      rest: e
    });
  }
}
Fe.create = (r, e) => {
  if (!Array.isArray(r))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Fe({
    items: r,
    typeName: q.ZodTuple,
    rest: null,
    ...W(e)
  });
};
class It extends X {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== T.object)
      return E(s, {
        code: b.invalid_type,
        expected: T.object,
        received: s.parsedType
      }), H;
    const n = [], i = this._def.keyType, a = this._def.valueType;
    for (const o in s.data)
      n.push({
        key: i._parse(new Ve(s, o, s.path, o)),
        value: a._parse(new Ve(s, s.data[o], s.path, o)),
        alwaysSet: o in s.data
      });
    return s.common.async ? he.mergeObjectAsync(t, n) : he.mergeObjectSync(t, n);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, t, s) {
    return t instanceof X ? new It({
      keyType: e,
      valueType: t,
      typeName: q.ZodRecord,
      ...W(s)
    }) : new It({
      keyType: Oe.create(),
      valueType: e,
      typeName: q.ZodRecord,
      ...W(t)
    });
  }
}
class hr extends X {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== T.map)
      return E(s, {
        code: b.invalid_type,
        expected: T.map,
        received: s.parsedType
      }), H;
    const n = this._def.keyType, i = this._def.valueType, a = [...s.data.entries()].map(([o, l], u) => ({
      key: n._parse(new Ve(s, o, s.path, [u, "key"])),
      value: i._parse(new Ve(s, l, s.path, [u, "value"]))
    }));
    if (s.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of a) {
          const u = await l.key, c = await l.value;
          if (u.status === "aborted" || c.status === "aborted")
            return H;
          (u.status === "dirty" || c.status === "dirty") && t.dirty(), o.set(u.value, c.value);
        }
        return { status: t.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const l of a) {
        const u = l.key, c = l.value;
        if (u.status === "aborted" || c.status === "aborted")
          return H;
        (u.status === "dirty" || c.status === "dirty") && t.dirty(), o.set(u.value, c.value);
      }
      return { status: t.value, value: o };
    }
  }
}
hr.create = (r, e, t) => new hr({
  valueType: e,
  keyType: r,
  typeName: q.ZodMap,
  ...W(t)
});
class it extends X {
  _parse(e) {
    const { status: t, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== T.set)
      return E(s, {
        code: b.invalid_type,
        expected: T.set,
        received: s.parsedType
      }), H;
    const n = this._def;
    n.minSize !== null && s.data.size < n.minSize.value && (E(s, {
      code: b.too_small,
      minimum: n.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: n.minSize.message
    }), t.dirty()), n.maxSize !== null && s.data.size > n.maxSize.value && (E(s, {
      code: b.too_big,
      maximum: n.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: n.maxSize.message
    }), t.dirty());
    const i = this._def.valueType;
    function a(l) {
      const u = /* @__PURE__ */ new Set();
      for (const c of l) {
        if (c.status === "aborted")
          return H;
        c.status === "dirty" && t.dirty(), u.add(c.value);
      }
      return { status: t.value, value: u };
    }
    const o = [...s.data.values()].map((l, u) => i._parse(new Ve(s, l, s.path, u)));
    return s.common.async ? Promise.all(o).then((l) => a(l)) : a(o);
  }
  min(e, t) {
    return new it({
      ...this._def,
      minSize: { value: e, message: F.toString(t) }
    });
  }
  max(e, t) {
    return new it({
      ...this._def,
      maxSize: { value: e, message: F.toString(t) }
    });
  }
  size(e, t) {
    return this.min(e, t).max(e, t);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
it.create = (r, e) => new it({
  valueType: r,
  minSize: null,
  maxSize: null,
  typeName: q.ZodSet,
  ...W(e)
});
class ft extends X {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== T.function)
      return E(t, {
        code: b.invalid_type,
        expected: T.function,
        received: t.parsedType
      }), H;
    function s(o, l) {
      return ur({
        data: o,
        path: t.path,
        errorMaps: [
          t.common.contextualErrorMap,
          t.schemaErrorMap,
          lr(),
          gt
        ].filter((u) => !!u),
        issueData: {
          code: b.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function n(o, l) {
      return ur({
        data: o,
        path: t.path,
        errorMaps: [
          t.common.contextualErrorMap,
          t.schemaErrorMap,
          lr(),
          gt
        ].filter((u) => !!u),
        issueData: {
          code: b.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const i = { errorMap: t.common.contextualErrorMap }, a = t.data;
    if (this._def.returns instanceof yt) {
      const o = this;
      return ge(async function(...l) {
        const u = new be([]), c = await o._def.args.parseAsync(l, i).catch((v) => {
          throw u.addIssue(s(l, v)), u;
        }), f = await Reflect.apply(a, this, c);
        return await o._def.returns._def.type.parseAsync(f, i).catch((v) => {
          throw u.addIssue(n(f, v)), u;
        });
      });
    } else {
      const o = this;
      return ge(function(...l) {
        const u = o._def.args.safeParse(l, i);
        if (!u.success)
          throw new be([s(l, u.error)]);
        const c = Reflect.apply(a, this, u.data), f = o._def.returns.safeParse(c, i);
        if (!f.success)
          throw new be([n(c, f.error)]);
        return f.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new ft({
      ...this._def,
      args: Fe.create(e).rest(et.create())
    });
  }
  returns(e) {
    return new ft({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, t, s) {
    return new ft({
      args: e || Fe.create([]).rest(et.create()),
      returns: t || et.create(),
      typeName: q.ZodFunction,
      ...W(s)
    });
  }
}
class Dt extends X {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    return this._def.getter()._parse({ data: t.data, path: t.path, parent: t });
  }
}
Dt.create = (r, e) => new Dt({
  getter: r,
  typeName: q.ZodLazy,
  ...W(e)
});
class $t extends X {
  _parse(e) {
    if (e.data !== this._def.value) {
      const t = this._getOrReturnCtx(e);
      return E(t, {
        received: t.data,
        code: b.invalid_literal,
        expected: this._def.value
      }), H;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
$t.create = (r, e) => new $t({
  value: r,
  typeName: q.ZodLiteral,
  ...W(e)
});
function An(r, e) {
  return new Je({
    values: r,
    typeName: q.ZodEnum,
    ...W(e)
  });
}
class Je extends X {
  constructor() {
    super(...arguments), Ct.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const t = this._getOrReturnCtx(e), s = this._def.values;
      return E(t, {
        expected: te.joinValues(s),
        received: t.parsedType,
        code: b.invalid_type
      }), H;
    }
    if (cr(this, Ct) || kn(this, Ct, new Set(this._def.values)), !cr(this, Ct).has(e.data)) {
      const t = this._getOrReturnCtx(e), s = this._def.values;
      return E(t, {
        received: t.data,
        code: b.invalid_enum_value,
        options: s
      }), H;
    }
    return ge(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Values() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  extract(e, t = this._def) {
    return Je.create(e, {
      ...this._def,
      ...t
    });
  }
  exclude(e, t = this._def) {
    return Je.create(this.options.filter((s) => !e.includes(s)), {
      ...this._def,
      ...t
    });
  }
}
Ct = /* @__PURE__ */ new WeakMap();
Je.create = An;
class Mt extends X {
  constructor() {
    super(...arguments), wt.set(this, void 0);
  }
  _parse(e) {
    const t = te.getValidEnumValues(this._def.values), s = this._getOrReturnCtx(e);
    if (s.parsedType !== T.string && s.parsedType !== T.number) {
      const n = te.objectValues(t);
      return E(s, {
        expected: te.joinValues(n),
        received: s.parsedType,
        code: b.invalid_type
      }), H;
    }
    if (cr(this, wt) || kn(this, wt, new Set(te.getValidEnumValues(this._def.values))), !cr(this, wt).has(e.data)) {
      const n = te.objectValues(t);
      return E(s, {
        received: s.data,
        code: b.invalid_enum_value,
        options: n
      }), H;
    }
    return ge(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
wt = /* @__PURE__ */ new WeakMap();
Mt.create = (r, e) => new Mt({
  values: r,
  typeName: q.ZodNativeEnum,
  ...W(e)
});
class yt extends X {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== T.promise && t.common.async === !1)
      return E(t, {
        code: b.invalid_type,
        expected: T.promise,
        received: t.parsedType
      }), H;
    const s = t.parsedType === T.promise ? t.data : Promise.resolve(t.data);
    return ge(s.then((n) => this._def.type.parseAsync(n, {
      path: t.path,
      errorMap: t.common.contextualErrorMap
    })));
  }
}
yt.create = (r, e) => new yt({
  type: r,
  typeName: q.ZodPromise,
  ...W(e)
});
class Le extends X {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === q.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: t, ctx: s } = this._processInputParams(e), n = this._def.effect || null, i = {
      addIssue: (a) => {
        E(s, a), a.fatal ? t.abort() : t.dirty();
      },
      get path() {
        return s.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), n.type === "preprocess") {
      const a = n.transform(s.data, i);
      if (s.common.async)
        return Promise.resolve(a).then(async (o) => {
          if (t.value === "aborted")
            return H;
          const l = await this._def.schema._parseAsync({
            data: o,
            path: s.path,
            parent: s
          });
          return l.status === "aborted" ? H : l.status === "dirty" || t.value === "dirty" ? dt(l.value) : l;
        });
      {
        if (t.value === "aborted")
          return H;
        const o = this._def.schema._parseSync({
          data: a,
          path: s.path,
          parent: s
        });
        return o.status === "aborted" ? H : o.status === "dirty" || t.value === "dirty" ? dt(o.value) : o;
      }
    }
    if (n.type === "refinement") {
      const a = (o) => {
        const l = n.refinement(o, i);
        if (s.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (s.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: s.data,
          path: s.path,
          parent: s
        });
        return o.status === "aborted" ? H : (o.status === "dirty" && t.dirty(), a(o.value), { status: t.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: s.data, path: s.path, parent: s }).then((o) => o.status === "aborted" ? H : (o.status === "dirty" && t.dirty(), a(o.value).then(() => ({ status: t.value, value: o.value }))));
    }
    if (n.type === "transform")
      if (s.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: s.data,
          path: s.path,
          parent: s
        });
        if (!st(a))
          return a;
        const o = n.transform(a.value, i);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: t.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: s.data, path: s.path, parent: s }).then((a) => st(a) ? Promise.resolve(n.transform(a.value, i)).then((o) => ({ status: t.value, value: o })) : a);
    te.assertNever(n);
  }
}
Le.create = (r, e, t) => new Le({
  schema: r,
  typeName: q.ZodEffects,
  effect: e,
  ...W(t)
});
Le.createWithPreprocess = (r, e, t) => new Le({
  schema: e,
  effect: { type: "preprocess", transform: r },
  typeName: q.ZodEffects,
  ...W(t)
});
class je extends X {
  _parse(e) {
    return this._getType(e) === T.undefined ? ge(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
je.create = (r, e) => new je({
  innerType: r,
  typeName: q.ZodOptional,
  ...W(e)
});
class Xe extends X {
  _parse(e) {
    return this._getType(e) === T.null ? ge(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Xe.create = (r, e) => new Xe({
  innerType: r,
  typeName: q.ZodNullable,
  ...W(e)
});
class Zt extends X {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    let s = t.data;
    return t.parsedType === T.undefined && (s = this._def.defaultValue()), this._def.innerType._parse({
      data: s,
      path: t.path,
      parent: t
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Zt.create = (r, e) => new Zt({
  innerType: r,
  typeName: q.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...W(e)
});
class Bt extends X {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), s = {
      ...t,
      common: {
        ...t.common,
        issues: []
      }
    }, n = this._def.innerType._parse({
      data: s.data,
      path: s.path,
      parent: {
        ...s
      }
    });
    return Nt(n) ? n.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new be(s.common.issues);
        },
        input: s.data
      })
    })) : {
      status: "valid",
      value: n.status === "valid" ? n.value : this._def.catchValue({
        get error() {
          return new be(s.common.issues);
        },
        input: s.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Bt.create = (r, e) => new Bt({
  innerType: r,
  typeName: q.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...W(e)
});
class pr extends X {
  _parse(e) {
    if (this._getType(e) !== T.nan) {
      const s = this._getOrReturnCtx(e);
      return E(s, {
        code: b.invalid_type,
        expected: T.nan,
        received: s.parsedType
      }), H;
    }
    return { status: "valid", value: e.data };
  }
}
pr.create = (r) => new pr({
  typeName: q.ZodNaN,
  ...W(r)
});
const bl = Symbol("zod_brand");
class ss extends X {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), s = t.data;
    return this._def.type._parse({
      data: s,
      path: t.path,
      parent: t
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class zt extends X {
  _parse(e) {
    const { status: t, ctx: s } = this._processInputParams(e);
    if (s.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: s.data,
          path: s.path,
          parent: s
        });
        return i.status === "aborted" ? H : i.status === "dirty" ? (t.dirty(), dt(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: s.path,
          parent: s
        });
      })();
    {
      const n = this._def.in._parseSync({
        data: s.data,
        path: s.path,
        parent: s
      });
      return n.status === "aborted" ? H : n.status === "dirty" ? (t.dirty(), {
        status: "dirty",
        value: n.value
      }) : this._def.out._parseSync({
        data: n.value,
        path: s.path,
        parent: s
      });
    }
  }
  static create(e, t) {
    return new zt({
      in: e,
      out: t,
      typeName: q.ZodPipeline
    });
  }
}
class Ut extends X {
  _parse(e) {
    const t = this._def.innerType._parse(e), s = (n) => (st(n) && (n.value = Object.freeze(n.value)), n);
    return Nt(t) ? t.then((n) => s(n)) : s(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ut.create = (r, e) => new Ut({
  innerType: r,
  typeName: q.ZodReadonly,
  ...W(e)
});
function Tn(r, e = {}, t) {
  return r ? mt.create().superRefine((s, n) => {
    var i, a;
    if (!r(s)) {
      const o = typeof e == "function" ? e(s) : typeof e == "string" ? { message: e } : e, l = (a = (i = o.fatal) !== null && i !== void 0 ? i : t) !== null && a !== void 0 ? a : !0, u = typeof o == "string" ? { message: o } : o;
      n.addIssue({ code: "custom", ...u, fatal: l });
    }
  }) : mt.create();
}
const _l = {
  object: ie.lazycreate
};
var q;
(function(r) {
  r.ZodString = "ZodString", r.ZodNumber = "ZodNumber", r.ZodNaN = "ZodNaN", r.ZodBigInt = "ZodBigInt", r.ZodBoolean = "ZodBoolean", r.ZodDate = "ZodDate", r.ZodSymbol = "ZodSymbol", r.ZodUndefined = "ZodUndefined", r.ZodNull = "ZodNull", r.ZodAny = "ZodAny", r.ZodUnknown = "ZodUnknown", r.ZodNever = "ZodNever", r.ZodVoid = "ZodVoid", r.ZodArray = "ZodArray", r.ZodObject = "ZodObject", r.ZodUnion = "ZodUnion", r.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", r.ZodIntersection = "ZodIntersection", r.ZodTuple = "ZodTuple", r.ZodRecord = "ZodRecord", r.ZodMap = "ZodMap", r.ZodSet = "ZodSet", r.ZodFunction = "ZodFunction", r.ZodLazy = "ZodLazy", r.ZodLiteral = "ZodLiteral", r.ZodEnum = "ZodEnum", r.ZodEffects = "ZodEffects", r.ZodNativeEnum = "ZodNativeEnum", r.ZodOptional = "ZodOptional", r.ZodNullable = "ZodNullable", r.ZodDefault = "ZodDefault", r.ZodCatch = "ZodCatch", r.ZodPromise = "ZodPromise", r.ZodBranded = "ZodBranded", r.ZodPipeline = "ZodPipeline", r.ZodReadonly = "ZodReadonly";
})(q || (q = {}));
const xl = (r, e = {
  message: `Input not instance of ${r.name}`
}) => Tn((t) => t instanceof r, e), Nn = Oe.create, Rn = Ke.create, Cl = pr.create, wl = We.create, Pn = Rt.create, Sl = nt.create, kl = dr.create, Ol = Pt.create, El = jt.create, Ll = mt.create, Al = et.create, Tl = Ze.create, Nl = fr.create, Rl = Ee.create, Pl = ie.create, jl = ie.strictCreate, Vl = Vt.create, Fl = br.create, Il = Ft.create, Dl = Fe.create, $l = It.create, Ml = hr.create, Zl = it.create, Bl = ft.create, Ul = Dt.create, ql = $t.create, Hl = Je.create, zl = Mt.create, Kl = yt.create, qs = Le.create, Wl = je.create, Jl = Xe.create, Xl = Le.createWithPreprocess, Gl = zt.create, Yl = () => Nn().optional(), Ql = () => Rn().optional(), eu = () => Pn().optional(), tu = {
  string: (r) => Oe.create({ ...r, coerce: !0 }),
  number: (r) => Ke.create({ ...r, coerce: !0 }),
  boolean: (r) => Rt.create({
    ...r,
    coerce: !0
  }),
  bigint: (r) => We.create({ ...r, coerce: !0 }),
  date: (r) => nt.create({ ...r, coerce: !0 })
}, ru = H;
var tt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: gt,
  setErrorMap: Xo,
  getErrorMap: lr,
  makeIssue: ur,
  EMPTY_PATH: Go,
  addIssueToContext: E,
  ParseStatus: he,
  INVALID: H,
  DIRTY: dt,
  OK: ge,
  isAborted: Hr,
  isDirty: zr,
  isValid: st,
  isAsync: Nt,
  get util() {
    return te;
  },
  get objectUtil() {
    return qr;
  },
  ZodParsedType: T,
  getParsedType: $e,
  ZodType: X,
  datetimeRegex: Ln,
  ZodString: Oe,
  ZodNumber: Ke,
  ZodBigInt: We,
  ZodBoolean: Rt,
  ZodDate: nt,
  ZodSymbol: dr,
  ZodUndefined: Pt,
  ZodNull: jt,
  ZodAny: mt,
  ZodUnknown: et,
  ZodNever: Ze,
  ZodVoid: fr,
  ZodArray: Ee,
  ZodObject: ie,
  ZodUnion: Vt,
  ZodDiscriminatedUnion: br,
  ZodIntersection: Ft,
  ZodTuple: Fe,
  ZodRecord: It,
  ZodMap: hr,
  ZodSet: it,
  ZodFunction: ft,
  ZodLazy: Dt,
  ZodLiteral: $t,
  ZodEnum: Je,
  ZodNativeEnum: Mt,
  ZodPromise: yt,
  ZodEffects: Le,
  ZodTransformer: Le,
  ZodOptional: je,
  ZodNullable: Xe,
  ZodDefault: Zt,
  ZodCatch: Bt,
  ZodNaN: pr,
  BRAND: bl,
  ZodBranded: ss,
  ZodPipeline: zt,
  ZodReadonly: Ut,
  custom: Tn,
  Schema: X,
  ZodSchema: X,
  late: _l,
  get ZodFirstPartyTypeKind() {
    return q;
  },
  coerce: tu,
  any: Ll,
  array: Rl,
  bigint: wl,
  boolean: Pn,
  date: Sl,
  discriminatedUnion: Fl,
  effect: qs,
  enum: Hl,
  function: Bl,
  instanceof: xl,
  intersection: Il,
  lazy: Ul,
  literal: ql,
  map: Ml,
  nan: Cl,
  nativeEnum: zl,
  never: Tl,
  null: El,
  nullable: Jl,
  number: Rn,
  object: Pl,
  oboolean: eu,
  onumber: Ql,
  optional: Wl,
  ostring: Yl,
  pipeline: Gl,
  preprocess: Xl,
  promise: Kl,
  record: $l,
  set: Zl,
  strictObject: jl,
  string: Nn,
  symbol: kl,
  transformer: qs,
  tuple: Dl,
  undefined: Ol,
  union: Vl,
  unknown: Al,
  void: Nl,
  NEVER: ru,
  ZodIssueCode: b,
  quotelessJson: Jo,
  ZodError: be
});
const Hs = (r, e, t) => {
  if (r && "reportValidity" in r) {
    const s = N(t, e);
    r.setCustomValidity(s && s.message || ""), r.reportValidity();
  }
}, jn = (r, e) => {
  for (const t in e.fields) {
    const s = e.fields[t];
    s && s.ref && "reportValidity" in s.ref ? Hs(s.ref, t, r) : s.refs && s.refs.forEach((n) => Hs(n, t, r));
  }
}, su = (r, e) => {
  e.shouldUseNativeValidation && jn(r, e);
  const t = {};
  for (const s in r) {
    const n = N(e.fields, s), i = Object.assign(r[s] || {}, { ref: n && n.ref });
    if (nu(e.names || Object.keys(r), s)) {
      const a = Object.assign({}, N(t, s));
      ne(a, "root", i), ne(t, s, a);
    } else
      ne(t, s, i);
  }
  return t;
}, nu = (r, e) => r.some((t) => t.startsWith(e + "."));
var iu = function(r, e) {
  for (var t = {}; r.length; ) {
    var s = r[0], n = s.code, i = s.message, a = s.path.join(".");
    if (!t[a])
      if ("unionErrors" in s) {
        var o = s.unionErrors[0].errors[0];
        t[a] = { message: o.message, type: o.code };
      } else
        t[a] = { message: i, type: n };
    if ("unionErrors" in s && s.unionErrors.forEach(function(c) {
      return c.errors.forEach(function(f) {
        return r.push(f);
      });
    }), e) {
      var l = t[a].types, u = l && l[s.code];
      t[a] = yn(a, e, t, n, u ? [].concat(u, s.message) : s.message);
    }
    r.shift();
  }
  return t;
}, au = function(r, e, t) {
  return t === void 0 && (t = {}), function(s, n, i) {
    try {
      return Promise.resolve(function(a, o) {
        try {
          var l = Promise.resolve(r[t.mode === "sync" ? "parse" : "parseAsync"](s, e)).then(function(u) {
            return i.shouldUseNativeValidation && jn({}, i), { errors: {}, values: t.raw ? s : u };
          });
        } catch (u) {
          return o(u);
        }
        return l && l.then ? l.then(void 0, o) : l;
      }(0, function(a) {
        if (function(o) {
          return Array.isArray(o == null ? void 0 : o.errors);
        }(a))
          return { values: {}, errors: su(iu(a.errors, !i.shouldUseNativeValidation && i.criteriaMode === "all"), i) };
        throw a;
      }));
    } catch (a) {
      return Promise.reject(a);
    }
  };
};
const ou = "_form_b8oxs_1", lu = "_body_b8oxs_7", uu = "_isPreview_b8oxs_18", cu = "_policyCheckbox_b8oxs_23", du = "_fieldset_b8oxs_29", fu = "_field_b8oxs_29", hu = "_isShort_b8oxs_39", pu = "_footer_b8oxs_43", gu = "_nonSticky_b8oxs_54", mu = "_footerActions_b8oxs_59", yu = "_backButton_b8oxs_64", vu = "_proceedButton_b8oxs_68", ye = {
  form: ou,
  body: lu,
  isPreview: uu,
  policyCheckbox: cu,
  fieldset: du,
  field: fu,
  isShort: hu,
  footer: pu,
  nonSticky: gu,
  footerActions: mu,
  backButton: yu,
  proceedButton: vu
}, bu = (r) => r.filter((e) => !e.fields.every((t) => t.hidden)).length, zs = (r, e) => `group-${r}.${e}`, _u = (r) => r.name === "email" ? {
  setValueAs: (e) => e.trim()
} : {}, xu = (r) => {
  let e = tt.string().email({
    message: "form.validation.is_email"
  });
  if (r.required)
    e = e.min(1, { message: "form.validation.required" });
  else
    return tt.union([tt.literal(""), e]);
  return e;
}, Cu = (r) => {
  const e = r.reduce((t, s) => {
    if (s.hidden)
      return t;
    if (s.name === "email")
      return t[s.name] = xu(s), t;
    let n = tt.string();
    return s.required && (n = n.min(1, "form.validation.required")), t[s.name] = n, t;
  }, {});
  return tt.object(e);
}, wu = (r) => {
  const e = r.reduce((t, s, n) => (t[`group-${n}`] = Cu(s.fields), t), {});
  return e.privacyConditions = tt.boolean().refine((t) => t, {
    message: "form.request-quote.accept-conditions.validation"
  }), tt.object(e);
}, Su = ({
  schema: r,
  onSubmit: e,
  shouldAutoFocus: t = !0,
  mode: s = "default"
}) => {
  const n = s === "preview", i = Wr(null), { t: a } = gr("translation"), [o, l] = Js(0), u = Fr(() => (r == null ? void 0 : r.configuration.fieldGroups.filter((P) => P.fields.some((O) => !O.hidden))) ?? [], [r]), c = bu(u), f = Math.min(o, Math.max(0, c - 1)), p = Fr(() => wu(u), [u]), {
    register: v,
    handleSubmit: x,
    setFocus: C,
    formState: { errors: L },
    trigger: V
  } = Wo({
    mode: "onTouched",
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    resolver: n ? void 0 : au(p)
  }), k = Vr(async () => {
    !n && !await V(`group-${f}`, { shouldFocus: !0 }) || l((P) => P + 1);
  }, [f, n, V]), U = Vr(() => {
    l((P) => P - 1);
  }, []);
  Et(() => {
    if (!(u.length === 0 || !i.current) && t) {
      const P = i.current.querySelector(
        `input[name="${zs(f, u[f].fields[0].name)}"]`
      );
      P == null || P.focus({ preventScroll: !0 });
    }
  }, [f, u, C, t]);
  const D = f + 1 === c, Z = f === 0;
  return /* @__PURE__ */ we(
    "form",
    {
      ref: i,
      onSubmit: x(async (P) => {
        const O = Object.values(P).reduce(($, J) => (typeof J == "object" && ($ = Object.assign($, J)), $), {});
        await e(O);
      }),
      name: "contact-us",
      className: de(ye.form),
      children: [
        /* @__PURE__ */ re(
          "div",
          {
            className: de(ye.body, { [ye.isPreview]: n }),
            inert: n ? "" : void 0,
            children: u == null ? void 0 : u.map((P, O) => /* @__PURE__ */ re("fieldset", { className: ye.fieldset, hidden: f !== O, children: P.fields.filter(($) => !$.hidden).map(($, J) => {
              const Q = L[`group-${O}`], se = $.inputElementType === "textarea" ? Lo : Oo;
              return /* @__PURE__ */ Me(
                se,
                {
                  ...v(zs(O, $.name), _u($)),
                  label: a(`form.request-quote.label.${$.name}`),
                  key: J,
                  required: $.required,
                  error: Q && Q[$.name],
                  className: de(ye.field, { [ye.isShort]: $.short }),
                  withValidation: !0,
                  maxLength: $.inputElementType === "textarea" ? void 0 : 255
                }
              );
            }) }, O))
          }
        ),
        /* @__PURE__ */ we("div", { className: de(ye.footer, { [ye.nonSticky]: n }), children: [
          D && /* @__PURE__ */ re(
            xo,
            {
              ...v("privacyConditions"),
              error: L.privacyConditions,
              noErrorPlaceholder: !0,
              className: de(ye.policyCheckbox, { [ye.isPreview]: n }),
              label: /* @__PURE__ */ re(ht, { variant: "hint", component: "div", children: /* @__PURE__ */ re(
                Qi,
                {
                  i18nKey: "form.request-quote.accept-conditions.text",
                  components: {
                    1: /* @__PURE__ */ re("a", { href: r == null ? void 0 : r.configuration.privacyConditionsLink, target: "_blank", rel: "noopener noreferrer" })
                  }
                }
              ) })
            }
          ),
          /* @__PURE__ */ we("div", { className: ye.footerActions, children: [
            !Z && /* @__PURE__ */ re(kr, { className: ye.backButton, variant: "secondary", iconStart: "arrow", onClick: U }),
            D && /* @__PURE__ */ re(kr, { variant: "primary", className: ye.proceedButton, children: a("form.request-quote.submitButton") }),
            !D && /* @__PURE__ */ re(kr, { type: "button", onClick: k, variant: "primary", className: ye.proceedButton, children: a("buttons.next") })
          ] })
        ] })
      ]
    }
  );
}, Tu = yr(Su), Nu = ({ path: r }) => {
  Et(() => (e(r), () => {
    t(r);
  }), [r]);
  const e = async (s) => {
    if (!s)
      return;
    const n = document.createElement("link");
    n.onload = () => {
      setTimeout(() => window.dispatchEvent(new Event("resize")), 100);
    }, n.setAttribute("rel", "stylesheet"), n.setAttribute("href", s), document.head.appendChild(n);
  }, t = (s) => {
    if (!s)
      return;
    const n = document.querySelector(`link[href='${s}']`);
    if (!n) {
      console.warn("Unable to perform theme cleanup");
      return;
    }
    document.head.removeChild(n);
  };
  return null;
};
export {
  kr as Button,
  xo as Checkbox,
  Yr as FormFieldError,
  bi as Icon,
  Oo as Input,
  lo as LOCALE_STORAGE_KEY,
  Tu as RequestQuoteForm,
  Lo as TextArea,
  Nu as Theme,
  ht as Typography,
  xu as getEmailSchema,
  uo as i18next,
  _i as isIconType
};
